import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { countries } from 'config/config'; // Importing countries configuration
import { profile } from 'config/config'; // Importing profile configuration
import { devConfig, accountingAccounts, providersSMS, providersEmail, providerPaymentWithdrawal } from 'config/config'; // Importing various configurations
/**
 * Class representing the FilterAgentListView.
 * @extends JetView
 */

// Flag to prevent loyalty validations from running during form.setValues()
var loadingPartnerSettings = false;
export default class FilterAgentListView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service
        const _ = this.app.getService('locale')._;
        // Get the screen size configuration
        const screen = this.app.config.size;
        let partnerCountry; // Variable to hold the partner's country
        const id_partner = this.getParam('partner', true); // Get the partner ID parameter

        /**
         * Loyalty points validations
         **/

        const loyaltyRules = {
            ValidationsCasino: {
                inputs: ['LoyaltyBaseValue', 'LoyaltyExpirationDate', 'LoyaltyBetCasino'],
                msg: 'Para activar Casino, los campos deben ser mayores que 0: Puntos Base, Días de expiración y Apuestas de casino.',
            },
            ValidationsLiveCasino: {
                inputs: ['LoyaltyBaseValue', 'LoyaltyExpirationDate', 'LoyaltyBetCasinoLive'],
                msg: 'Para activar LiveCasino, los campos deben ser mayores que 0: Puntos Base, Días de expiración y Apuestas casino en vivo.',
            },
            ValidationsVirtuals: {
                inputs: ['LoyaltyBaseValue', 'LoyaltyExpirationDate', 'LoyaltyBetVirtuals'],
                msg: 'Para activar Virtuals, los campos deben ser mayores que 0: Puntos Base, Días de expiración y Apuestas virtuales.',
            },
            ValidationsSportbook: {
                inputs: [
                    'LoyaltyBaseValue',
                    'LoyaltyExpirationDate',
                    'LoyaltyBettingSportsSimple',
                    'LoyaltyBettingSportsCombinedTwo',
                    'LoyaltyBettingSportsCombinedThree',
                    'LoyaltyBettingSportsCombinedFour',
                    'LoyaltyBettingSportsCombinedFive',
                    'LoyaltyBettingSportsCombinedSix',
                    'LoyaltyBettingSportsCombinedSeven',
                    'LoyaltyBettingSportsCombinedEight',
                    'LoyaltyBettingSportsCombinedNine',
                    'LoyaltyBettingSportsCombinedTen',
                ],
                msg: 'Para activar Sportbook, los campos deben ser mayores que 0: Puntos Base, Días de expiración y todas las apuestas deportivas (simple y combinadas).',
            },
        };
        // validate if the input exists and convert the ‘string’ to a 'number'
        function convertToNum(inputId) {
            var inputValue = $$(inputId);
            if (!inputValue) return 0;
            return parseFloat(inputValue.getValue()) || 0;
        }
        // validate input values are greater than zero
        function canEnableValidationSwitch(switchId) {
            var rule = loyaltyRules[switchId];
            if (!rule) return true;
            return rule.inputs.every(function (id) {
                return convertToNum(id) > 0;
            });
        }

        // Enforces that a validation switch cannot stay "Activo" if required inputs are 0.
        // NOTE: We do not disable the switch; we only revert value to 0 when invalid.
        function validationsLoyaltyFields(opts) {
            opts = opts || {};

            Object.keys(loyaltyRules).forEach(function (switchId) {
                var switchRef = $$(switchId);
                if (!switchRef) return;

                var canEdit = canEnableValidationSwitch(switchId);

                if (!canEdit && opts.enforce && switchRef.getValue && switchRef.getValue() === 1) {
                    switchRef.setValue(0);
                    if (!opts.silent) webix.message({ type: 'error', text: loyaltyRules[switchId].msg });
                }
            });
        }
        //Modify 'input' style if some fields do not meet validation requirements
        function modifyInputStyle(newv, ref) {
            var isInvalid = newv === '' || parseFloat(newv) <= 0;
            var field = $$(ref);
            var form = field.getFormView();
            var btn = $$('btnSavePartnerSettings');
            if (isInvalid) {
                webix.message({ type: 'error', text: _('Debe ingresar un valor mayor a cero') });
                form.markInvalid(ref, _('Debe ingresar un valor mayor a cero')); // add red style
                btn.disable();
            } else {
                form.clearValidation(ref); // delete red style
                updateSaveButtonState();
            }
        }
        //Disable the save button if some fields do not meet validation requirements
        function updateSaveButtonState() {
            var inputsId = [
                'LoyaltyBaseValue', 'LoyaltyExpirationDate', 'LoyaltyBetVirtuals',
                'LoyaltyBetCasinoLive', 'LoyaltyBetCasino',
                'LoyaltyBettingSportsSimple', 'LoyaltyBettingSportsCombinedTwo',
                'LoyaltyBettingSportsCombinedThree', 'LoyaltyBettingSportsCombinedFour',
                'LoyaltyBettingSportsCombinedFive', 'LoyaltyBettingSportsCombinedSix',
                'LoyaltyBettingSportsCombinedSeven', 'LoyaltyBettingSportsCombinedEight',
                'LoyaltyBettingSportsCombinedNine', 'LoyaltyBettingSportsCombinedTen'
            ];
            var btn = $$('btnSavePartnerSettings');
            var canSave = true;
            for (var i = 0; i < inputsId.length; i++) {
                var inputInfo = $$(inputsId[i]);
                if (!inputInfo) continue;
                var value = inputInfo.getValue().trim();
                if (value === '' || value === undefined || parseFloat(value) <= 0) {
                    canSave = false;
                    //Prevent other inputs from changing the style if they do not comply with the validations.
                    var field = $$(inputsId[i]);
                    var form = field.getFormView();
                    form.markInvalid(inputsId[i], _('Debe ingresar un valor mayor a cero'));
                }
            }
            if (canSave) btn.enable();
        }

        // Event listener for partner settings filter
        this.on(this.app, 'partnerSettings:filter', (filterdata) => {
            partnerCountry = filterdata; // Update partnerCountry with the filtered data
        });

        // Configuration for the left section of the general form
        const left_general = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'CompanyName',
                    label: "<div class='tittle'>" + _('Nombre Compañía') + '</div>',
                    labelPosition: 'top',
                    placeholder: _('Nombre Compañía'),
                    invalidMessage: _('Campo Requerido'), // Message for invalid input
                },
            ],
        };

        // Configuration for the center-left section of the general form
        const center_left_general = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'Address',
                    label: "<div class='tittle'>" + _('Dirección') + '</div>',
                    labelPosition: 'top',
                    placeholder: _('Dirección'),
                    invalidMessage: _('Campo Requerido'), // Message for invalid input
                },
            ],
        };

        // Configuration for the icon alert section
        const iconalert = {
            rows: [
                {
                    view: 'icon',
                    icon: 'mdi mdi-menu',
                    click: () => this.app.callEvent('menu:toggle'), // Toggle menu on click
                },
            ],
        };

        // Configuration for the center-right section of the general form
        const center_right_general = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'Phone',
                    type: 'number',
                    label: "<div class='tittle'>" + _('Teléfono') + '</div>',
                    labelPosition: 'top',
                    placeholder: _('Teléfono'),
                    invalidMessage: _('Campo Requerido'), // Message for invalid input
                },
            ],
        };

        // Configuration for the right section of the general form
        const right_general = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'Email',
                    label: "<span class='icon-mail'></span>" + _('Email'),
                    labelPosition: 'top',
                    placeholder: _('Email'),
                    invalidMessage: _('Campo Requerido'), // Message for invalid input
                },
            ],
        };

        // Configuration for the second right section of the general form
        const right_general2 = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'CodeMincetur',
                    label: _('CODIGO DE PLATAFORMA DE MINCETUR'),
                    labelPosition: 'top',
                    placeholder: _('Codigo'),
                },
            ],
        };

        // Configuration for the upper section of the general form
        const upper_section_general = {
            id: 'a1',
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [left_general, center_left_general, center_right_general, right_general, right_general2],
                },
            ],
        };

        // Configuration for the left section of the accounting form
        const left_accounting = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'combo',
                    labelPosition: 'top',
                    label: "<div class='tittle'>" + _('Plan cuentas Apuestas Tickets Tiendas') + '</div>',
                    name: 'AccountingAccountsBetsTicketsStores',
                    options: {
                        body: {
                            dataFeed: function (text) {
                                var vthis = this;
                                if (text.length > 2) {
                                    webix
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json',
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'es/Select/AccountsSelect',
                                            '{"Filter":"' + text + '"}',
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message('Error! '); // Error message on AJAX failure
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    var resp = JSON.parse(text);
                                                    if (!resp.HasError) {
                                                        vthis.parse(resp.Data); // Parse and display data if no error
                                                    }
                                                },
                                            },
                                        );
                                }
                            },
                        },
                    },
                },
                {
                    view: 'combo',
                    labelPosition: 'top',
                    label: "<div class='tittle'>" + _('Plan de cuentas Recargas') + '</div>',
                    name: 'AccountingAccountsRecharge',
                    options: {
                        body: {
                            dataFeed: function (text) {
                                var vthis = this;
                                if (text.length > 2) {
                                    webix
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json',
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'es/Select/AccountsSelect',
                                            '{"Filter":"' + text + '"}',
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message('Error! '); // Error message on AJAX failure
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    var resp = JSON.parse(text);
                                                    if (!resp.HasError) {
                                                        vthis.parse(resp.Data); // Parse and display data if no error
                                                    }
                                                },
                                            },
                                        );
                                }
                            },
                        },
                    },
                },
            ],
        };

        // Configuration for the center-left section of the accounting form
        const center_left_accounting = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'combo',
                    labelPosition: 'top',
                    label: "<div class='tittle'>" + _('Plan cuentas Premios Tickets Tiendas') + '</div>',
                    name: 'AccountingAccountsAwardsTicketsStores',
                    options: {
                        body: {
                            dataFeed: function (text) {
                                var vthis = this;
                                if (text.length > 2) {
                                    webix
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json',
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'es/Select/AccountsSelect',
                                            '{"Filter":"' + text + '"}',
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message('Error! '); // Error message on AJAX failure
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    var resp = JSON.parse(text);
                                                    if (!resp.HasError) {
                                                        vthis.parse(resp.Data); // Parse and display data if no error
                                                    }
                                                },
                                            },
                                        );
                                }
                            },
                        },
                    },
                },
            ],
        };

        // Configuration for the center-right section of the accounting form
        const center_right_accounting = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'combo',
                    labelPosition: 'top',
                    label: "<div class='tittle'>" + _('Plan cuentas Pagos notas de retiro') + '</div>',
                    name: 'AccountingAccountsPaymentsWithdrawal',
                    options: {
                        body: {
                            dataFeed: function (text) {
                                var vthis = this;
                                if (text.length > 2) {
                                    webix
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json',
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'es/Select/AccountsSelect',
                                            '{"Filter":"' + text + '"}',
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message('Error! '); // Error message on AJAX failure
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    var resp = JSON.parse(text);
                                                    if (!resp.HasError) {
                                                        vthis.parse(resp.Data); // Parse and display data if no error
                                                    }
                                                },
                                            },
                                        );
                                }
                            },
                        },
                    },
                },
            ],
        };

        const right_accounting = {
            margin: 5,
            minWidth: 200,
            rows: [], // Empty rows for future use
        };

        // Configuration for the upper section of the accounting form
        const upper_section_accounting = {
            id: 'a6',
            rows: [
                {
                    responsive: 'a6',
                    margin: 10,
                    cols: [left_accounting, center_left_accounting, center_right_accounting],
                },
            ],
        };

        const left_configuration_loyalty = {
            margin: 10,
            minWidth: 200,
            rows: [
                {
                    view: 'label',
                    label:
                        "<div class='tittle'>" +
                        _('Puede repetir el canje del mismo regalo cada X tiempo') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _(
                            'El jugador podrá volver a canjear un mismo regalo luego de que haya pasado un cierto tiempo desde el último canje.',
                        ) +
                        '</span></div>',
                },
                {
                    css: 'centrar',
                    id: 'StateSwith18',
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Si'),
                    offLabel: _('No'),
                    on: {
                        onChange: function (newv) {
                            if (newv === 1) {
                                $$('TypeOfTime').show();
                                $$('TimeForExchange').show();
                            } else {
                                $$('TypeOfTime').hide();
                                $$('TimeForExchange').hide();
                            }
                        },
                    },
                },
                {
                    view: 'text',
                    name: 'TimeForExchange',
                    id: 'TimeForExchange',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Tiempo de Espera') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Valor numerico para el tiempo de espera para canjear un mismo regalo') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Tiempo de Espera'),
                    invalidMessage: _(''),
                    required: true,
                    hidden: true,
                },
                {},
                {
                    view: 'combo',
                    name: 'TypeOfTime',
                    id: 'TypeOfTime',
                    labelPosition: 'top',
                    label: "<div class='tittle'>" + _('Unidades de Tiempo') + '</div>',
                    placeholder: _('Unidades de Tiempo'),
                    options: [
                        { id: 'M', value: _('Minutos') },
                        { id: 'H', value: _('Horas') },
                        { id: 'D', value: _('Días') },
                    ],
                    invalidMessage: _(''),
                    required: true,
                    hidden: true,
                },
                {},
            ],
        };

        const center_left_configuration_loyalty = {
            margin: 10,
            minWidth: 200,
            rows: [
                {
                    view: 'label',
                    label:
                        "<div class='tittle'>" +
                        _('Tiempo mínimo entre cualquier canje (campo opcional)') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _(
                            'Define cuánto debe esperar el jugador entre un canje y otro, incluso si son regalos diferentes.',
                        ) +
                        '</span></div>',
                },
                {
                    css: 'centrar',
                    id: 'StateSwith16',
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Si'),
                    offLabel: _('No'),
                    on: {
                        onChange: function (newv) {
                            if (newv === 1) {
                                $$('TypeOfTimeGeneral').show();
                                $$('TimeForExchangeGeneral').show();
                            } else {
                                $$('TypeOfTimeGeneral').hide();
                                $$('TimeForExchangeGeneral').hide();
                            }
                        },
                    },
                },
                {
                    view: 'text',
                    name: 'TimeForExchangeGeneral',
                    id: 'TimeForExchangeGeneral',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Tiempo de Espera') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Valor numerico para el tiempo de espera para canjear un regalo') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Tiempo de Espera'),
                    invalidMessage: _(''),
                    required: true,
                    hidden: true,
                },
                {},
                {
                    view: 'combo',
                    name: 'TypeOfTimeGeneral',
                    id: 'TypeOfTimeGeneral',
                    labelPosition: 'top',
                    label: "<div class='tittle'>" + _('Unidades de Tiempo') + '</div>',
                    placeholder: _('Unidades de Tiempo'),
                    options: [
                        { id: 'M', value: _('Minutos') },
                        { id: 'H', value: _('Horas') },
                        { id: 'D', value: _('Días') },
                    ],
                    invalidMessage: _(''),
                    required: true,
                    hidden: true,
                },
                {},
            ],
        };

        // Configuration for the left section of the register form
        const left_register = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'LimitDepositDayDefault',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Limite depósito día por defecto') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el límite de depósito diario por defecto') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Limite depósito día por defecto'),
                    invalidMessage: _('Campo Requerido'), // Message for invalid input
                },
                {
                    view: 'label',
                    label:
                        "<div class='tittle'>" +
                        _('Tipo de registro') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique tipo de registro si es corto o largo') +
                        '</span></div>',
                },
                {
                    css: 'centrar',
                    id: 'StateSwith8',
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Corto'),
                    offLabel: _('Largo'),
                },
            ],
        };

        // Configuration for the center-left section of the register form
        const center_left_register = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'LimitDepositWeekDefault',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Limite depósito semana por defecto') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el límite de depósito semanal por defecto') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Limite depósito semana por defecto'),
                    invalidMessage: _('Campo Requerido'), // Message for invalid input
                },
                {
                    view: 'label',
                    label:
                        "<div class='tittle'>" +
                        _('Usuario automáticamente activado') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique si el usuario quedara automáticamente activado después del registro') +
                        '</span></div>',
                },
                {
                    css: 'centrar',
                    id: 'StateSwith3',
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'),
                    offLabel: _('Inactivo'),
                },
            ],
        };

        // Configuration for the center-right section of the register form
        const center_right_register = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'LimitDepositMonthDefault',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Limite depósito mes por defecto') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el límite de depósito mensual por defecto') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Limite depósito mes por defecto'),
                    invalidMessage: _('Campo Requerido'), // Message for invalid input
                },
            ],
        };

        // Configuration for the left section of the for comission tax form (base values)
        const left_for_comission_tax = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'TaxSportbookNGRAffiliates',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Sportbook NGR Afiliados') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el numero de tasa de impuesto del Sportbook NGR Afiliados.') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Sportbook NGR Afiliados'),
                    invalidMessage: _('Campo Requerido'), // Message for invalid input
                    attributes: { min: 0, max: 100, step: 1, inputmode: 'numeric' },
                    on: {
                        onAfterRender: function () {
                            this._lastOK = this.getValue() || '';
                        },
                        onBeforePaste: function (text) {
                            // Solo dígitos y máximo 3 caracteres
                            var clean = String(text).replace(/\D+/g, '').slice(0, 3);
                            return clean;
                        },
                        onKeyPress: function (code, e) {
                            // Permite solo dígitos y teclas de control comunes
                            if (
                                (code >= 48 && code <= 57) ||
                                code === 8 ||
                                code === 9 ||
                                code === 13 ||
                                code === 46 ||
                                code === 37 ||
                                code === 39
                            )
                                return true;
                            return false;
                        },
                        onTimedKeyPress: function () {
                            var s = String(this.getValue() || '').replace(/\D+/g, '');
                            if (s === '') {
                                this.setValue('');
                                this._lastOK = '';
                                return;
                            }
                            var n = parseInt(s, 10);
                            if (isNaN(n)) {
                                this.setValue(this._lastOK || '');
                                return;
                            }
                            if (n > 100) n = 100;
                            if (n < 0) n = 0;
                            var str = String(n);
                            if (this.getValue() !== str) this.setValue(str);
                            this._lastOK = str;
                        },
                        onChange: function (newv) {
                            var s = String(newv || '').replace(/\D+/g, '');
                            if (s === '') {
                                this.setValue('');
                                return;
                            }
                            var n = parseInt(s, 10);
                            if (isNaN(n)) {
                                this.setValue(this._lastOK || '');
                                return;
                            }
                            if (n > 100) n = 100;
                            if (n < 0) n = 0;
                            var str = String(n);
                            if (this.getValue() !== str) this.setValue(str);
                            this._lastOK = str;
                        },
                    },
                },
                {
                    view: 'text',
                    name: 'TaxAffiliatedeposit',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Deposito Afiliados') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el numero de tasa de impuesto del Deposito Afiliados') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Deposito Afiliados'),
                    invalidMessage: _('Campo Requerido'), // Message for invalid input
                    attributes: { min: 0, max: 100, step: 1, inputmode: 'numeric' },
                    on: {
                        onAfterRender: function () {
                            this._lastOK = this.getValue() || '';
                        },
                        onBeforePaste: function (text) {
                            // Solo dígitos y máximo 3 caracteres
                            var clean = String(text).replace(/\D+/g, '').slice(0, 3);
                            return clean;
                        },
                        onKeyPress: function (code, e) {
                            // Permite solo dígitos y teclas de control comunes
                            if (
                                (code >= 48 && code <= 57) ||
                                code === 8 ||
                                code === 9 ||
                                code === 13 ||
                                code === 46 ||
                                code === 37 ||
                                code === 39
                            )
                                return true;
                            return false;
                        },
                        onTimedKeyPress: function () {
                            var s = String(this.getValue() || '').replace(/\D+/g, '');
                            if (s === '') {
                                this.setValue('');
                                this._lastOK = '';
                                return;
                            }
                            var n = parseInt(s, 10);
                            if (isNaN(n)) {
                                this.setValue(this._lastOK || '');
                                return;
                            }
                            if (n > 100) n = 100;
                            if (n < 0) n = 0;
                            var str = String(n);
                            if (this.getValue() !== str) this.setValue(str);
                            this._lastOK = str;
                        },
                        onChange: function (newv) {
                            var s = String(newv || '').replace(/\D+/g, '');
                            if (s === '') {
                                this.setValue('');
                                return;
                            }
                            var n = parseInt(s, 10);
                            if (isNaN(n)) {
                                this.setValue(this._lastOK || '');
                                return;
                            }
                            if (n > 100) n = 100;
                            if (n < 0) n = 0;
                            var str = String(n);
                            if (this.getValue() !== str) this.setValue(str);
                            this._lastOK = str;
                        },
                    },
                },
                {
                    view: 'text',
                    name: 'TaxSportbookGGRPointsaleIP',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Sportbook GGR Punto venta IP') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el numero de tasa de impuesto del Sportbook GGR Punto venta IP') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Sportbook GGR Punto venta IP'),
                    invalidMessage: _('Campo Requerido'), // Message for invalid input
                    attributes: { min: 0, max: 100, step: 1, inputmode: 'numeric' },
                    on: {
                        onAfterRender: function () {
                            this._lastOK = this.getValue() || '';
                        },
                        onBeforePaste: function (text) {
                            // Solo dígitos y máximo 3 caracteres
                            var clean = String(text).replace(/\D+/g, '').slice(0, 3);
                            return clean;
                        },
                        onKeyPress: function (code, e) {
                            // Permite solo dígitos y teclas de control comunes
                            if (
                                (code >= 48 && code <= 57) ||
                                code === 8 ||
                                code === 9 ||
                                code === 13 ||
                                code === 46 ||
                                code === 37 ||
                                code === 39
                            )
                                return true;
                            return false;
                        },
                        onTimedKeyPress: function () {
                            var s = String(this.getValue() || '').replace(/\D+/g, '');
                            if (s === '') {
                                this.setValue('');
                                this._lastOK = '';
                                return;
                            }
                            var n = parseInt(s, 10);
                            if (isNaN(n)) {
                                this.setValue(this._lastOK || '');
                                return;
                            }
                            if (n > 100) n = 100;
                            if (n < 0) n = 0;
                            var str = String(n);
                            if (this.getValue() !== str) this.setValue(str);
                            this._lastOK = str;
                        },
                        onChange: function (newv) {
                            var s = String(newv || '').replace(/\D+/g, '');
                            if (s === '') {
                                this.setValue('');
                                return;
                            }
                            var n = parseInt(s, 10);
                            if (isNaN(n)) {
                                this.setValue(this._lastOK || '');
                                return;
                            }
                            if (n > 100) n = 100;
                            if (n < 0) n = 0;
                            var str = String(n);
                            if (this.getValue() !== str) this.setValue(str);
                            this._lastOK = str;
                        },
                    },
                },
                {
                    view: 'text',
                    name: 'TaxSportbookGGRPointsale',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Sportbook GGR Punto venta') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el numero de tasa de impuesto del Sportbook GGR Punto venta') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Sportbook GGR Punto venta'),
                    invalidMessage: _('Campo Requerido'), // Message for invalid input
                    attributes: { min: 0, max: 100, step: 1, inputmode: 'numeric' },
                    on: {
                        onAfterRender: function () {
                            this._lastOK = this.getValue() || '';
                        },
                        onBeforePaste: function (text) {
                            // Solo dígitos y máximo 3 caracteres
                            var clean = String(text).replace(/\D+/g, '').slice(0, 3);
                            return clean;
                        },
                        onKeyPress: function (code, e) {
                            // Permite solo dígitos y teclas de control comunes
                            if (
                                (code >= 48 && code <= 57) ||
                                code === 8 ||
                                code === 9 ||
                                code === 13 ||
                                code === 46 ||
                                code === 37 ||
                                code === 39
                            )
                                return true;
                            return false;
                        },
                        onTimedKeyPress: function () {
                            var s = String(this.getValue() || '').replace(/\D+/g, '');
                            if (s === '') {
                                this.setValue('');
                                this._lastOK = '';
                                return;
                            }
                            var n = parseInt(s, 10);
                            if (isNaN(n)) {
                                this.setValue(this._lastOK || '');
                                return;
                            }
                            if (n > 100) n = 100;
                            if (n < 0) n = 0;
                            var str = String(n);
                            if (this.getValue() !== str) this.setValue(str);
                            this._lastOK = str;
                        },
                        onChange: function (newv) {
                            var s = String(newv || '').replace(/\D+/g, '');
                            if (s === '') {
                                this.setValue('');
                                return;
                            }
                            var n = parseInt(s, 10);
                            if (isNaN(n)) {
                                this.setValue(this._lastOK || '');
                                return;
                            }
                            if (n > 100) n = 100;
                            if (n < 0) n = 0;
                            var str = String(n);
                            if (this.getValue() !== str) this.setValue(str);
                            this._lastOK = str;
                        },
                    },
                },
            ],
        };

        // Configuration for the center-left section of the for comission tax form (base values)
        const center_left_for_comission_tax = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'TaxPointsaledeposit',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Deposito Punto venta') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el numero de tasa de impuesto del Deposito Punto venta') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Deposito Punto venta'),
                    invalidMessage: _('Campo Requerido'), // Message for invalid input
                    attributes: { min: 0, max: 100, step: 1, inputmode: 'numeric' },
                    on: {
                        onAfterRender: function () {
                            this._lastOK = this.getValue() || '';
                        },
                        onBeforePaste: function (text) {
                            // Solo dígitos y máximo 3 caracteres
                            var clean = String(text).replace(/\D+/g, '').slice(0, 3);
                            return clean;
                        },
                        onKeyPress: function (code, e) {
                            // Permite solo dígitos y teclas de control comunes
                            if (
                                (code >= 48 && code <= 57) ||
                                code === 8 ||
                                code === 9 ||
                                code === 13 ||
                                code === 46 ||
                                code === 37 ||
                                code === 39
                            )
                                return true;
                            return false;
                        },
                        onTimedKeyPress: function () {
                            var s = String(this.getValue() || '').replace(/\D+/g, '');
                            if (s === '') {
                                this.setValue('');
                                this._lastOK = '';
                                return;
                            }
                            var n = parseInt(s, 10);
                            if (isNaN(n)) {
                                this.setValue(this._lastOK || '');
                                return;
                            }
                            if (n > 100) n = 100;
                            if (n < 0) n = 0;
                            var str = String(n);
                            if (this.getValue() !== str) this.setValue(str);
                            this._lastOK = str;
                        },
                        onChange: function (newv) {
                            var s = String(newv || '').replace(/\D+/g, '');
                            if (s === '') {
                                this.setValue('');
                                return;
                            }
                            var n = parseInt(s, 10);
                            if (isNaN(n)) {
                                this.setValue(this._lastOK || '');
                                return;
                            }
                            if (n > 100) n = 100;
                            if (n < 0) n = 0;
                            var str = String(n);
                            if (this.getValue() !== str) this.setValue(str);
                            this._lastOK = str;
                        },
                    },
                },
                {
                    view: 'text',
                    name: 'TaxPointsalesportbet',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Apuesta Sport Punto venta') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el numero de tasa de impuesto de la Apuesta Sport Punto venta') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Apuesta Sport Punto venta'),
                    invalidMessage: _('Campo Requerido'), // Message for invalid input
                    attributes: { min: 0, max: 100, step: 1, inputmode: 'numeric' },
                    on: {
                        onAfterRender: function () {
                            this._lastOK = this.getValue() || '';
                        },
                        onBeforePaste: function (text) {
                            // Solo dígitos y máximo 3 caracteres
                            var clean = String(text).replace(/\D+/g, '').slice(0, 3);
                            return clean;
                        },
                        onKeyPress: function (code, e) {
                            // Permite solo dígitos y teclas de control comunes
                            if (
                                (code >= 48 && code <= 57) ||
                                code === 8 ||
                                code === 9 ||
                                code === 13 ||
                                code === 46 ||
                                code === 37 ||
                                code === 39
                            )
                                return true;
                            return false;
                        },
                        onTimedKeyPress: function () {
                            var s = String(this.getValue() || '').replace(/\D+/g, '');
                            if (s === '') {
                                this.setValue('');
                                this._lastOK = '';
                                return;
                            }
                            var n = parseInt(s, 10);
                            if (isNaN(n)) {
                                this.setValue(this._lastOK || '');
                                return;
                            }
                            if (n > 100) n = 100;
                            if (n < 0) n = 0;
                            var str = String(n);
                            if (this.getValue() !== str) this.setValue(str);
                            this._lastOK = str;
                        },
                        onChange: function (newv) {
                            var s = String(newv || '').replace(/\D+/g, '');
                            if (s === '') {
                                this.setValue('');
                                return;
                            }
                            var n = parseInt(s, 10);
                            if (isNaN(n)) {
                                this.setValue(this._lastOK || '');
                                return;
                            }
                            if (n > 100) n = 100;
                            if (n < 0) n = 0;
                            var str = String(n);
                            if (this.getValue() !== str) this.setValue(str);
                            this._lastOK = str;
                        },
                    },
                },
                {
                    view: 'text',
                    name: 'TaxPointsalewithdrawalnotes',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Notas de retiro Punto venta') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el numero de tasa de impuesto de la Notas de retiro Punto venta') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Notas de retiro Punto venta'),
                    invalidMessage: _('Campo Requerido'), // Message for invalid input
                    attributes: { min: 0, max: 100, step: 1, inputmode: 'numeric' },
                    on: {
                        onAfterRender: function () {
                            this._lastOK = this.getValue() || '';
                        },
                        onBeforePaste: function (text) {
                            // Solo dígitos y máximo 3 caracteres
                            var clean = String(text).replace(/\D+/g, '').slice(0, 3);
                            return clean;
                        },
                        onKeyPress: function (code, e) {
                            // Permite solo dígitos y teclas de control comunes
                            if (
                                (code >= 48 && code <= 57) ||
                                code === 8 ||
                                code === 9 ||
                                code === 13 ||
                                code === 46 ||
                                code === 37 ||
                                code === 39
                            )
                                return true;
                            return false;
                        },
                        onTimedKeyPress: function () {
                            var s = String(this.getValue() || '').replace(/\D+/g, '');
                            if (s === '') {
                                this.setValue('');
                                this._lastOK = '';
                                return;
                            }
                            var n = parseInt(s, 10);
                            if (isNaN(n)) {
                                this.setValue(this._lastOK || '');
                                return;
                            }
                            if (n > 100) n = 100;
                            if (n < 0) n = 0;
                            var str = String(n);
                            if (this.getValue() !== str) this.setValue(str);
                            this._lastOK = str;
                        },
                        onChange: function (newv) {
                            var s = String(newv || '').replace(/\D+/g, '');
                            if (s === '') {
                                this.setValue('');
                                return;
                            }
                            var n = parseInt(s, 10);
                            if (isNaN(n)) {
                                this.setValue(this._lastOK || '');
                                return;
                            }
                            if (n > 100) n = 100;
                            if (n < 0) n = 0;
                            var str = String(n);
                            if (this.getValue() !== str) this.setValue(str);
                            this._lastOK = str;
                        },
                    },
                },
                {
                    view: 'text',
                    name: 'TaxSportbookGGRAffiliates',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Sportbook GGR Afiliados') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el numero de tasa de impuesto del Sportbook GGR Afiliados') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Sportbook GGR Afiliados'),
                    invalidMessage: _('Campo Requerido'), // Message for invalid input
                    attributes: { min: 0, max: 100, step: 1, inputmode: 'numeric' },
                    on: {
                        onAfterRender: function () {
                            this._lastOK = this.getValue() || '';
                        },
                        onBeforePaste: function (text) {
                            // Solo dígitos y máximo 3 caracteres
                            var clean = String(text).replace(/\D+/g, '').slice(0, 3);
                            return clean;
                        },
                        onKeyPress: function (code, e) {
                            // Permite solo dígitos y teclas de control comunes
                            if (
                                (code >= 48 && code <= 57) ||
                                code === 8 ||
                                code === 9 ||
                                code === 13 ||
                                code === 46 ||
                                code === 37 ||
                                code === 39
                            )
                                return true;
                            return false;
                        },
                        onTimedKeyPress: function () {
                            var s = String(this.getValue() || '').replace(/\D+/g, '');
                            if (s === '') {
                                this.setValue('');
                                this._lastOK = '';
                                return;
                            }
                            var n = parseInt(s, 10);
                            if (isNaN(n)) {
                                this.setValue(this._lastOK || '');
                                return;
                            }
                            if (n > 100) n = 100;
                            if (n < 0) n = 0;
                            var str = String(n);
                            if (this.getValue() !== str) this.setValue(str);
                            this._lastOK = str;
                        },
                        onChange: function (newv) {
                            var s = String(newv || '').replace(/\D+/g, '');
                            if (s === '') {
                                this.setValue('');
                                return;
                            }
                            var n = parseInt(s, 10);
                            if (isNaN(n)) {
                                this.setValue(this._lastOK || '');
                                return;
                            }
                            if (n > 100) n = 100;
                            if (n < 0) n = 0;
                            var str = String(n);
                            if (this.getValue() !== str) this.setValue(str);
                            this._lastOK = str;
                        },
                    },
                },
            ],
        };

        // Configuration for the center-right section of the for comission tax form (base values)
        const center_right_for_comission_tax = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'TaxCasinongRAffiliates',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Casino NGR Afiliados') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el numero de tasa de impuesto del Casino NGR Afiliados') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Casino NGR Afiliados'),
                    invalidMessage: _('Campo Requerido'), // Message for invalid input
                    attributes: { min: 0, max: 100, step: 1, inputmode: 'numeric' },
                    on: {
                        onAfterRender: function () {
                            this._lastOK = this.getValue() || '';
                        },
                        onBeforePaste: function (text) {
                            // Solo dígitos y máximo 3 caracteres
                            var clean = String(text).replace(/\D+/g, '').slice(0, 3);
                            return clean;
                        },
                        onKeyPress: function (code, e) {
                            // Permite solo dígitos y teclas de control comunes
                            if (
                                (code >= 48 && code <= 57) ||
                                code === 8 ||
                                code === 9 ||
                                code === 13 ||
                                code === 46 ||
                                code === 37 ||
                                code === 39
                            )
                                return true;
                            return false;
                        },
                        onTimedKeyPress: function () {
                            var s = String(this.getValue() || '').replace(/\D+/g, '');
                            if (s === '') {
                                this.setValue('');
                                this._lastOK = '';
                                return;
                            }
                            var n = parseInt(s, 10);
                            if (isNaN(n)) {
                                this.setValue(this._lastOK || '');
                                return;
                            }
                            if (n > 100) n = 100;
                            if (n < 0) n = 0;
                            var str = String(n);
                            if (this.getValue() !== str) this.setValue(str);
                            this._lastOK = str;
                        },
                        onChange: function (newv) {
                            var s = String(newv || '').replace(/\D+/g, '');
                            if (s === '') {
                                this.setValue('');
                                return;
                            }
                            var n = parseInt(s, 10);
                            if (isNaN(n)) {
                                this.setValue(this._lastOK || '');
                                return;
                            }
                            if (n > 100) n = 100;
                            if (n < 0) n = 0;
                            var str = String(n);
                            if (this.getValue() !== str) this.setValue(str);
                            this._lastOK = str;
                        },
                    },
                },
                {
                    view: 'text',
                    name: 'TaxTransactionfeedeposit',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Deposito Comision por Transaccion') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el numero de tasa de impuesto del Deposito Comision por Transaccion') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Deposito Comision por Transaccion'),
                    invalidMessage: _('Campo Requerido'), // Message for invalid input
                    attributes: { min: 0, max: 100, step: 1, inputmode: 'numeric' },
                    on: {
                        onAfterRender: function () {
                            this._lastOK = this.getValue() || '';
                        },
                        onBeforePaste: function (text) {
                            // Solo dígitos y máximo 3 caracteres
                            var clean = String(text).replace(/\D+/g, '').slice(0, 3);
                            return clean;
                        },
                        onKeyPress: function (code, e) {
                            // Permite solo dígitos y teclas de control comunes
                            if (
                                (code >= 48 && code <= 57) ||
                                code === 8 ||
                                code === 9 ||
                                code === 13 ||
                                code === 46 ||
                                code === 37 ||
                                code === 39
                            )
                                return true;
                            return false;
                        },
                        onTimedKeyPress: function () {
                            var s = String(this.getValue() || '').replace(/\D+/g, '');
                            if (s === '') {
                                this.setValue('');
                                this._lastOK = '';
                                return;
                            }
                            var n = parseInt(s, 10);
                            if (isNaN(n)) {
                                this.setValue(this._lastOK || '');
                                return;
                            }
                            if (n > 100) n = 100;
                            if (n < 0) n = 0;
                            var str = String(n);
                            if (this.getValue() !== str) this.setValue(str);
                            this._lastOK = str;
                        },
                        onChange: function (newv) {
                            var s = String(newv || '').replace(/\D+/g, '');
                            if (s === '') {
                                this.setValue('');
                                return;
                            }
                            var n = parseInt(s, 10);
                            if (isNaN(n)) {
                                this.setValue(this._lastOK || '');
                                return;
                            }
                            if (n > 100) n = 100;
                            if (n < 0) n = 0;
                            var str = String(n);
                            if (this.getValue() !== str) this.setValue(str);
                            this._lastOK = str;
                        },
                    },
                },
            ],
        };

        // Configuration for the left section of the tax form
        const left_tax = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'DepositTaxValue',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Impuesto de depósito') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Impuesto de depósito por defecto') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Impuesto de depósito por defecto'),
                    invalidMessage: _('Campo Requerido'), // Message for invalid input
                },
            ],
        };

        // Configuration for the center-left section of the tax form
        const center_left_tax = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'BetTaxValue',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Impuesto a la apuesta') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Impuesto de apuesta por defecto') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Impuesto de apuesta por defecto'),
                    invalidMessage: _('Campo Requerido'), // Message for invalid input
                },
            ],
        };

        // Configuration for the right section of the tax form
        const right_tax = {
            hidden: !devConfig.getPermAction('taxPaymentsReport', 'Add'), // Hide if no permission
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    hidden: !devConfig.getPermAction('taxPaymentsReport', 'Add'), // Hide if no permission
                    view: 'text',
                    name: 'TaxPayments',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Impuesto de premios Guatemala') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Impuesto de premios Guatemala por defecto') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Impuesto de premios Guatemala por defecto'),
                    invalidMessage: _('Campo Requerido'), // Message for invalid input
                },
            ],
        };

        const right_register = {
            margin: 5,
            minWidth: 200,
            rows: [], // Empty rows for future use
        };

        // Configuration for the left section of the provider form
        const left_provider = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'combo',
                    name: 'ProviderSMS',
                    minWidth: 200,
                    id: 'ProviderSMS',
                    label: "<div class='tittle'>" + _('Proveedor de SMS') + '</div>',
                    labelPosition: 'top',
                    options: [],
                    placeholder: _('Click para seleccionar '),
                },
                {
                    view: 'combo',
                    name: 'ProviderSignature',
                    minWidth: 200,
                    id: 'ProviderSignature',
                    label: "<div class='tittle'>" + _('Proveedor de Firmas') + '</div>',
                    labelPosition: 'top',
                    options: [],
                    placeholder: _('Click para seleccionar '),
                },
                {
                    view: 'combo',
                    name: 'ProviderForCreditCardSelected',
                    minWidth: 200,
                    id: 'ProviderForCreditCardSelected',
                    label: "<div class='tittle'>" + _('Proveedor de Tarjeta de Credito') + '</div>',
                    labelPosition: 'top',
                    options: [],
                    placeholder: _('Click para seleccionar '),
                },
            ],
        };

        // Configuration for the center-left section of the provider form
        const center_left_provider = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'combo',
                    name: 'ProviderVerification',
                    minWidth: 200,
                    id: 'ProviderVerification',
                    label: "<div class='tittle'>" + _('Proveedor de verificacíon') + '</div>',
                    labelPosition: 'top',
                    options: [],
                    placeholder: _('Click para seleccionar '),
                },
                {
                    cols: [
                        { view: 'label', label: "<div class='tittle'>" + _('Usuario Online') + '</div>' },
                        {
                            id: 'VerificaFiltro',
                            view: 'switch',
                            onLabel: _('Si'),
                            offLabel: _('No'),
                        },
                    ],
                },
                {
                    cols: [
                        { view: 'label', label: "<div class='tittle'>" + _('Retail') + '</div>' },
                        {
                            id: 'VerificaFiltroPV',
                            view: 'switch',
                            onLabel: _('Si'),
                            offLabel: _('No'),
                        },
                    ],
                },
            ],
        };

        // Configuration for the center-right section of the provider form
        const center_right_provider = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'combo',
                    name: 'ProviderCRM',
                    minWidth: 200,
                    id: 'ProviderCRM',
                    label: "<div class='tittle'>" + _('Proveedor de CRM') + '</div>',
                    labelPosition: 'top',
                    options: [],
                    placeholder: _('Click para seleccionar '),
                },
                {
                    view: 'combo',
                    name: 'ProviderCPF',
                    minWidth: 200,
                    id: 'ProviderCPF',
                    label: "<div class='tittle'>" + _('Proveedor CPF') + '</div>',
                    labelPosition: 'top',
                    options: [],
                    placeholder: _('Click para seleccionar '),
                },
            ],
        };

        // Configuration for the right section of the provider form
        const right_provider = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'combo',
                    name: 'ProviderEmail',
                    minWidth: 200,
                    id: 'ProviderEmail',
                    label: "<div class='tittle'>" + _('Proveedor de Email') + '</div>',
                    labelPosition: 'top',
                    options: [],
                    placeholder: _('Click para seleccionar '),
                },
                {
                    view: 'text',
                    id: 'SetMins',
                    name: 'SetMins',
                    type: 'number',
                    label: "<div class='tittle'>" + _('Tiempo de verificacion') + '</div>',
                    labelPosition: 'top',
                    defaultValue: 0,
                },
            ],
        };

        // Configuration for the left section of the loyalty form
        const left_loyalty = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'PointsLevelOne',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Puntos requeridos para el nivel 1') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Puntos requeridos para el nivel 1') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Puntos requeridos para el nivel 1'),
                    invalidMessage: _('Campo Requerido'), // Message for invalid input
                },
                {
                    view: 'text',
                    name: 'PointsLevelSix',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Puntos requeridos para el nivel 6') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Puntos requeridos para el nivel 6') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Puntos requeridos para el nivel 6'),
                    invalidMessage: _('Campo Requerido'), // Message for invalid input
                },
            ],
        };

        // Configuration for the center-left section of the loyalty form
        const center_left_loyalty = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'PointsLevelTwo',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Puntos requeridos para el nivel 2') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Puntos requeridos para el nivel 2') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Puntos requeridos para el nivel 2'),
                    invalidMessage: _('Campo Requerido'), // Message for invalid input
                },
                {
                    view: 'text',
                    name: 'PointsLevelSeven',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Puntos requeridos para el nivel 7') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Puntos requeridos para el nivel 7') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Puntos requeridos para el nivel 7'),
                    invalidMessage: _('Campo Requerido'), // Message for invalid input
                },
            ],
        };

        // Configuration for the center-right section of the loyalty form
        const center_right_loyalty = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'PointsLevelThree',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Puntos requeridos para el nivel 3') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Puntos requeridos para el nivel 3') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Puntos requeridos para el nivel 3'),
                    invalidMessage: _('Campo Requerido'), // Message for invalid input
                },
                {
                    view: 'text',
                    name: 'PointsLevelEight',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Puntos requeridos para el nivel 8') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Puntos requeridos para el nivel 8') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Puntos requeridos para el nivel 8'),
                    invalidMessage: _('Campo Requerido'), // Message for invalid input
                },
            ],
        };

        // Configuration for the right section of the loyalty form
        const right_loyalty = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'PointsLevelFour',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Puntos requeridos para el nivel 4') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Puntos requeridos para el nivel 4') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Puntos requeridos para el nivel 4'),
                    invalidMessage: _('Campo Requerido'), // Message for invalid input
                },
                {
                    view: 'text',
                    name: 'PointsLevelNine',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Puntos requeridos para el nivel 9') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Puntos requeridos para el nivel 9') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Puntos requeridos para el nivel 9'),
                    invalidMessage: _('Campo Requerido'), // Message for invalid input
                },
            ],
        };

        // Configuration for the second right section of the loyalty form
        const right2_loyalty = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'PointsLevelFive',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Puntos requeridos para el nivel 5') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Puntos requeridos para el nivel 5') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Puntos requeridos para el nivel 5'),
                    invalidMessage: _('Campo Requerido'), // Message for invalid input
                },
                {
                    view: 'text',
                    name: 'PointsLevelTen',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Puntos requeridos para el nivel 10') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Puntos requeridos para el nivel 10') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Puntos requeridos para el nivel 10'),
                    invalidMessage: _('Campo Requerido'), // Message for invalid input
                },
            ],
        };

        // Configuration for the left section of the loyalty form (base values)
        const left_loyalty_ = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'label',
                    label:
                        "<div class='tittle'>" +
                        _('Sportbook') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _(
                            ' Para activar Sportbook, los campos Puntos Base, Días de expiración y todas las apuestas deportivas (simple y combinadas) deben ser mayores que 0.',
                        ) +
                        '</span></div>',
                },
                {
                    css: 'centrar', // CSS class for centering
                    id: 'ValidationsSportbook', // Unique identifier for the switch
                    name: 'ValidationsSportbook',
                    view: 'switch', // Type of input view
                    labelWidth: 55, // Width of the label
                    onLabel: _('Activo'), // Label when switch is on
                    offLabel: _('Inactivo'), // Label when switch is off
                    on: {
                        onChange: function (newv) {
                            if (loadingPartnerSettings) return;
                            if (newv === 1 && !canEnableValidationSwitch('ValidationsSportbook')) {
                                webix.message({ type: 'error', text: loyaltyRules.ValidationsSportbook.msg });
                                this.setValue(0);
                            }
                        },
                    },
                },
                {
                    view: 'text',
                    name: 'LoyaltyBaseValue',
                    id: 'LoyaltyBaseValue',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Puntos Base') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _(
                            'Especifique el numero de puntos que se tomara como base, equivalente a Z en los demás items.',
                        ) +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Puntos Base'),
                    invalidMessage: _('Campo Requerido'), // Message for invalid input
                    on: {
                        onChange: function (newv, oldv) {
                            if (loadingPartnerSettings) return;
                            validationsLoyaltyFields({ enforce: true, silent: true });
                            modifyInputStyle(newv, 'LoyaltyBaseValue');
                        },
                    },
                },
                {
                    view: 'text',
                    name: 'LoyaltyDeposit',
                    id: 'LoyaltyDeposit',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Monto depósito') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Monto (Dinero) requerido de los depósitos para obtener Z punto') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Monto depósito'),
                    invalidMessage: _('Campo Requerido'), // Message for invalid input
                },
                {
                    view: 'text',
                    name: 'LoyaltyBettingSportsCombinedTwo',
                    id: 'LoyaltyBettingSportsCombinedTwo',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Deportiva combinada de 2') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Monto (Dinero) requerido de una apuesta deportiva Combinada de 2 para obtener Z punto') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Deportiva combinada de 2'),
                    invalidMessage: _('Campo Requerido'), // Message for invalid input
                    on: {
                        onChange: function (newv, oldv) {
                            if (loadingPartnerSettings) return;
                            validationsLoyaltyFields({ enforce: true, silent: true });
                            modifyInputStyle(newv, 'LoyaltyBettingSportsCombinedTwo');
                        },
                    },
                },
                {
                    view: 'text',
                    name: 'LoyaltyBettingSportsCombinedSix',
                    id: 'LoyaltyBettingSportsCombinedSix',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Deportiva combinada de 6') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Monto (Dinero) requerido de una apuesta deportiva Combinada de 6 para obtener Z punto') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Deportiva combinada de 6'),
                    invalidMessage: _('Campo Requerido'), // Message for invalid input
                    on: {
                        onChange: function (newv, oldv) {
                            if (loadingPartnerSettings) return;
                            validationsLoyaltyFields({ enforce: true, silent: true });
                            modifyInputStyle(newv, 'LoyaltyBettingSportsCombinedSix');
                        },
                    },
                },
                {
                    view: 'text',
                    name: 'LoyaltyBettingSportsCombinedTen',
                    id: 'LoyaltyBettingSportsCombinedTen',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Deportiva combinada de 10') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Monto (Dinero) requerido de una apuesta deportiva Combinada de 10 para obtener Z punto') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Deportiva combinada de 10'),
                    invalidMessage: _('Campo Requerido'), // Message for invalid input
                    on: {
                        onChange: function (newv, oldv) {
                            if (loadingPartnerSettings) return;
                            validationsLoyaltyFields({ enforce: true, silent: true });
                            modifyInputStyle(newv, 'LoyaltyBettingSportsCombinedTen');
                        },
                    },
                },
            ],
        };

        // Configuration for the center-left section of the loyalty form (base values)
        const center_left_loyalty_ = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'label',
                    label:
                        "<div class='tittle'>" +
                        _('Casino') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _(
                            'Para activar Casino, los campos Puntos Base, Días de expiración y Apuestas de casino deben ser mayores que 0.',
                        ) +
                        '</span></div>',
                },
                {
                    css: 'centrar', // CSS class for centering
                    id: 'ValidationsCasino', // Unique identifier for the switch
                    name: 'ValidationsCasino',
                    view: 'switch', // Type of input view
                    labelWidth: 55, // Width of the label
                    onLabel: _('Activo'), // Label when switch is on
                    offLabel: _('Inactivo'), // Label when switch is off
                    on: {
                        onChange: function (newv) {
                            if (loadingPartnerSettings) return;
                            if (newv === 1 && !canEnableValidationSwitch('ValidationsCasino')) {
                                webix.message({ type: 'error', text: loyaltyRules.ValidationsCasino.msg });
                                this.setValue(0);
                            }
                        },
                    },
                },
                {
                    view: 'text',
                    name: 'LoyaltyBetCasino',
                    id: 'LoyaltyBetCasino',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Apuestas de casino') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Monto (Dinero) requerido de apuestas de casino para obtener Z punto') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Apuestas de casino'),
                    invalidMessage: _('Campo Requerido'), // Message for invalid input
                    on: {
                        onChange: function (newv, oldv) {
                            if (loadingPartnerSettings) return;
                            validationsLoyaltyFields({ enforce: true, silent: true });
                            modifyInputStyle(newv, 'LoyaltyBetCasino');
                        },
                    },
                },
                {
                    view: 'text',
                    name: 'LoyaltyWithdrawal',
                    id: 'LoyaltyWithdrawal',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Monto requerido de retiros') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Monto (Dinero) requerido de retiros para obtener Z punto') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Monto requerido de retiros'),
                    invalidMessage: _('Campo Requerido'), // Message for invalid input
                },
                {
                    view: 'text',
                    name: 'LoyaltyBettingSportsCombinedThree',
                    id: 'LoyaltyBettingSportsCombinedThree',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Deportiva combinada de 3') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Monto (Dinero) requerido de una apuesta deportiva Combinada de 3 para obtener Z punto') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Deportiva combinada de 3'),
                    invalidMessage: _('Campo Requerido'), // Message for invalid input
                    on: {
                        onChange: function (newv, oldv) {
                            if (loadingPartnerSettings) return;
                            validationsLoyaltyFields({ enforce: true, silent: true });
                            modifyInputStyle(newv, 'LoyaltyBettingSportsCombinedThree');
                        },
                    },
                },
                {
                    view: 'text',
                    name: 'LoyaltyBettingSportsCombinedSeven',
                    id: 'LoyaltyBettingSportsCombinedSeven',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Deportiva combinada de 7') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Monto (Dinero) requerido de una apuesta deportiva Combinada de 7 para obtener Z punto') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Deportiva combinada de 7'),
                    invalidMessage: _('Campo Requerido'), // Message for invalid input
                    on: {
                        onChange: function (newv, oldv) {
                            if (loadingPartnerSettings) return;
                            validationsLoyaltyFields({ enforce: true, silent: true });
                            modifyInputStyle(newv, 'LoyaltyBettingSportsCombinedSeven');
                        },
                    },
                },
            ],
        };

        // Configuration for the center-right section of the loyalty form (base values)
        const center_right_loyalty_ = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'label',
                    label:
                        "<div class='tittle'>" +
                        _('Livecasino') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _(
                            'Para activar LiveCasino, los campos Puntos Base, Días de expiración y Apuestas de casino en vivo deben ser mayores que 0.',
                        ) +
                        '</span></div>',
                },
                {
                    css: 'centrar', // CSS class for centering
                    id: 'ValidationsLiveCasino', // Unique identifier for the switch
                    name: 'ValidationsLiveCasino',
                    view: 'switch', // Type of input view
                    labelWidth: 55, // Width of the label
                    onLabel: _('Activo'), // Label when switch is on
                    offLabel: _('Inactivo'), // Label when switch is off
                    on: {
                        onChange: function (newv) {
                            if (loadingPartnerSettings) return;
                            if (newv === 1 && !canEnableValidationSwitch('ValidationsLiveCasino')) {
                                webix.message({ type: 'error', text: loyaltyRules.ValidationsLiveCasino.msg });
                                this.setValue(0);
                            }
                        },
                    },
                },
                {
                    view: 'text',
                    name: 'LoyaltyBetCasinoLive',
                    id: 'LoyaltyBetCasinoLive',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Apuestas casino en vivo') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Monto (Dinero) requerido de apuestas casino en vivo para obtener Z punto') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Casino en Vivo'),
                    invalidMessage: _('Campo Requerido'), // Message for invalid input
                    on: {
                        onChange: function (newv, oldv) {
                            if (loadingPartnerSettings) return;
                            validationsLoyaltyFields({ enforce: true, silent: true });
                            modifyInputStyle(newv, 'LoyaltyBetCasinoLive');
                        },
                    },
                },
                {
                    view: 'text',
                    name: 'LoyaltyExpirationDate',
                    id: 'LoyaltyExpirationDate',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Días de expiración de puntos') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el tiempo en días para la caducidad de los puntos') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Días de expiración de puntos'),
                    invalidMessage: _('Campo Requerido'), // Message for invalid input
                    on: {
                        onChange: function (newv, oldv) {
                            if (loadingPartnerSettings) return;
                            validationsLoyaltyFields({ enforce: true, silent: true });
                            modifyInputStyle(newv, 'LoyaltyExpirationDate');
                        },
                    },
                },
                {
                    view: 'text',
                    name: 'LoyaltyBettingSportsCombinedFour',
                    id: 'LoyaltyBettingSportsCombinedFour',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Deportiva combinada de 4') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Monto (Dinero) requerido de una apuesta deportiva Combinada de 4 para obtener Z punto') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Deportiva combinada de 4'),
                    invalidMessage: _('Campo Requerido'), // Message for invalid input
                    on: {
                        onChange: function (newv, oldv) {
                            if (loadingPartnerSettings) return;
                            validationsLoyaltyFields({ enforce: true, silent: true });
                            modifyInputStyle(newv, 'LoyaltyBettingSportsCombinedFour');
                        },
                    },
                },
                {
                    view: 'text',
                    name: 'LoyaltyBettingSportsCombinedEight',
                    id: 'LoyaltyBettingSportsCombinedEight',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Deportiva combinada de 8') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Monto (Dinero) requerido de una apuesta deportiva Combinada de 8 para obtener Z punto') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Deportiva combinada de 8'),
                    invalidMessage: _('Campo Requerido'), // Message for invalid input
                    on: {
                        onChange: function (newv, oldv) {
                            if (loadingPartnerSettings) return;
                            validationsLoyaltyFields({ enforce: true, silent: true });
                            modifyInputStyle(newv, 'LoyaltyBettingSportsCombinedEight');
                        },
                    },
                },
            ],
        };

        // Configuration for the right section of the loyalty form (base values)
        const right_loyalty_ = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'label',
                    label:
                        "<div class='tittle'>" +
                        _('Virtual') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _(
                            'Para activar Virtual, los campos Puntos Base, Días de expiración y Apuestas virtuales deben ser mayores que 0.',
                        ) +
                        '</span></div>',
                },
                {
                    css: 'centrar', // CSS class for centering
                    id: 'ValidationsVirtuals', // Unique identifier for the switch
                    name: 'ValidationsVirtuals',
                    view: 'switch', // Type of input view
                    labelWidth: 55, // Width of the label
                    onLabel: _('Activo'), // Label when switch is on
                    offLabel: _('Inactivo'), // Label when switch is off
                    on: {
                        onChange: function (newv) {
                            if (loadingPartnerSettings) return;
                            if (newv === 1 && !canEnableValidationSwitch('ValidationsVirtuals')) {
                                webix.message({ type: 'error', text: loyaltyRules.ValidationsVirtuals.msg });
                                this.setValue(0);
                            }
                        },
                    },
                },
                {
                    view: 'text',
                    name: 'LoyaltyBetVirtuals',
                    id: 'LoyaltyBetVirtuals',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Apuestas Virtuales') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Monto (Dinero) requerido de apuestas virtuales para obtener Z punto') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Apuestas Virtuales'),
                    invalidMessage: _('Campo Requerido'), // Message for invalid input
                    on: {
                        onChange: function (newv, oldv) {
                            if (loadingPartnerSettings) return;
                            validationsLoyaltyFields({ enforce: true, silent: true });
                            modifyInputStyle(newv, 'LoyaltyBetVirtuals');
                        },
                    },
                },
                {
                    view: 'text',
                    name: 'LoyaltyBettingSportsSimple',
                    id: 'LoyaltyBettingSportsSimple',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Deportiva simple') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Monto (Dinero) requerido de una apuesta deportiva simple para obtener Z punto') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Deportiva simple'),
                    invalidMessage: _('Campo Requerido'), // Message for invalid input
                    on: {
                        onChange: function (newv, oldv) {
                            if (loadingPartnerSettings) return;
                            validationsLoyaltyFields({ enforce: true, silent: true });
                            modifyInputStyle(newv, 'LoyaltyBettingSportsSimple');
                        },
                    },
                },
                {
                    view: 'text',
                    name: 'LoyaltyBettingSportsCombinedFive',
                    id: 'LoyaltyBettingSportsCombinedFive',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Deportiva combinada de 5') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Monto (Dinero) requerido de una apuesta deportiva Combinada de 5 para obtener Z punto') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Deportiva combinada de 5'),
                    invalidMessage: _('Campo Requerido'), // Message for invalid input
                    on: {
                        onChange: function (newv, oldv) {
                            if (loadingPartnerSettings) return;
                            validationsLoyaltyFields({ enforce: true, silent: true });
                            modifyInputStyle(newv, 'LoyaltyBettingSportsCombinedFive');
                        },
                    },
                },
                {
                    view: 'text',
                    name: 'LoyaltyBettingSportsCombinedNine',
                    id: 'LoyaltyBettingSportsCombinedNine',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Deportiva combinada de 9') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Monto (Dinero) requerido de una apuesta deportiva Combinada de 9 para obtener Z punto') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Deportiva combinada de 9'),
                    invalidMessage: _('Campo Requerido'), // Message for invalid input
                    on: {
                        onChange: function (newv, oldv) {
                            if (loadingPartnerSettings) return;
                            validationsLoyaltyFields({ enforce: true, silent: true });
                            modifyInputStyle(newv, 'LoyaltyBettingSportsCombinedNine');
                        },
                    },
                },
            ],
        };

        /**
         * Configuration object for the left fiscal section.
         * Contains margin, minimum width, and an array of input rows.
         * @type {Object}
         */
        const left_fiscal = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'PercentDepositValue',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Porcentaje valor de depósitos') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el porcentaje del valor de depositos a mostrar en los reportes') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Porcentaje valor de depósitos'),
                    invalidMessage: _('Campo Requerido'),
                },
                {
                    view: 'text',
                    name: 'PercentValueNonSportsAwards',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Porcentaje premios no deportivos') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el porcentaje de los premios no deportivos a mostrar en los reportes') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Porcentaje premios no deportivos'),
                    invalidMessage: _('Campo Requerido'),
                },
            ],
        };

        /**
         * Configuration object for the center left fiscal section.
         * Contains margin, minimum width, and an array of input rows.
         * @type {Object}
         */
        const center_left_fiscal = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'PercentRetirementValue',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Porcentaje valor de retiros') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el porcentaje del valor de retiros a mostrar en los reportes') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Porcentaje valor de retiros'),
                    invalidMessage: _('Campo Requerido'),
                },
                {
                    view: 'text',
                    name: 'PercentValueSportsBonds',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Porcentaje de bonos deportivos') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el porcentaje de los bonos deportivos a mostrar en los reportes') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Porcentaje de bonos deportivos'),
                    invalidMessage: _('Campo Requerido'),
                },
            ],
        };

        /**
         * Configuration object for the center right fiscal section.
         * Contains margin, minimum width, and an array of input rows.
         * @type {Object}
         */
        const center_right_fiscal = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'PercentValueSportsBets',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Porcentaje de apuestas deportivas') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el porcentaje de las apuestas deportivas a mostrar en los reportes') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Porcentaje de apuestas deportivas'),
                    invalidMessage: _('Campo Requerido'),
                },
                {
                    view: 'text',
                    name: 'PercentValueNonSportsBounds',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Porcentaje de bonos no deportivos') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el porcentaje de los bonos no deportivos a mostrar en los reportes') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Porcentaje de bonos no deportivos'),
                    invalidMessage: _('Campo Requerido'),
                },
            ],
        };

        /**
         * Configuration object for the right fiscal section.
         * Contains margin, minimum width, and an array of input rows.
         * @type {Object}
         */
        const right_fiscal = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'PercentValueNonSportBets',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Porcentaje de apuestas no deportivas') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el porcentaje de las apuestas no deportivas a mostrar en los reportes') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Porcentaje de apuestas no deportivas'),
                    invalidMessage: _('Campo Requerido'),
                },
                {
                    view: 'text',
                    name: 'PercentValueTickets',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Porcentaje de tickets') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el porcentaje de los tickets a mostrar en los reportes') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Porcentaje de tickets'),
                    invalidMessage: _('Campo Requerido'),
                },
            ],
        };

        /**
         * Configuration object for the right2 fiscal section.
         * Contains margin, minimum width, and an array of input rows.
         * @type {Object}
         */
        const right2_fiscal = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'PercentValueSportsAwards',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Porcentaje de premios deportivos') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el porcentaje de los premios deportivos a mostrar en los reportes') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Porcentaje de de premios deportivos'),
                    invalidMessage: _('Campo Requerido'),
                },
            ],
        };

        /**
         * Configuration object for the upper section of the register.
         * Contains an ID, margin, and an array of rows with columns.
         * @type {Object}
         */
        const upper_section_register = {
            id: 'a6',
            rows: [
                {
                    responsive: 'a6',
                    margin: 10,
                    cols: [left_register, center_left_register, center_right_register],
                },
            ],
        };

        /**
         * Configuration object for the upper section of the tax.
         * Contains an ID, margin, and an array of rows with columns.
         * @type {Object}
         */
        const upper_section_configuration_loyalty = {
            id: 'a6',
            rows: [
                {
                    responsive: 'a6',
                    margin: 10,
                    cols: [left_configuration_loyalty, center_left_configuration_loyalty, {}],
                },
            ],
        };

        /**
         * Configuration object for the upper section of the tax.
         * Contains an ID, margin, and an array of rows with columns.
         * @type {Object}
         */
        const upper_section_tax = {
            id: 'a6',
            rows: [
                {
                    responsive: 'a6',
                    margin: 10,
                    cols: [left_tax, center_left_tax, right_tax],
                },
            ],
        };

        /**
         * Configuration object for the upper section of the for comission tax.
         * Contains an ID, margin, and an array of rows with columns.
         * @type {Object}
         */
        const upper_section_for_comission_tax = {
            id: 'a6',
            rows: [
                {
                    responsive: 'a6',
                    margin: 10,
                    cols: [left_for_comission_tax, center_left_for_comission_tax, center_right_for_comission_tax],
                },
            ],
        };

        /**
         * Configuration object for the upper section of the provider.
         * Contains an ID, margin, and an array of rows with columns.
         * @type {Object}
         */
        const upper_section_provider = {
            id: 'a6',
            rows: [
                {
                    responsive: 'a6',
                    margin: 10,
                    cols: [left_provider, center_left_provider, center_right_provider, right_provider],
                },
                {
                    responsive: 'a6',
                    margin: 10,
                    cols: [
                        {
                            view: 'text',
                            id: 'NumRechazos',
                            name: 'NumRechazos',
                            type: 'number',
                            label: "<div class='tittle'>" + _('Número de rechazos permitidos') + '</div>',
                            labelPosition: 'top',
                            defaultValue: 0,
                        },
                        {
                            view: 'text',
                            id: 'NumRechazosDocument',
                            name: 'NumRechazosDocument',
                            type: 'number',
                            label: "<div class='tittle'>" + _('Número de rechazos por documento') + '</div>',
                            labelPosition: 'top',
                            defaultValue: 0,
                        },
                        {
                            view: 'text',
                            id: 'LevelName',
                            name: 'LevelName',
                            type: 'string',
                            label: "<div class='tittle'>" + _('Nivel Sumsub') + '</div>',
                            labelPosition: 'top',
                            defaultValue: 0,
                        },
                        {
                            view: 'combo',
                            name: 'ProviderSportbook',
                            minWidth: 200,
                            id: 'ProviderSportbook',
                            label: "<div class='tittle'>" + _('Proveedor de Sportbook') + '</div>',
                            labelPosition: 'top',
                            options: [
                                { id: 'ITN', value: 'Altenar' },
                                { id: 'DIGITAIN', value: 'Digitain' },
                            ],
                            placeholder: _('Click para seleccionar '),
                            defaultValue: 'ITN',
                        },
                    ],
                },
                {
                    view: 'label',
                    label: "<div class='tittle'>" + _('Mensajes de Verificación') + '</div>',
                },
                {
                    responsive: 'a6',
                    margin: 10,
                    cols: [
                        {
                            cols: [
                                { view: 'label', label: "<div class='tittle'>" + _('SMS') + '</div>' },
                                {
                                    id: 'IsActiveSms',
                                    view: 'switch',
                                    onLabel: _('Si'),
                                    offLabel: _('No'),
                                },
                            ],
                        },
                        {
                            cols: [
                                { view: 'label', label: "<div class='tittle'>" + _('Pop Up') + '</div>' },
                                {
                                    id: 'IsActivePopUp',
                                    view: 'switch',
                                    onLabel: _('Si'),
                                    offLabel: _('No'),
                                },
                            ],
                        },
                        {
                            cols: [
                                { view: 'label', label: "<div class='tittle'>" + _('Email') + '</div>' },
                                {
                                    id: 'IsActiveEmail',
                                    view: 'switch',
                                    onLabel: _('Si'),
                                    offLabel: _('No'),
                                },
                            ],
                        },
                        {
                            cols: [
                                { view: 'label', label: "<div class='tittle'>" + _('Inbox') + '</div>' },
                                {
                                    id: 'IsActiveInbox',
                                    view: 'switch',
                                    onLabel: _('Si'),
                                    offLabel: _('No'),
                                },
                            ],
                        },
                    ],
                },
                {
                    hidden: !devConfig.getPermAction('clearCharactersSwitch', 'Switch'), // Visibility of the ClearCharacters switch based on permissions.
                    margin: 5,
                    //New field for character normalization in identity validation.
                    rows: [
                        {
                            cols: [
                                {
                                    view: 'label',
                                    width: 430,
                                    label:
                                        "<div class='tittle'>" +
                                        _('Normalización de caracteres en validación de identidad') +
                                        '</div>' +
                                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                                        _(
                                            'Al activarse, elimina caracteres especiales de los datos de identidad antes de compararlos con proveedores externos',
                                        ) +
                                        '</span></div>',
                                },
                                {},
                            ],
                        },
                        {
                            cols: [
                                {
                                    css: 'centrar',
                                    id: 'ClearCharacters', // Unique identifier for the ClearCharacters switch.
                                    view: 'switch',
                                    width: 200,
                                    labelWidth: 55,
                                    onLabel: _('Activo'),
                                    offLabel: _('Inactivo'),
                                },
                                {},
                            ],
                        },
                    ],
                },
            ],
        };

        /**
         * Configuration object for the upper section of loyalty.
         * Contains an ID, margin, and an array of rows with columns.
         * @type {Object}
         */
        const upper_section_loyalty = {
            id: 'a6',
            rows: [
                {
                    responsive: 'a6',
                    margin: 10,
                    cols: [left_loyalty, center_left_loyalty, center_right_loyalty, right_loyalty, right2_loyalty],
                },
                {
                    view: 'combo',
                    name: 'LoyaltyTimeExpirationQualifyPoints',
                    id: 'LoyaltyTimeExpirationQualifyPoints',
                    label: _('Frecuencia de expiración de puntos calificables'),
                    labelPosition: 'top',
                    options: [
                        { id: 1, value: '1' },
                        { id: 2, value: '2' },
                        { id: 3, value: '3' },
                        { id: 4, value: '4' },
                        { id: 5, value: '5' },
                        { id: 6, value: '6' },
                        { id: 7, value: '7' },
                        { id: 8, value: '8' },
                        { id: 9, value: '9' },
                        { id: 10, value: '10' },
                        { id: 11, value: '11' },
                        { id: 12, value: '12' }
                    ],
                    placeholder: _('Click para seleccionar ')
                }
            ],
        };

        /**
         * Configuration object for the upper section of loyalty (alternative).
         * Contains an ID, margin, and an array of rows with columns.
         * @type {Object}
         */
        const upper_section_loyalty_ = {
            id: 'a6',
            rows: [
                {
                    responsive: 'a6',
                    margin: 10,
                    cols: [left_loyalty_, center_left_loyalty_, center_right_loyalty_, right_loyalty_],
                },
            ],
        };

        /**
         * Configuration object for the upper section of referrals.
         * Contains an ID, view type, and an array of rows.
         * @type {Object}
         */
        const upper_section_referrals = {
            id: 'refferalsSection',
            view: 'layout',
            rows: [
                {
                    view: 'form',
                    cols: [
                        {
                            maxWidth: 150,
                            cols: [
                                {
                                    view: 'form',
                                    rows: [
                                        {
                                            view: 'label',
                                            label: 'Activar referidos',
                                            css: {
                                                'text-align': 'center',
                                            },
                                        },
                                        {
                                            id: 'AcceptReferred',
                                            name: 'AcceptReferred',
                                            view: 'switch',
                                            onLabel: 'Si',
                                            offLabel: 'No',
                                            on: {
                                                onChange: function (newv, oldv) {
                                                    // Logic to handle changes in the referral activation switch
                                                    if (newv === 1) {
                                                        let awardsReferrals = devConfig.getAwardsReferrals();
                                                        if (awardsReferrals.length > 0) {
                                                            awardsReferrals.map(function (award) {
                                                                award.AwardName = $$(
                                                                    'AwardName' + award.AwardId,
                                                                ).getValue();
                                                                award.IsVerified =
                                                                    $$('IsVerified' + award.AwardId).getValue() === 1;
                                                                award.Conditions.map(function (condition) {
                                                                    let valor = $$(
                                                                        condition.Condition + award.AwardId,
                                                                    ).getValue();
                                                                    condition.Value = valor > 0 ? parseInt(valor) : '0';
                                                                });
                                                                let ofertedBonuses = $$(
                                                                    'OfertedBonuses' + award.AwardId,
                                                                ).getValue();
                                                                if (ofertedBonuses.length > 0) {
                                                                    ofertedBonuses = ofertedBonuses.split(',');
                                                                } else {
                                                                    ofertedBonuses = [];
                                                                }
                                                                award.OfertedBonuses = ofertedBonuses;
                                                            });
                                                        }
                                                        let conditionsReferrals = devConfig.getConditionsReferrals();
                                                        if (conditionsReferrals.length > 0) {
                                                            conditionsReferrals.map(function (condition) {
                                                                condition.Value = parseInt(
                                                                    $$(condition.Condition).getValue(),
                                                                );
                                                            });
                                                        }
                                                        let validateConditionsReferrals = conditionsReferrals.filter(
                                                            (condition) => {
                                                                return condition.Value > 0;
                                                            },
                                                        );
                                                        if ($$('UrlLanding').getValue() === '') {
                                                            webix.message({
                                                                text: _(
                                                                    'Debe agregar una url de landing para activar referidos',
                                                                ),
                                                                title: _('¡Mensaje!'),
                                                                type: 'alert-warning',
                                                            });
                                                            $$('AcceptReferred').setValue(0);
                                                        } else if (validateConditionsReferrals.length === 0) {
                                                            webix.message({
                                                                text: _(
                                                                    'Debe tener al menos una condición de referente con valor mayor a cero o requerir verificacion para activar referidos',
                                                                ),
                                                                title: _('¡Mensaje!'),
                                                                type: 'alert-warning',
                                                            });
                                                            $$('AcceptReferred').setValue(0);
                                                        } else if (
                                                            $$('ReferredMinSelValue').getValue() === '' ||
                                                            parseFloat($$('ReferredMinSelValue').getValue()) < 0
                                                        ) {
                                                            webix.message({
                                                                text: _(
                                                                    'Debe tener un valor mínimo de cuotas deportivas, mayor o igual a cero para activar referidos',
                                                                ),
                                                                title: _('¡Mensaje!'),
                                                                type: 'alert-warning',
                                                            });
                                                            $$('AcceptReferred').setValue(0);
                                                        } else if (awardsReferrals.length === 0) {
                                                            webix.message({
                                                                text: _(
                                                                    'Debe agregar al menos un premio para activar referidos',
                                                                ),
                                                                title: _('¡Mensaje!'),
                                                                type: 'alert-warning',
                                                            });
                                                            $$('AcceptReferred').setValue(0);
                                                        } else {
                                                            awardsReferrals.map(function (award) {
                                                                if (award.AwardName === '') {
                                                                    webix.message({
                                                                        text: _(
                                                                            'Los nombres de los premios no pueden estar vacios para activar referidos',
                                                                        ),
                                                                        title: _('¡Mensaje!'),
                                                                        type: 'alert-warning',
                                                                    });
                                                                    $$('AcceptReferred').setValue(0);
                                                                } else {
                                                                    let awardConditions = award.Conditions.filter(
                                                                        (condition) =>
                                                                            condition.Value !== '' &&
                                                                            condition.Value > 0,
                                                                    );
                                                                    if (
                                                                        awardConditions.length === 0 &&
                                                                        !award.IsVerified
                                                                    ) {
                                                                        webix.message({
                                                                            text: _(
                                                                                'Debe tener al menos una condición con valor mayor a cero o requerir verificacion en los premios para activar referidos',
                                                                            ),
                                                                            title: _('¡Mensaje!'),
                                                                            type: 'alert-warning',
                                                                        });
                                                                        $$('AcceptReferred').setValue(0);
                                                                    } else if (award.OfertedBonuses.length === 0) {
                                                                        webix.message({
                                                                            text: _(
                                                                                'Debe agregar al menos un bono en los premios para activar referidos',
                                                                            ),
                                                                            title: _('¡Mensaje!'),
                                                                            type: 'alert-warning',
                                                                        });
                                                                        $$('AcceptReferred').setValue(0);
                                                                    }
                                                                }
                                                            });
                                                        }
                                                    }
                                                },
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            rows: [
                                {
                                    view: 'label',
                                    label: 'URL Landing',
                                    css: {
                                        'text-align': 'center',
                                    },
                                },
                                {
                                    view: 'text',
                                    name: 'UrlLanding',
                                    id: 'UrlLanding',
                                    placeholder: 'URL',
                                    invalidMessage: 'Campo Requerido',
                                    validate: function (value) {
                                        try {
                                            const url = new URL(value);
                                            return url.protocol === 'http:' || url.protocol === 'https:';
                                        } catch (e) {
                                            return false;
                                        }
                                    }
                                },
                            ],
                        },
                        {
                            id: 'ElementsReferralConditionBet',
                            maxWidth: 500,
                            rows: [
                                {
                                    view: 'label',
                                    label:
                                        "<div class='tittle'>" +
                                        _('Cuota mínima en apuestas deportivas para el desbloqueo de la recompensa') +
                                        '</div>',
                                },
                                {
                                    id: 'ElementsReferralConditionBetItems',
                                    margin: 10,
                                    rows: [
                                        {
                                            view: 'text',
                                            name: 'ReferredMinSelValue',
                                            id: 'ReferredMinSelValue',
                                            type: 'float',
                                            placeholder: 'Valor',
                                            invalidMessage: 'Campo Requerido',
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
                {
                    view: 'form',
                    cols: [
                        {
                            rows: [
                                {
                                    view: 'label',
                                    label:
                                        "<div class='tittle'>" +
                                        _('Limite de días para selección de recompensa - Referente') +
                                        '</div>',
                                },
                                {
                                    id: 'AwardLimitRedemptionDayReferentItem',
                                    margin: 10,
                                    rows: [
                                        {
                                            view: 'text',
                                            name: 'AwardLimitRedemptionDayReferent',
                                            id: 'AwardLimitRedemptionDayReferent',
                                            type: 'number',
                                            placeholder: 'Valor',
                                            invalidMessage: 'Campo Requerido',
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            rows: [
                                {
                                    view: 'label',
                                    label:
                                        "<div class='tittle'>" +
                                        _('Límite días para cumplimiento de condiciones - Referido') +
                                        '</div>',
                                },
                                {
                                    id: 'AwardLimitFulfillmentDayReferredItem',
                                    margin: 10,
                                    rows: [
                                        {
                                            view: 'text',
                                            name: 'AwardLimitFulfillmentDayReferred',
                                            id: 'AwardLimitFulfillmentDayReferred',
                                            type: 'number',
                                            placeholder: 'Valor',
                                            invalidMessage: 'Campo Requerido',
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
                {
                    cols: [
                        {
                            id: 'ElementsReferralConditions',
                            rows: [
                                {
                                    view: 'label',
                                    label: "<div class='tittle'>" + _('Condiciones de Referente') + '</div>',
                                    css: {
                                        'background-color': '#DADEE0',
                                        color: '#313131',
                                        'text-align': 'center',
                                    },
                                },
                                {
                                    id: 'ElementsReferralConditionsItems',
                                    margin: 10,
                                    view: 'form',
                                    rows: [],
                                },
                            ],
                        },
                    ],
                },
                {
                    margin: 10,
                    cols: [
                        {
                            id: 'ElementsReferralCategories',
                            rows: [
                                {
                                    view: 'label',
                                    label:
                                        "<div class='tittle'>" +
                                        '<span><strong>' +
                                        _(
                                            'Exclusión de categorías en apuestas de casino para el desbloqueo de la recompensa: ',
                                        ) +
                                        '</strong>' +
                                        _('Mover los elementos de la casilla todas a la casilla de excluidos.') +
                                        '</span>' +
                                        '</div>',
                                    css: {
                                        color: '#313131',
                                        'text-align': 'center',
                                    },
                                },
                                {
                                    id: 'ElementsReferralCategoriesItems',
                                    margin: 10,
                                    view: 'form',
                                    rows: [
                                        {
                                            margin: 10,
                                            view: 'dbllist',
                                            name: 'ExcludedCategoriesMinBetReferred',
                                            id: 'ExcludedCategoriesMinBetReferred',
                                            list: { height: 180, margin: 10 },
                                            labelLeft: 'Todas',
                                            labelRight: 'Excluidas',
                                            css: 'webix_dbllist2',
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'ElementsReferralsAward',
                    margin: 10,
                    rows: [
                        {
                            view: 'form',
                            cols: [
                                {},
                                {
                                    id: 'addAwardButtons',
                                    cols: [
                                        {
                                            view: 'button',
                                            css: 'webix_primary2',
                                            value: _('Agregar recompensa por primer deposito'),
                                            click: () => {
                                                // Logic to add a new award for the first deposit
                                                if (devConfig.getAwardsReferrals().length === 0) {
                                                    $$('ElementsReferralsAward').removeView('ReferralsAwardItems');
                                                    $$('ElementsReferralsAward').addView({
                                                        id: 'ReferralsAwardItems',
                                                        margin: 10,
                                                        view: 'layout',
                                                        rows: [],
                                                    });
                                                }
                                                let id = Math.floor(Math.random() * 10000);
                                                let awards = devConfig.getAwardsReferrals();
                                                let newAward = {
                                                    AwardId: id,
                                                    AwardName: '',
                                                    IsVerified: 0,
                                                    Type: 1,
                                                    IsNew: true,
                                                    Conditions: [
                                                        {
                                                            Label: 'Mínimo primer depósito',
                                                            Condition: 'CONDMINFIRSTDEPOSITREFERRED',
                                                            Value: '0',
                                                        },
                                                    ],
                                                    OfertedBonuses: [],
                                                };
                                                awards.push(newAward);
                                                devConfig.setAwardsReferrals(awards);
                                                if (awards.length > 2) {
                                                    $$('addAwardButtons').hide();
                                                } else {
                                                    $$('addAwardButtons').show();
                                                }
                                                let conditionsElements = [];
                                                newAward.Conditions.map((condition) => {
                                                    conditionsElements.push({
                                                        rows: [
                                                            { view: 'label', label: condition.Label },
                                                            {
                                                                view: 'text',
                                                                name: condition.Condition + id,
                                                                id: condition.Condition + id,
                                                                type: 'number',
                                                                placeholder: 'Valor',
                                                                invalidMessage: 'Campo Requerido',
                                                                value: condition.Value,
                                                            },
                                                        ],
                                                    });
                                                });
                                                conditionsElements.push({
                                                    cols: [
                                                        {},
                                                        {},
                                                        {},
                                                        {
                                                            rows: [
                                                                {
                                                                    view: 'label',
                                                                    label: 'Cuenta verificada',
                                                                    css: { 'text-align': 'center' },
                                                                },
                                                                {
                                                                    id: 'IsVerified' + id,
                                                                    name: 'IsVerified' + id,
                                                                    view: 'switch',
                                                                    onLabel: 'Si',
                                                                    offLabel: 'No',
                                                                    value: newAward.IsVerified,
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                });
                                                $$('ReferralsAwardItems').addView({
                                                    view: 'form',
                                                    id: 'Award' + id,
                                                    margin: 10,
                                                    rows: [
                                                        {
                                                            cols: [
                                                                {
                                                                    view: 'text',
                                                                    name: 'AwardName' + id,
                                                                    id: 'AwardName' + id,
                                                                    label: 'Nombre de recompensa',
                                                                    labelPosition: 'top',
                                                                    placeholder: 'Nombre',
                                                                    invalidMessage: 'Campo Requerido',
                                                                },
                                                                {
                                                                    cols: [
                                                                        {},
                                                                        {},
                                                                        {},
                                                                        {
                                                                            view: 'button',
                                                                            label: 'Eliminar',
                                                                            css: 'webix_danger2',
                                                                            backgroundColor: '#FF5C4C',
                                                                            click: function () {
                                                                                // Logic to remove an award
                                                                                let awards =
                                                                                    devConfig.getAwardsReferrals();
                                                                                awards = awards.filter(function (item) {
                                                                                    return item.AwardId !== id;
                                                                                });
                                                                                devConfig.setAwardsReferrals(awards);
                                                                                if (awards.length > 2) {
                                                                                    $$('addAwardButtons').hide();
                                                                                } else {
                                                                                    $$('addAwardButtons').show();
                                                                                }
                                                                                $$('ReferralsAwardItems').removeView(
                                                                                    'Award' + id,
                                                                                );
                                                                                if (
                                                                                    $$(
                                                                                        'ReferralsAwardItems',
                                                                                    ).getChildViews().length === 0
                                                                                ) {
                                                                                    $$(
                                                                                        'ElementsReferralsAward',
                                                                                    ).removeView('ReferralsAwardItems');
                                                                                    $$(
                                                                                        'ElementsReferralsAward',
                                                                                    ).addView({
                                                                                        id: 'ReferralsAwardItems',
                                                                                        margin: 10,
                                                                                        view: 'form',
                                                                                        rows: [
                                                                                            {
                                                                                                view: 'label',
                                                                                                label: 'No hay premios agregados',
                                                                                                css: {
                                                                                                    'text-align':
                                                                                                        'center',
                                                                                                },
                                                                                            },
                                                                                        ],
                                                                                    });
                                                                                }
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                        {
                                                            minWidth: 200,
                                                            margin: 10,
                                                            cols: conditionsElements,
                                                        },
                                                        {
                                                            margin: 10,
                                                            rows: [
                                                                {
                                                                    view: 'label',
                                                                    label: _('Bonos'),
                                                                },
                                                                {
                                                                    view: 'label',
                                                                    template:
                                                                        "<img src='https://images.virtualsoft.tech/m/msj0212T1708977286.png' alt=''>" +
                                                                        '<span>' +
                                                                        _(
                                                                            'Mueve los elementos a la categoría requerida.',
                                                                        ) +
                                                                        '</span>',
                                                                    css: {
                                                                        color: '#313131',
                                                                        'text-align': 'center',
                                                                        display: 'flex',
                                                                        'align-items': 'center',
                                                                        'justify-content': 'center',
                                                                        gap: '10px',
                                                                    },
                                                                },
                                                                {
                                                                    view: 'dbllist',
                                                                    name: 'OfertedBonuses' + id,
                                                                    id: 'OfertedBonuses' + id,
                                                                    list: { height: 180 },
                                                                    labelLeft: 'Disponibles',
                                                                    labelRight: 'Seleccionados',
                                                                    data: webix.storage.local.get('bonusReferrals'),
                                                                    value: newAward.OfertedBonuses.toString(),
                                                                    css: 'webix_dbllist2',
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                });
                                            },
                                        },
                                        {
                                            view: 'button',
                                            css: 'webix_primary2',
                                            value: _('Agregar recompensa por apuesta'),
                                            click: () => {
                                                // Logic to add a new award for bets
                                                if (devConfig.getAwardsReferrals().length === 0) {
                                                    $$('ElementsReferralsAward').removeView('ReferralsAwardItems');
                                                    $$('ElementsReferralsAward').addView({
                                                        id: 'ReferralsAwardItems',
                                                        margin: 10,
                                                        view: 'layout',
                                                        rows: [],
                                                    });
                                                }
                                                let id = Math.floor(Math.random() * 100000);
                                                let awards = devConfig.getAwardsReferrals();
                                                let newAward = {
                                                    AwardId: id,
                                                    AwardName: '',
                                                    IsVerified: 0,
                                                    Type: 2,
                                                    IsNew: true,
                                                    Conditions: [
                                                        {
                                                            Label: 'Mínimo apuestas',
                                                            Condition: 'CONDMINBETREFERRED',
                                                            Value: '0',
                                                        },
                                                    ],
                                                    OfertedBonuses: [],
                                                };
                                                awards.push(newAward);
                                                devConfig.setAwardsReferrals(awards);
                                                if (awards.length > 2) {
                                                    $$('addAwardButtons').hide();
                                                } else {
                                                    $$('addAwardButtons').show();
                                                }
                                                let conditionsElements = [];
                                                newAward.Conditions.map((condition) => {
                                                    conditionsElements.push({
                                                        rows: [
                                                            { view: 'label', label: condition.Label },
                                                            {
                                                                view: 'text',
                                                                name: condition.Condition + id,
                                                                id: condition.Condition + id,
                                                                type: 'number',
                                                                placeholder: 'Valor',
                                                                invalidMessage: 'Campo Requerido',
                                                                value: condition.Value,
                                                            },
                                                        ],
                                                    });
                                                });
                                                conditionsElements.push({
                                                    cols: [
                                                        {},
                                                        {},
                                                        {},
                                                        {
                                                            rows: [
                                                                {
                                                                    view: 'label',
                                                                    label: 'Cuenta verificada',
                                                                    css: { 'text-align': 'center' },
                                                                },
                                                                {
                                                                    id: 'IsVerified' + id,
                                                                    name: 'IsVerified' + id,
                                                                    view: 'switch',
                                                                    onLabel: 'Si',
                                                                    offLabel: 'No',
                                                                    value: newAward.IsVerified,
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                });
                                                $$('ReferralsAwardItems').addView({
                                                    view: 'form',
                                                    id: 'Award' + id,
                                                    margin: 10,
                                                    rows: [
                                                        {
                                                            cols: [
                                                                {
                                                                    view: 'text',
                                                                    name: 'AwardName' + id,
                                                                    id: 'AwardName' + id,
                                                                    label: 'Nombre de recompensa',
                                                                    labelPosition: 'top',
                                                                    placeholder: 'Nombre',
                                                                    invalidMessage: 'Campo Requerido',
                                                                },
                                                                {
                                                                    cols: [
                                                                        {},
                                                                        {},
                                                                        {},
                                                                        {
                                                                            view: 'button',
                                                                            label: 'Eliminar',
                                                                            css: 'webix_danger2',
                                                                            click: function () {
                                                                                // Logic to remove an award
                                                                                let awards =
                                                                                    devConfig.getAwardsReferrals();
                                                                                awards = awards.filter(function (item) {
                                                                                    return item.AwardId !== id;
                                                                                });
                                                                                devConfig.setAwardsReferrals(awards);
                                                                                if (awards.length > 2) {
                                                                                    $$('addAwardButtons').hide();
                                                                                } else {
                                                                                    $$('addAwardButtons').show();
                                                                                }
                                                                                $$('ReferralsAwardItems').removeView(
                                                                                    'Award' + id,
                                                                                );
                                                                                if (
                                                                                    $$(
                                                                                        'ReferralsAwardItems',
                                                                                    ).getChildViews().length === 0
                                                                                ) {
                                                                                    $$(
                                                                                        'ElementsReferralsAward',
                                                                                    ).removeView('ReferralsAwardItems');
                                                                                    $$(
                                                                                        'ElementsReferralsAward',
                                                                                    ).addView({
                                                                                        id: 'ReferralsAwardItems',
                                                                                        margin: 10,
                                                                                        view: 'form',
                                                                                        rows: [
                                                                                            {
                                                                                                view: 'label',
                                                                                                label: 'No hay premios agregados',
                                                                                                css: {
                                                                                                    'text-align':
                                                                                                        'center',
                                                                                                },
                                                                                            },
                                                                                        ],
                                                                                    });
                                                                                }
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                        {
                                                            minWidth: 200,
                                                            margin: 10,
                                                            cols: conditionsElements,
                                                        },
                                                        {
                                                            margin: 10,
                                                            rows: [
                                                                {
                                                                    view: 'label',
                                                                    label: _('Bonos'),
                                                                },
                                                                {
                                                                    view: 'label',
                                                                    template:
                                                                        "<img src='https://images.virtualsoft.tech/m/msj0212T1708977286.png' alt=''>" +
                                                                        '<span>' +
                                                                        _(
                                                                            'Mueve los elementos a la categoría requerida.',
                                                                        ) +
                                                                        '</span>',
                                                                    css: {
                                                                        color: '#313131',
                                                                        'text-align': 'center',
                                                                        display: 'flex',
                                                                        'align-items': 'center',
                                                                        'justify-content': 'center',
                                                                        gap: '10px',
                                                                    },
                                                                },
                                                                {
                                                                    view: 'dbllist',
                                                                    name: 'OfertedBonuses' + id,
                                                                    id: 'OfertedBonuses' + id,
                                                                    list: { height: 180 },
                                                                    labelLeft: 'Disponibles',
                                                                    labelRight: 'Seleccionados',
                                                                    data: webix.storage.local.get('bonusReferrals'),
                                                                    value: newAward.OfertedBonuses.toString(),
                                                                    css: 'webix_dbllist2',
                                                                },
                                                            ],
                                                        },
                                                        {
                                                            view: 'label',
                                                            label: "<div class='tittle'>" + _('Recompensas') + '</div>',
                                                            css: {
                                                                'background-color': '#DADEE0',
                                                                color: '#313131',
                                                                'text-align': 'center',
                                                            },
                                                        },
                                                    ],
                                                });
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            view: 'label',
                            label: "<div class='tittle'>" + _('Recompensas') + '</div>',
                            css: {
                                'background-color': '#DADEE0',
                                color: '#313131',
                                'text-align': 'center',
                            },
                        },
                        {
                            id: 'ReferralsAwardItems',
                            margin: 10,
                            view: 'layout',
                            rows: [],
                        },
                    ],
                },
                {
                    id: 'RewardsDeliverySection',
                    margin: 10,
                    rows: [
                        {
                            view: 'label',
                            label:
                                "<div class='tittle'>" + _('Método de envio invitación programa referidos') + '</div>',
                            css: {
                                'background-color': '#DADEE0',
                                color: '#313131',
                                'text-align': 'center',
                            },
                        },
                        {
                            view: 'label',
                            label: '<div class="tittle">' + _('Canales de envío permitidos') + '</div>',
                        },
                        {
                            id: 'IsReferralEmailEnabled', // Unique identifier for the email referral switch
                            view: 'switch', // Specifies the type of view as a switch
                            labelWidth: 200, // Sets the width of the label
                            label: _('Envío por correo electrónico'), // Label text for the switch
                            onLabel: _('Activo'), // Text displayed when the switch is on
                            offLabel: _('Inactivo'), // Text displayed when the switch is off
                        },
                        {
                            id: 'IsReferralLinkEnabled', // Unique identifier for the link referral switch
                            view: 'switch', // Specifies the type of view as a switch
                            labelWidth: 200, // Sets the width of the label
                            label: _('Envío por enlace/código'), // Label text for the switch
                            onLabel: _('Activo'), // Text displayed when the switch is on
                            offLabel: _('Inactivo'), // Text displayed when the switch is off
                            value: 1, // Default value for the switch (1 = on)
                            disabled: true, // Makes the switch non-interactive
                            readonly: true, // Prevents the switch from being modified
                            css: 'switch-disabled', // CSS class for styling the disabled switch
                        },
                    ],
                },
            ],
        };

        /**
         * Configuration object for the upper section of verticals.
         * Contains an ID, margin, and an array of rows.
         * @type {Object}
         */
        const upper_section_verticals = {
            id: 'verticalsSection',
            margin: 10,
            view: 'layout',
            rows: [
                {
                    view: 'form',
                    margin: 10,
                    css: 'on-row',
                    rows: [
                        {
                            view: 'form',
                            id: 'a6',
                            rows: [
                                {
                                    view: 'combo',
                                    label: "<div class='tittle'>" + _('Tipo de perfil') + '</div>',
                                    labelPosition: 'top',
                                    options: [
                                        { id: '1', value: _('Usuarios online') },
                                        { id: '2', value: _('Puntos de venta') },
                                        { id: '3', value: _('Cajeros') },
                                    ],
                                    value: '1',
                                    placeholder: _('Click para seleccionar '),
                                    on: {
                                        onChange: function (newv, oldv) {
                                            // Logic to show/hide sections based on selected profile type
                                            if (newv === '1') {
                                                $$('a79').show();
                                                $$('a80').hide();
                                                $$('a81').hide();
                                            } else if (newv === '2') {
                                                $$('a79').hide();
                                                $$('a80').show();
                                                $$('a81').hide();
                                            } else if (newv === '3') {
                                                $$('a79').hide();
                                                $$('a80').hide();
                                                $$('a81').show();
                                            }
                                        },
                                    },
                                },
                            ],
                        },
                        {
                            margin: 10,
                            css: 'on-row',
                            view: 'form',
                            id: 'a79',
                            batch: 'Usuarios online',
                            rows: [
                                {
                                    view: 'label',
                                    label: "<div class='tittle'>" + _('Usuarios online') + '</div>',
                                },
                                {
                                    cols: [
                                        {
                                            view: 'form',
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                            rows: [
                                                {
                                                    view: 'label',
                                                    label: _('Apuestas deportivas'),
                                                },
                                                {
                                                    id: 'SportsBetsUserOnline',
                                                    view: 'switch',
                                                    labelWidth: 50,
                                                    onLabel: _('Si'),
                                                    offLabel: _('No'),
                                                },
                                            ],
                                        },
                                        {
                                            view: 'form',
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                            rows: [
                                                { view: 'label', label: _('Apuestas de casino') },
                                                {
                                                    id: 'CasinoBetsUserOnline',
                                                    view: 'switch',
                                                    labelWidth: 50,
                                                    onLabel: _('Si'),
                                                    offLabel: _('No'),
                                                },
                                            ],
                                        },
                                        {
                                            view: 'form',
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                            rows: [
                                                { view: 'label', label: _('Casino en vivo') },
                                                {
                                                    id: 'LiveCasinoUserOnline',
                                                    view: 'switch',
                                                    labelWidth: 50,
                                                    onLabel: _('Si'),
                                                    offLabel: _('No'),
                                                },
                                            ],
                                        },
                                        {
                                            view: 'form',
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                            rows: [
                                                { view: 'label', label: _('Apuestas virtuales') },
                                                {
                                                    id: 'VirtualBetsUserOnline',
                                                    view: 'switch',
                                                    labelWidth: 50,
                                                    onLabel: _('Si'),
                                                    offLabel: _('No'),
                                                },
                                            ],
                                        },
                                    ],
                                },
                                {
                                    cols: [
                                        {
                                            view: 'form',
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                            rows: [
                                                { view: 'label', label: _('Poker') },
                                                {
                                                    id: 'PokerUserOnline',
                                                    view: 'switch',
                                                    labelWidth: 50,
                                                    onLabel: _('Si'),
                                                    offLabel: _('No'),
                                                },
                                            ],
                                        },
                                        {
                                            view: 'form',
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                            rows: [
                                                {
                                                    view: 'label',
                                                    label: _('Creación de notas de retiro'),
                                                },
                                                {
                                                    id: 'RetirementNotesUserOnline',
                                                    view: 'switch',
                                                    labelWidth: 50,
                                                    onLabel: _('Si'),
                                                    offLabel: _('No'),
                                                },
                                            ],
                                        },
                                        {
                                            view: 'form',
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                            rows: [
                                                { view: 'label', label: _('Depositar') },
                                                {
                                                    id: 'DepositUserOnline',
                                                    view: 'switch',
                                                    labelWidth: 50,
                                                    onLabel: _('Si'),
                                                    offLabel: _('No'),
                                                },
                                            ],
                                        },
                                        {
                                            view: 'form',
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                            rows: [
                                                { view: 'label', label: _('Hípicas') },
                                                {
                                                    id: 'HipicaUserOnline',
                                                    view: 'switch',
                                                    labelWidth: 50,
                                                    onLabel: _('Si'),
                                                    offLabel: _('No'),
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            margin: 10,
                            css: 'on-row',
                            view: 'form',
                            id: 'a80',
                            batch: 'Puntos de venta',
                            hidden: true,
                            rows: [
                                {
                                    view: 'label',
                                    label: "<div class='tittle'>" + _('Punto de venta') + '</div>',
                                },
                                {
                                    cols: [
                                        {
                                            view: 'form',
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                            rows: [
                                                {
                                                    view: 'label',
                                                    label: _('Apuestas deportivas'),
                                                },
                                                {
                                                    id: 'SportsBetsPv',
                                                    view: 'switch',
                                                    labelWidth: 50,
                                                    onLabel: _('Si'),
                                                    offLabel: _('No'),
                                                },
                                            ],
                                        },
                                        {
                                            view: 'form',
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                            rows: [
                                                {
                                                    view: 'label',
                                                    label: _('Pago de notas de retiro'),
                                                },
                                                {
                                                    id: 'PayRetirementNotesPv',
                                                    view: 'switch',
                                                    labelWidth: 50,
                                                    onLabel: _('Si'),
                                                    offLabel: _('No'),
                                                },
                                            ],
                                        },
                                        {
                                            view: 'form',
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                            rows: [
                                                { view: 'label', label: _('Venta de depósitos') },
                                                {
                                                    id: 'PayDepositPv',
                                                    view: 'switch',
                                                    labelWidth: 50,
                                                    onLabel: _('Si'),
                                                    offLabel: _('No'),
                                                },
                                            ],
                                        },
                                        {
                                            view: 'form',
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                            rows: [
                                                { view: 'label', label: _('Pago de premios') },
                                                {
                                                    id: 'PayAwardsPv',
                                                    view: 'switch',
                                                    labelWidth: 50,
                                                    onLabel: _('Si'),
                                                    offLabel: _('No'),
                                                },
                                            ],
                                        },
                                        {
                                            view: 'form',
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                            rows: [
                                                {
                                                    view: 'label',
                                                    label: _('Virtuales (Golden race y kiron)'),
                                                },
                                                {
                                                    id: 'VirtualBetsPv',
                                                    view: 'switch',
                                                    labelWidth: 50,
                                                    onLabel: _('Si'),
                                                    offLabel: _('No'),
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            margin: 10,
                            css: 'on-row',
                            view: 'form',
                            id: 'a81',
                            batch: 'Cajeros',
                            hidden: true,
                            rows: [
                                {
                                    view: 'label',
                                    label: "<div class='tittle'>" + _('Cajeros') + '</div>',
                                },
                                {
                                    cols: [
                                        {
                                            view: 'form',
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                            rows: [
                                                {
                                                    view: 'label',
                                                    label: _('Apuestas deportivas'),
                                                },
                                                {
                                                    id: 'SportsBetsAtm',
                                                    view: 'switch',
                                                    labelWidth: 50,
                                                    onLabel: _('Si'),
                                                    offLabel: _('No'),
                                                },
                                            ],
                                        },
                                        {
                                            view: 'form',
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                            rows: [
                                                {
                                                    view: 'label',
                                                    label: _('Pago de notas de retiro'),
                                                },
                                                {
                                                    id: 'PayRetirementNotesAtm',
                                                    view: 'switch',
                                                    labelWidth: 50,
                                                    onLabel: _('Si'),
                                                    offLabel: _('No'),
                                                },
                                            ],
                                        },
                                        {
                                            view: 'form',
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                            rows: [
                                                { view: 'label', label: _('Venta de depósitos') },
                                                {
                                                    id: 'PayDepositAtm',
                                                    view: 'switch',
                                                    labelWidth: 50,
                                                    onLabel: _('Si'),
                                                    offLabel: _('No'),
                                                },
                                            ],
                                        },
                                        {
                                            view: 'form',
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                            rows: [
                                                { view: 'label', label: _('Pago de premios') },
                                                {
                                                    id: 'PayAwardsAtm',
                                                    view: 'switch',
                                                    labelWidth: 50,
                                                    onLabel: _('Si'),
                                                    offLabel: _('No'),
                                                },
                                            ],
                                        },
                                        {
                                            view: 'form',
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                            rows: [
                                                {
                                                    view: 'label',
                                                    label: _('Virtuales (Golden race y kiron)'),
                                                },
                                                {
                                                    id: 'VirtualBetsAtm',
                                                    view: 'switch',
                                                    labelWidth: 50,
                                                    onLabel: _('Si'),
                                                    offLabel: _('No'),
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
                {
                    view: 'form',
                    margin: 10,
                    css: 'on-row',
                    rows: [
                        {
                            view: 'label',
                            label: "<div class='tittle'>" + _('Verificar celular') + '</div>',
                        },
                        {
                            margin: 0,
                            css: 'on-row',
                            id: 'a6',
                            cols: [
                                {
                                    view: 'form',
                                    css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                    rows: [
                                        { view: 'label', label: _('Depositar') },
                                        {
                                            id: 'DepositPhoneVerification',
                                            view: 'switch',
                                            labelWidth: 50,
                                            onLabel: _('Si'),
                                            offLabel: _('No'),
                                        },
                                    ],
                                },
                                {
                                    view: 'form',
                                    css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                    rows: [
                                        { view: 'label', label: _('Apuestas deportivas') },
                                        {
                                            id: 'SportBetsPhoneVerification',
                                            view: 'switch',
                                            labelWidth: 50,
                                            onLabel: _('Si'),
                                            offLabel: _('No'),
                                        },
                                    ],
                                },
                                {
                                    view: 'form',
                                    css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                    rows: [
                                        { view: 'label', label: _('Apuestas de casino') },
                                        {
                                            id: 'CasinoBetsPhoneVerification',
                                            view: 'switch',
                                            labelWidth: 50,
                                            onLabel: _('Si'),
                                            offLabel: _('No'),
                                        },
                                    ],
                                },
                                {
                                    view: 'form',
                                    css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                    rows: [
                                        { view: 'label', label: _('Retiros') },
                                        {
                                            id: 'WithdrawalPhoneVerification',
                                            view: 'switch',
                                            labelWidth: 50,
                                            onLabel: _('Si'),
                                            offLabel: _('No'),
                                        },
                                    ],
                                },
                                {
                                    view: 'form',
                                    css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                    rows: [
                                        { view: 'label', label: _('Casino en vivo') },
                                        {
                                            id: 'LiveCasinoPhoneVerification',
                                            view: 'switch',
                                            labelWidth: 50,
                                            onLabel: _('Si'),
                                            offLabel: _('No'),
                                        },
                                    ],
                                },
                                {
                                    view: 'form',
                                    css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                    rows: [
                                        { view: 'label', label: _('Virtuales') },
                                        {
                                            id: 'VirtualPhoneVerification',
                                            view: 'switch',
                                            labelWidth: 50,
                                            onLabel: _('Si'),
                                            offLabel: _('No'),
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
            ],
        };

        /**
         * Configuration object for the upper section of landing bonuses.
         * @type {Object}
         */
        const upper_section_landingBonuses = {
            id: 'landingBonusesSection',
            margin: 10,
            view: 'layout',
            rows: [
                {
                    view: 'form',
                    rows: [
                        {
                            view: 'label',
                            label: "<div class='tittle'>" + _('FreeBet') + '</div>',
                            css: {
                                'background-color': '#DADEE0',
                                color: '#313131',
                                'text-align': 'center',
                            },
                        },
                        {
                            margin: 10,
                            id: 'ElementsLandingBonusesFreeBetItems',
                            view: 'form',
                            rows: [
                                {
                                    margin: 10,
                                    view: 'dbllist',
                                    name: 'LandingFreeBetBonuses',
                                    id: 'LandingFreeBetBonuses',
                                    list: { height: 200, margin: 10 },
                                    labelLeft: 'Todos los bonos',
                                    labelRight: 'Bono seleccionado',
                                    css: 'webix_dbllist2',
                                    buttons:
                                        "<button class='dbllist_button' action='select_one' style='width:100%; margin-right:0;'>Select</button><button class='dbllist_button' action='deselect_one' style='width:100%;margin-left:0;'>Remove</button>",
                                },
                            ],
                        },
                    ],
                },
                {
                    view: 'form',
                    rows: [
                        {
                            view: 'label',
                            label: "<div class='tittle'>" + _('FreeCasino') + '</div>',
                            css: {
                                'background-color': '#DADEE0',
                                color: '#313131',
                                'text-align': 'center',
                            },
                        },
                        {
                            margin: 10,
                            id: 'ElementsLandingBonusesFreeCasinoItems',
                            view: 'form',
                            rows: [
                                {
                                    margin: 10,
                                    view: 'dbllist',
                                    name: 'LandingFreeCasinoBonuses',
                                    id: 'LandingFreeCasinoBonuses',
                                    list: { height: 200, margin: 10 },
                                    labelLeft: 'Todos los bonos',
                                    labelRight: 'Bono seleccionado',
                                    css: 'webix_dbllist2',
                                    buttons:
                                        "<button class='dbllist_button' action='select_one' style='width:100%; margin-right:0;'>Select</button><button class='dbllist_button' action='deselect_one' style='width:100%;margin-left:0;'>Remove</button>",
                                },
                            ],
                        },
                    ],
                },
            ],
        };

        /**
         * Configuration object for the upper section of birthday bonuses.
         * @type {Object}
         */
        const upper_section_birthdayBonuses = {
            id: 'birthdayBonusesSection',
            margin: 10,
            view: 'form',
            rows: [
                {
                    view: 'label',
                    label: '<div class="tittle">' + _('Bono de cumpleaños') + '</div>',
                    css: {
                        'background-color': '#DADEE0',
                        color: '#313131',
                        'text-align': 'center',
                    },
                },
                {
                    margin: 10,
                    id: 'ElementsBirthdayBonusesItems',
                    view: 'form',
                    rows: [
                        {
                            margin: 10,
                            view: 'dbllist',
                            name: 'TotalityBirthday',
                            id: 'TotalityBirthday',
                            list: { height: 200, margin: 10 },
                            labelLeft: 'Todos los bonos',
                            labelRight: 'Bono seleccionado',
                            css: 'webix_dbllist2',
                            buttons: `
                        <button class="dbllist_button" action="select_one" style="width:100%; margin-right:0;">Select</button>
                        <button class="dbllist_button" action="deselect_one" style="width:100%; margin-left:0;">Remove</button>
                    `,
                        },
                    ],
                },
            ],
        };

        /**
         * Configuration object for the upper section of commission.
         * Contains an ID, margin, and an array of rows.
         * @type {Object}
         */
        const upper_section_commission = {
            id: 'commissionSection',
            margin: 10,
            view: 'layout',
            rows: [
                {
                    view: 'form', // Form view for the commission section
                    margin: 10,
                    css: 'on-row', // CSS class for styling
                    rows: [
                        {
                            view: 'form', // Nested form for profile type selection
                            id: 'a20',
                            rows: [
                                {
                                    view: 'combo', // Dropdown for selecting profile type
                                    label: "<div class='tittle'>" + _('Tipo de perfil') + '</div>', // Label for the dropdown
                                    labelPosition: 'top', // Position of the label
                                    options: [
                                        // Options for the dropdown
                                        { id: '1', value: _('Concesionario') },
                                        { id: '2', value: _('Operadores') },
                                        { id: '3', value: _('Punto de venta') },
                                        { id: '4', value: _('Afiliador') },
                                    ],
                                    value: '1', // Default selected value
                                    placeholder: _('Click para seleccionar '), // Placeholder text
                                    on: {
                                        onChange: function (newv, oldv) {
                                            // Event handler for dropdown change
                                            if (newv === '1') {
                                                $$('a69').show(); // Show Concesionario section
                                                $$('a70').hide(); // Hide Operadores section
                                                $$('a71').hide(); // Hide Punto de venta section
                                                $$('a72').hide(); // Hide Afiliador section
                                            } else if (newv === '2') {
                                                $$('a69').hide(); // Hide Concesionario section
                                                $$('a70').show(); // Show Operadores section
                                                $$('a71').hide(); // Hide Punto de venta section
                                                $$('a72').hide(); // Hide Afiliador section
                                            } else if (newv === '3') {
                                                $$('a69').hide(); // Hide Concesionario section
                                                $$('a70').hide(); // Hide Operadores section
                                                $$('a71').show(); // Show Punto de venta section
                                                $$('a72').hide(); // Hide Afiliador section
                                            } else if (newv === '4') {
                                                $$('a69').hide(); // Hide Concesionario section
                                                $$('a70').hide(); // Hide Operadores section
                                                $$('a71').hide(); // Hide Punto de venta section
                                                $$('a72').show(); // Show Afiliador section
                                            }
                                        },
                                    },
                                },
                            ],
                        },
                        {
                            margin: 10,
                            css: 'on-row', // CSS class for styling
                            view: 'form', // Form view for Concesionario details
                            id: 'a69',
                            batch: 'Concesionario', // Batch identifier for grouping
                            rows: [
                                {
                                    view: 'label', // Label for the Concesionario section
                                    label: "<div class='tittle'>" + _('Concesionario') + '</div>',
                                },
                                {
                                    cols: [
                                        // Columns for layout of input fields
                                        {
                                            view: 'form', // Form for Sportbook GGR Punto de venta IP
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                            rows: [
                                                {
                                                    view: 'label', // Label for the input field
                                                    label: _('Sportbook GGR Punto de venta IP'),
                                                },
                                                {
                                                    id: 'IsSportbookGgrPvIpConcessionaire', // ID for the switch
                                                    view: 'switch', // Switch for enabling/disabling
                                                    labelWidth: 50, // Width of the label
                                                    onLabel: _('Si'), // Label when switch is on
                                                    offLabel: _('No'), // Label when switch is off
                                                    on: {
                                                        onChange: function (newv, oldv) {
                                                            // Event handler for switch change
                                                            if (newv === 1) {
                                                                $$('SportbookGgrPvIpConcessionaire').show(); // Show input field
                                                            } else {
                                                                $$('SportbookGgrPvIpConcessionaire').hide(); // Hide input field
                                                            }
                                                        },
                                                    },
                                                },
                                                {
                                                    hidden: true, // Initially hidden input field
                                                    view: 'text', // Text input for commission percentage
                                                    name: 'SportbookGgrPvIpConcessionaire',
                                                    id: 'SportbookGgrPvIpConcessionaire',
                                                    label: _('% Comisión'), // Label for the input field
                                                    labelPosition: 'top', // Position of the label
                                                    placeholder: 'Comisión', // Placeholder text
                                                    invalidMessage: 'Campo Requerido', // Message for required field
                                                    type: 'number', // Input type
                                                },
                                            ],
                                        },
                                        {
                                            view: 'form', // Form for Deposito Punto de venta
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                            rows: [
                                                {
                                                    view: 'label', // Label for the input field
                                                    label: _('Deposito Punto de venta'),
                                                },
                                                {
                                                    id: 'IsDepositPvConcessionaire', // ID for the switch
                                                    view: 'switch', // Switch for enabling/disabling
                                                    labelWidth: 50, // Width of the label
                                                    onLabel: _('Si'), // Label when switch is on
                                                    offLabel: _('No'), // Label when switch is off
                                                    on: {
                                                        onChange: function (newv, oldv) {
                                                            // Event handler for switch change
                                                            if (newv === 1) {
                                                                $$('DepositPvConcessionaire').show(); // Show input field
                                                            } else {
                                                                $$('DepositPvConcessionaire').hide(); // Hide input field
                                                            }
                                                        },
                                                    },
                                                },
                                                {
                                                    hidden: true, // Initially hidden input field
                                                    view: 'text', // Text input for commission percentage
                                                    name: 'DepositPvConcessionaire',
                                                    id: 'DepositPvConcessionaire',
                                                    label: _('% Comisión'), // Label for the input field
                                                    labelPosition: 'top', // Position of the label
                                                    placeholder: 'Comisión', // Placeholder text
                                                    invalidMessage: 'Campo Requerido', // Message for required field
                                                    type: 'number', // Input type
                                                },
                                            ],
                                        },
                                        {
                                            view: 'form', // Form for Notas de retiro Punto de venta
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                            rows: [
                                                {
                                                    view: 'label', // Label for the input field
                                                    label: _('Notas de retiro Punto de venta'),
                                                },
                                                {
                                                    id: 'IsWithdrawalsNotesPvConcessionaire', // ID for the switch
                                                    view: 'switch', // Switch for enabling/disabling
                                                    labelWidth: 50, // Width of the label
                                                    onLabel: _('Si'), // Label when switch is on
                                                    offLabel: _('No'), // Label when switch is off
                                                    on: {
                                                        onChange: function (newv, oldv) {
                                                            // Event handler for switch change
                                                            if (newv === 1) {
                                                                $$('WithdrawalsNotesPvConcessionaire').show(); // Show input field
                                                            } else {
                                                                $$('WithdrawalsNotesPvConcessionaire').hide(); // Hide input field
                                                            }
                                                        },
                                                    },
                                                },
                                                {
                                                    hidden: true, // Initially hidden input field
                                                    view: 'text', // Text input for commission percentage
                                                    name: 'WithdrawalsNotesPvConcessionaire',
                                                    id: 'WithdrawalsNotesPvConcessionaire',
                                                    label: _('% Comisión'), // Label for the input field
                                                    labelPosition: 'top', // Position of the label
                                                    placeholder: 'Comisión', // Placeholder text
                                                    invalidMessage: 'Campo Requerido', // Message for required field
                                                    type: 'number', // Input type
                                                },
                                            ],
                                        },
                                        {
                                            view: 'form', // Form for Sportbook GGR Afiliados
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                            rows: [
                                                {
                                                    view: 'label', // Label for the input field
                                                    label: _('Sportbook GGR Afiliados'),
                                                },
                                                {
                                                    id: 'IsSportbookGgrAfConcessionaire', // ID for the switch
                                                    view: 'switch', // Switch for enabling/disabling
                                                    labelWidth: 50, // Width of the label
                                                    onLabel: _('Si'), // Label when switch is on
                                                    offLabel: _('No'), // Label when switch is off
                                                    on: {
                                                        onChange: function (newv, oldv) {
                                                            // Event handler for switch change
                                                            if (newv === 1) {
                                                                $$('SportbookGgrAfConcessionaire').show(); // Show input field
                                                            } else {
                                                                $$('SportbookGgrAfConcessionaire').hide(); // Hide input field
                                                            }
                                                        },
                                                    },
                                                },
                                                {
                                                    hidden: true, // Initially hidden input field
                                                    view: 'text', // Text input for commission percentage
                                                    name: 'SportbookGgrAfConcessionaire',
                                                    id: 'SportbookGgrAfConcessionaire',
                                                    label: _('% Comisión'), // Label for the input field
                                                    labelPosition: 'top', // Position of the label
                                                    placeholder: 'Comisión', // Placeholder text
                                                    invalidMessage: 'Campo Requerido', // Message for required field
                                                    type: 'number', // Input type
                                                },
                                            ],
                                        },
                                        {
                                            view: 'form', // Form for Sportbook NGR Afiliados
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                            rows: [
                                                {
                                                    view: 'label', // Label for the input field
                                                    label: _('Sportbook NGR Afiliados'),
                                                },
                                                {
                                                    id: 'IsSportbookNgrAfConcessionaire', // ID for the switch
                                                    view: 'switch', // Switch for enabling/disabling
                                                    labelWidth: 50, // Width of the label
                                                    onLabel: _('Si'), // Label when switch is on
                                                    offLabel: _('No'), // Label when switch is off
                                                    on: {
                                                        onChange: function (newv, oldv) {
                                                            // Event handler for switch change
                                                            if (newv === 1) {
                                                                $$('SportbookNgrAfConcessionaire').show(); // Show input field
                                                            } else {
                                                                $$('SportbookNgrAfConcessionaire').hide(); // Hide input field
                                                            }
                                                        },
                                                    },
                                                },
                                                {
                                                    hidden: true, // Initially hidden input field
                                                    view: 'text', // Text input for commission percentage
                                                    name: 'SportbookNgrAfConcessionaire',
                                                    id: 'SportbookNgrAfConcessionaire',
                                                    label: _('% Comisión'), // Label for the input field
                                                    labelPosition: 'top', // Position of the label
                                                    placeholder: 'Comisión', // Placeholder text
                                                    invalidMessage: 'Campo Requerido', // Message for required field
                                                    type: 'number', // Input type
                                                },
                                            ],
                                        },
                                    ],
                                },
                                {
                                    cols: [
                                        // Columns for layout of additional input fields
                                        {
                                            view: 'form', // Form for Sportbook GGR Punto de venta
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                            rows: [
                                                {
                                                    view: 'label', // Label for the input field
                                                    label: _('Sportbook GGR Punto de venta'),
                                                },
                                                {
                                                    id: 'IsSportbookGgrPvConcessionaire', // ID for the switch
                                                    view: 'switch', // Switch for enabling/disabling
                                                    labelWidth: 50, // Width of the label
                                                    onLabel: _('Si'), // Label when switch is on
                                                    offLabel: _('No'), // Label when switch is off
                                                    on: {
                                                        onChange: function (newv, oldv) {
                                                            // Event handler for switch change
                                                            if (newv === 1) {
                                                                $$('SportbookGgrPvConcessionaire').show(); // Show input field
                                                            } else {
                                                                $$('SportbookGgrPvConcessionaire').hide(); // Hide input field
                                                            }
                                                        },
                                                    },
                                                },
                                                {
                                                    hidden: true, // Initially hidden input field
                                                    view: 'text', // Text input for commission percentage
                                                    name: 'SportbookGgrPvConcessionaire',
                                                    id: 'SportbookGgrPvConcessionaire',
                                                    label: _('% Comisión'), // Label for the input field
                                                    labelPosition: 'top', // Position of the label
                                                    placeholder: 'Comisión', // Placeholder text
                                                    invalidMessage: 'Campo Requerido', // Message for required field
                                                    type: 'number', // Input type
                                                },
                                            ],
                                        },
                                        {
                                            view: 'form', // Form for Apuestas Sport Punto de venta
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                            rows: [
                                                {
                                                    view: 'label', // Label for the input field
                                                    label: _('Apuestas Sport Punto de venta'),
                                                },
                                                {
                                                    id: 'IsBetSportPvConcessionaire', // ID for the switch
                                                    view: 'switch', // Switch for enabling/disabling
                                                    labelWidth: 50, // Width of the label
                                                    onLabel: _('Si'), // Label when switch is on
                                                    offLabel: _('No'), // Label when switch is off
                                                    on: {
                                                        onChange: function (newv, oldv) {
                                                            // Event handler for switch change
                                                            if (newv === 1) {
                                                                $$('BetSportPvConcessionaire').show(); // Show input field
                                                            } else {
                                                                $$('BetSportPvConcessionaire').hide(); // Hide input field
                                                            }
                                                        },
                                                    },
                                                },
                                                {
                                                    hidden: true, // Initially hidden input field
                                                    view: 'text', // Text input for commission percentage
                                                    name: 'BetSportPvConcessionaire',
                                                    id: 'BetSportPvConcessionaire',
                                                    label: _('% Comisión'), // Label for the input field
                                                    labelPosition: 'top', // Position of the label
                                                    placeholder: 'Comisión', // Placeholder text
                                                    invalidMessage: 'Campo Requerido', // Message for required field
                                                    type: 'number', // Input type
                                                },
                                            ],
                                        },
                                        {
                                            view: 'form', // Form for Casino NGR Afiliados
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                            rows: [
                                                {
                                                    view: 'label', // Label for the input field
                                                    label: _('Casino NGR Afiliados'),
                                                },
                                                {
                                                    id: 'IsCasinoNgrAfConcessionaire', // ID for the switch
                                                    view: 'switch', // Switch for enabling/disabling
                                                    labelWidth: 50, // Width of the label
                                                    onLabel: _('Si'), // Label when switch is on
                                                    offLabel: _('No'), // Label when switch is off
                                                    on: {
                                                        onChange: function (newv, oldv) {
                                                            // Event handler for switch change
                                                            if (newv === 1) {
                                                                $$('CasinoNgrAfConcessionaire').show(); // Show input field
                                                            } else {
                                                                $$('CasinoNgrAfConcessionaire').hide(); // Hide input field
                                                            }
                                                        },
                                                    },
                                                },
                                                {
                                                    hidden: true, // Initially hidden input field
                                                    view: 'text', // Text input for commission percentage
                                                    name: 'CasinoNgrAfConcessionaire',
                                                    id: 'CasinoNgrAfConcessionaire',
                                                    label: _('% Comisión'), // Label for the input field
                                                    labelPosition: 'top', // Position of the label
                                                    placeholder: 'Comisión', // Placeholder text
                                                    invalidMessage: 'Campo Requerido', // Message for required field
                                                    type: 'number', // Input type
                                                },
                                            ],
                                        },
                                        {
                                            view: 'form', // Form for Deposito Comision por Transaccion
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                            rows: [
                                                {
                                                    view: 'label', // Label for the input field
                                                    label: _('Deposito Comision por Transaccion'),
                                                },
                                                {
                                                    id: 'IsDepositCommissionTransactionConcessionaire', // ID for the switch
                                                    view: 'switch', // Switch for enabling/disabling
                                                    labelWidth: 50, // Width of the label
                                                    onLabel: _('Si'), // Label when switch is on
                                                    offLabel: _('No'), // Label when switch is off
                                                    on: {
                                                        onChange: function (newv, oldv) {
                                                            // Event handler for switch change
                                                            if (newv === 1) {
                                                                $$('DepositCommissionTransactionConcessionaire').show(); // Show input field
                                                            } else {
                                                                $$('DepositCommissionTransactionConcessionaire').hide(); // Hide input field
                                                            }
                                                        },
                                                    },
                                                },
                                                {
                                                    hidden: true, // Initially hidden input field
                                                    view: 'text', // Text input for commission percentage
                                                    name: 'DepositCommissionTransactionConcessionaire',
                                                    id: 'DepositCommissionTransactionConcessionaire',
                                                    label: _('% Comisión'), // Label for the input field
                                                    labelPosition: 'top', // Position of the label
                                                    placeholder: 'Comisión', // Placeholder text
                                                    invalidMessage: 'Campo Requerido', // Message for required field
                                                    type: 'number', // Input type
                                                },
                                            ],
                                        },
                                        {
                                            view: 'form', // Form for Deposito Afiliados
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                            rows: [
                                                {
                                                    view: 'label', // Label for the input field
                                                    label: _('Deposito Afiliados'),
                                                },
                                                {
                                                    id: 'IsDepositAfConcessionaire', // ID for the switch
                                                    view: 'switch', // Switch for enabling/disabling
                                                    labelWidth: 50, // Width of the label
                                                    onLabel: _('Si'), // Label when switch is on
                                                    offLabel: _('No'), // Label when switch is off
                                                    on: {
                                                        onChange: function (newv, oldv) {
                                                            // Event handler for switch change
                                                            if (newv === 1) {
                                                                $$('DepositAfConcessionaire').show(); // Show input field
                                                            } else {
                                                                $$('DepositAfConcessionaire').hide(); // Hide input field
                                                            }
                                                        },
                                                    },
                                                },
                                                {
                                                    hidden: true, // Initially hidden input field
                                                    view: 'text', // Text input for commission percentage
                                                    name: 'DepositAfConcessionaire',
                                                    id: 'DepositAfConcessionaire',
                                                    label: _('% Comisión'), // Label for the input field
                                                    labelPosition: 'top', // Position of the label
                                                    placeholder: 'Comisión', // Placeholder text
                                                    invalidMessage: 'Campo Requerido', // Message for required field
                                                    type: 'number', // Input type
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            margin: 10, // Sets the margin for the component
                            css: 'on-row', // Applies CSS class for styling
                            view: 'form', // Specifies the view type as a form
                            id: 'a70', // Unique identifier for the form
                            batch: 'Operadores', // Batch name for grouping related elements—
                            hidden: true, // Initially hides the form
                            rows: [
                                // Array of rows in the form
                                {
                                    view: 'label', // Label view for displaying text
                                    label: "<div class='tittle'>" + _('Operadores') + '</div>', // Title label with localization
                                },
                                {
                                    cols: [
                                        // Array of columns in the row
                                        {
                                            view: 'form', // Nested form view
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch', // CSS classes for styling
                                            rows: [
                                                // Array of rows in the nested form
                                                {
                                                    view: 'label', // Label for the section
                                                    label: _('Sportbook GGR Punto de venta'), // Localized label text
                                                },
                                                {
                                                    id: 'IsSportbookGgrPvIpSubdealer', // Unique identifier for the switch
                                                    view: 'switch', // Switch view for toggling options
                                                    labelWidth: 50, // Width of the label
                                                    onLabel: _('Si'), // Label for the 'on' state
                                                    offLabel: _('No'), // Label for the 'off' state
                                                    on: {
                                                        // Event handlers for the switch
                                                        onChange: function (newv, oldv) {
                                                            // Triggered when the switch state changes
                                                            if (newv === 1) {
                                                                // If switched on
                                                                $$('SportbookGgrPvIpSubdealer').show(); // Show associated input
                                                            } else {
                                                                // If switched off
                                                                $$('SportbookGgrPvIpSubdealer').hide(); // Hide associated input
                                                            }
                                                        },
                                                    },
                                                },
                                                {
                                                    hidden: true, // Initially hidden input
                                                    view: 'text', // Text input view
                                                    name: 'SportbookGgrPvIpSubdealer', // Name for the input
                                                    id: 'SportbookGgrPvIpSubdealer', // Unique identifier for the input
                                                    label: _('% Comisión'), // Localized label for the input
                                                    labelPosition: 'top', // Position of the label
                                                    placeholder: 'Comisión', // Placeholder text for the input
                                                    invalidMessage: 'Campo Requerido', // Message shown when input is invalid
                                                    type: 'number', // Input type
                                                },
                                            ],
                                        },
                                        {
                                            view: 'form', // Another nested form view
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch', // CSS classes for styling
                                            rows: [
                                                // Array of rows in the nested form
                                                {
                                                    view: 'label', // Label for the section
                                                    label: _('Deposito Punto de venta'), // Localized label text
                                                },
                                                {
                                                    id: 'IsDepositPvSubdealer', // Unique identifier for the switch
                                                    view: 'switch', // Switch view for toggling options
                                                    labelWidth: 50, // Width of the label
                                                    onLabel: _('Si'), // Label for the 'on' state
                                                    offLabel: _('No'), // Label for the 'off' state
                                                    on: {
                                                        // Event handlers for the switch
                                                        onChange: function (newv, oldv) {
                                                            // Triggered when the switch state changes
                                                            if (newv === 1) {
                                                                // If switched on
                                                                $$('DepositPvSubdealer').show(); // Show associated input
                                                            } else {
                                                                // If switched off
                                                                $$('DepositPvSubdealer').hide(); // Hide associated input
                                                            }
                                                        },
                                                    },
                                                },
                                                {
                                                    hidden: true, // Initially hidden input
                                                    view: 'text', // Text input view
                                                    name: 'DepositPvSubdealer', // Name for the input
                                                    id: 'DepositPvSubdealer', // Unique identifier for the input
                                                    label: _('% Comisión'), // Localized label for the input
                                                    labelPosition: 'top', // Position of the label
                                                    placeholder: 'Comisión', // Placeholder text for the input
                                                    invalidMessage: 'Campo Requerido', // Message shown when input is invalid
                                                    type: 'number', // Input type
                                                },
                                            ],
                                        },
                                        {
                                            view: 'form', // Another nested form view
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch', // CSS classes for styling
                                            rows: [
                                                // Array of rows in the nested form
                                                {
                                                    view: 'label', // Label for the section
                                                    label: _('Notas de retiro Punto de venta'), // Localized label text
                                                },
                                                {
                                                    id: 'IsWithdrawalsNotesPvSubdealer', // Unique identifier for the switch
                                                    view: 'switch', // Switch view for toggling options
                                                    labelWidth: 50, // Width of the label
                                                    onLabel: _('Si'), // Label for the 'on' state
                                                    offLabel: _('No'), // Label for the 'off' state
                                                    on: {
                                                        // Event handlers for the switch
                                                        onChange: function (newv, oldv) {
                                                            // Triggered when the switch state changes
                                                            if (newv === 1) {
                                                                // If switched on
                                                                $$('WithdrawalsNotesPvSubdealer').show(); // Show associated input
                                                            } else {
                                                                // If switched off
                                                                $$('WithdrawalsNotesPvSubdealer').hide(); // Hide associated input
                                                            }
                                                        },
                                                    },
                                                },
                                                {
                                                    hidden: true, // Initially hidden input
                                                    view: 'text', // Text input view
                                                    name: 'WithdrawalsNotesPvSubdealer', // Name for the input
                                                    id: 'WithdrawalsNotesPvSubdealer', // Unique identifier for the input
                                                    label: _('% Comisión'), // Localized label for the input
                                                    labelPosition: 'top', // Position of the label
                                                    placeholder: 'Comisión', // Placeholder text for the input
                                                    invalidMessage: 'Campo Requerido', // Message shown when input is invalid
                                                    type: 'number', // Input type
                                                },
                                            ],
                                        },
                                        {
                                            view: 'form', // Another nested form view
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch', // CSS classes for styling
                                            rows: [
                                                // Array of rows in the nested form
                                                {
                                                    view: 'label', // Label for the section
                                                    label: _('Sportbook GGR Afiliados'), // Localized label text
                                                },
                                                {
                                                    id: 'IsSportbookGgrAfSubdealer', // Unique identifier for the switch
                                                    view: 'switch', // Switch view for toggling options
                                                    labelWidth: 50, // Width of the label
                                                    onLabel: _('Si'), // Label for the 'on' state
                                                    offLabel: _('No'), // Label for the 'off' state
                                                    on: {
                                                        // Event handlers for the switch
                                                        onChange: function (newv, oldv) {
                                                            // Triggered when the switch state changes
                                                            if (newv === 1) {
                                                                // If switched on
                                                                $$('SportbookGgrAfSubdealer').show(); // Show associated input
                                                            } else {
                                                                // If switched off
                                                                $$('SportbookGgrAfSubdealer').hide(); // Hide associated input
                                                            }
                                                        },
                                                    },
                                                },
                                                {
                                                    hidden: true, // Initially hidden input
                                                    view: 'text', // Text input view
                                                    name: 'SportbookGgrAfSubdealer', // Name for the input
                                                    id: 'SportbookGgrAfSubdealer', // Unique identifier for the input
                                                    label: _('% Comisión'), // Localized label for the input
                                                    labelPosition: 'top', // Position of the label
                                                    placeholder: 'Comisión', // Placeholder text for the input
                                                    invalidMessage: 'Campo Requerido', // Message shown when input is invalid
                                                    type: 'number', // Input type
                                                },
                                            ],
                                        },
                                        {
                                            view: 'form', // Another nested form view
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch', // CSS classes for styling
                                            rows: [
                                                // Array of rows in the nested form
                                                {
                                                    view: 'label', // Label for the section
                                                    label: _('Sportbook NGR Afiliados'), // Localized label text
                                                },
                                                {
                                                    id: 'IsSportbookNgrAfSubdealer', // Unique identifier for the switch
                                                    view: 'switch', // Switch view for toggling options
                                                    labelWidth: 50, // Width of the label
                                                    onLabel: _('Si'), // Label for the 'on' state
                                                    offLabel: _('No'), // Label for the 'off' state
                                                    on: {
                                                        // Event handlers for the switch
                                                        onChange: function (newv, oldv) {
                                                            // Triggered when the switch state changes
                                                            if (newv === 1) {
                                                                // If switched on
                                                                $$('SportbookNgrAfSubdealer').show(); // Show associated input
                                                            } else {
                                                                // If switched off
                                                                $$('SportbookNgrAfSubdealer').hide(); // Hide associated input
                                                            }
                                                        },
                                                    },
                                                },
                                                {
                                                    hidden: true, // Initially hidden input
                                                    view: 'text', // Text input view
                                                    name: 'SportbookNgrAfSubdealer', // Name for the input
                                                    id: 'SportbookNgrAfSubdealer', // Unique identifier for the input
                                                    label: _('% Comisión'), // Localized label for the input
                                                    labelPosition: 'top', // Position of the label
                                                    placeholder: 'Comisión', // Placeholder text for the input
                                                    invalidMessage: 'Campo Requerido', // Message shown when input is invalid
                                                    type: 'number', // Input type
                                                },
                                            ],
                                        },
                                    ],
                                },
                                {
                                    cols: [
                                        // Array of columns in the second row
                                        {
                                            view: 'form', // Nested form view
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch', // CSS classes for styling
                                            rows: [
                                                // Array of rows in the nested form
                                                {
                                                    view: 'label', // Label for the section
                                                    label: _('Sportbook GGR Punto de venta'), // Localized label text
                                                },
                                                {
                                                    id: 'IsSportbookGgrPvSubdealer', // Unique identifier for the switch
                                                    view: 'switch', // Switch view for toggling options
                                                    labelWidth: 50, // Width of the label
                                                    onLabel: _('Si'), // Label for the 'on' state
                                                    offLabel: _('No'), // Label for the 'off' state
                                                    on: {
                                                        // Event handlers for the switch
                                                        onChange: function (newv, oldv) {
                                                            // Triggered when the switch state changes
                                                            if (newv === 1) {
                                                                // If switched on
                                                                $$('SportbookGgrPvSubdealer').show(); // Show associated input
                                                            } else {
                                                                // If switched off
                                                                $$('SportbookGgrPvSubdealer').hide(); // Hide associated input
                                                            }
                                                        },
                                                    },
                                                },
                                                {
                                                    hidden: true, // Initially hidden input
                                                    view: 'text', // Text input view
                                                    name: 'SportbookGgrPvSubdealer', // Name for the input
                                                    id: 'SportbookGgrPvSubdealer', // Unique identifier for the input
                                                    label: _('% Comisión'), // Localized label for the input
                                                    labelPosition: 'top', // Position of the label
                                                    placeholder: 'Comisión', // Placeholder text for the input
                                                    invalidMessage: 'Campo Requerido', // Message shown when input is invalid
                                                    type: 'number', // Input type
                                                },
                                            ],
                                        },
                                        {
                                            view: 'form', // Another nested form view
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch', // CSS classes for styling
                                            rows: [
                                                // Array of rows in the nested form
                                                {
                                                    view: 'label', // Label for the section
                                                    label: _('Apuestas Sport Punto de venta'), // Localized label text
                                                },
                                                {
                                                    id: 'IsBetSportPvSubdealer', // Unique identifier for the switch
                                                    view: 'switch', // Switch view for toggling options
                                                    labelWidth: 50, // Width of the label
                                                    onLabel: _('Si'), // Label for the 'on' state
                                                    offLabel: _('No'), // Label for the 'off' state
                                                    on: {
                                                        // Event handlers for the switch
                                                        onChange: function (newv, oldv) {
                                                            // Triggered when the switch state changes
                                                            if (newv === 1) {
                                                                // If switched on
                                                                $$('BetSportPvSubdealer').show(); // Show associated input
                                                            } else {
                                                                // If switched off
                                                                $$('BetSportPvSubdealer').hide(); // Hide associated input
                                                            }
                                                        },
                                                    },
                                                },
                                                {
                                                    hidden: true, // Initially hidden input
                                                    view: 'text', // Text input view
                                                    name: 'BetSportPvSubdealer', // Name for the input
                                                    id: 'BetSportPvSubdealer', // Unique identifier for the input
                                                    label: _('% Comisión'), // Localized label for the input
                                                    labelPosition: 'top', // Position of the label
                                                    placeholder: 'Comisión', // Placeholder text for the input
                                                    invalidMessage: 'Campo Requerido', // Message shown when input is invalid
                                                    type: 'number', // Input type
                                                },
                                            ],
                                        },
                                        {
                                            view: 'form', // Another nested form view
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch', // CSS classes for styling
                                            rows: [
                                                // Array of rows in the nested form
                                                {
                                                    view: 'label', // Label for the section
                                                    label: _('Casino NGR Afiliados'), // Localized label text
                                                },
                                                {
                                                    id: 'IsCasinoNgrAfSubdealer', // Unique identifier for the switch
                                                    view: 'switch', // Switch view for toggling options
                                                    labelWidth: 50, // Width of the label
                                                    onLabel: _('Si'), // Label for the 'on' state
                                                    offLabel: _('No'), // Label for the 'off' state
                                                    on: {
                                                        // Event handlers for the switch
                                                        onChange: function (newv, oldv) {
                                                            // Triggered when the switch state changes
                                                            if (newv === 1) {
                                                                // If switched on
                                                                $$('CasinoNgrAfSubdealer').show(); // Show associated input
                                                            } else {
                                                                // If switched off
                                                                $$('CasinoNgrAfSubdealer').hide(); // Hide associated input
                                                            }
                                                        },
                                                    },
                                                },
                                                {
                                                    hidden: true, // Initially hidden input
                                                    view: 'text', // Text input view
                                                    name: 'CasinoNgrAfSubdealer', // Name for the input
                                                    id: 'CasinoNgrAfSubdealer', // Unique identifier for the input
                                                    label: _('% Comisión'), // Localized label for the input
                                                    labelPosition: 'top', // Position of the label
                                                    placeholder: 'Comisión', // Placeholder text for the input
                                                    invalidMessage: 'Campo Requerido', // Message shown when input is invalid
                                                    type: 'number', // Input type
                                                },
                                            ],
                                        },
                                        {
                                            view: 'form', // Another nested form view
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch', // CSS classes for styling
                                            rows: [
                                                // Array of rows in the nested form
                                                {
                                                    view: 'label', // Label for the section
                                                    label: _('Deposito Comision por Transaccion'), // Localized label text
                                                },
                                                {
                                                    id: 'IsDepositCommissionTransactionSubdealer', // Unique identifier for the switch
                                                    view: 'switch', // Switch view for toggling options
                                                    labelWidth: 50, // Width of the label
                                                    onLabel: _('Si'), // Label for the 'on' state
                                                    offLabel: _('No'), // Label for the 'off' state
                                                    on: {
                                                        // Event handlers for the switch
                                                        onChange: function (newv, oldv) {
                                                            // Triggered when the switch state changes
                                                            if (newv === 1) {
                                                                // If switched on
                                                                $$('DepositCommissionTransactionSubdealer').show(); // Show associated input
                                                            } else {
                                                                // If switched off
                                                                $$('DepositCommissionTransactionSubdealer').hide(); // Hide associated input
                                                            }
                                                        },
                                                    },
                                                },
                                                {
                                                    hidden: true, // Initially hidden input
                                                    view: 'text', // Text input view
                                                    name: 'DepositCommissionTransactionSubdealer', // Name for the input
                                                    id: 'DepositCommissionTransactionSubdealer', // Unique identifier for the input
                                                    label: _('% Comisión'), // Localized label for the input
                                                    labelPosition: 'top', // Position of the label
                                                    placeholder: 'Comisión', // Placeholder text for the input
                                                    invalidMessage: 'Campo Requerido', // Message shown when input is invalid
                                                    type: 'number', // Input type
                                                },
                                            ],
                                        },
                                        {
                                            view: 'form', // Another nested form view
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch', // CSS classes for styling
                                            rows: [
                                                // Array of rows in the nested form
                                                {
                                                    view: 'label', // Label for the section
                                                    label: _('Deposito Afiliados'), // Localized label text
                                                },
                                                {
                                                    id: 'IsDepositAfSubdealer', // Unique identifier for the switch
                                                    view: 'switch', // Switch view for toggling options
                                                    labelWidth: 50, // Width of the label
                                                    onLabel: _('Si'), // Label for the 'on' state
                                                    offLabel: _('No'), // Label for the 'off' state
                                                    on: {
                                                        // Event handlers for the switch
                                                        onChange: function (newv, oldv) {
                                                            // Triggered when the switch state changes
                                                            if (newv === 1) {
                                                                // If switched on
                                                                $$('DepositAfSubdealer').show(); // Show associated input
                                                            } else {
                                                                // If switched off
                                                                $$('DepositAfSubdealer').hide(); // Hide associated input
                                                            }
                                                        },
                                                    },
                                                },
                                                {
                                                    hidden: true, // Initially hidden input
                                                    view: 'text', // Text input view
                                                    name: 'DepositAfSubdealer', // Name for the input
                                                    id: 'DepositAfSubdealer', // Unique identifier for the input
                                                    label: _('% Comisión'), // Localized label for the input
                                                    labelPosition: 'top', // Position of the label
                                                    placeholder: 'Comisión', // Placeholder text for the input
                                                    invalidMessage: 'Campo Requerido', // Message shown when input is invalid
                                                    type: 'number', // Input type
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            margin: 10,
                            css: 'on-row', // CSS class for styling
                            view: 'form', // Form view for Punto de venta details
                            id: 'a71',
                            batch: 'Punto de venta', // Batch identifier for grouping
                            hidden: true, // Initially hidden
                            rows: [
                                {
                                    view: 'label', // Label for the Punto de venta section
                                    label: "<div class='tittle'>" + _('Punto de venta') + '</div>',
                                },
                                {
                                    cols: [
                                        // Columns for layout of input fields
                                        {
                                            view: 'form', // Form for Sportbook GGR Punto de venta IP
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                            rows: [
                                                {
                                                    view: 'label', // Label for the input field
                                                    label: _('Sportbook GGR Punto de venta IP'),
                                                },
                                                {
                                                    id: 'IsSportbookGgrPvIpPointSale', // ID for the switch
                                                    view: 'switch', // Switch for enabling/disabling
                                                    labelWidth: 50, // Width of the label
                                                    onLabel: _('Si'), // Label when switch is on
                                                    offLabel: _('No'), // Label when switch is off
                                                    on: {
                                                        onChange: function (newv, oldv) {
                                                            // Event handler for switch change
                                                            if (newv === 1) {
                                                                $$('SportbookGgrPvIpPointSale').show(); // Show input field
                                                            } else {
                                                                $$('SportbookGgrPvIpPointSale').hide(); // Hide input field
                                                            }
                                                        },
                                                    },
                                                },
                                                {
                                                    hidden: true, // Initially hidden input field
                                                    view: 'text', // Text input for commission percentage
                                                    name: 'SportbookGgrPvIpPointSale',
                                                    id: 'SportbookGgrPvIpPointSale',
                                                    label: _('% Comisión'), // Label for the input field
                                                    labelPosition: 'top', // Position of the label
                                                    placeholder: 'Comisión', // Placeholder text
                                                    invalidMessage: 'Campo Requerido', // Message for required field
                                                    type: 'number', // Input type
                                                },
                                            ],
                                        },
                                        {
                                            view: 'form', // Form for Deposito Punto de venta
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                            rows: [
                                                {
                                                    view: 'label', // Label for the input field
                                                    label: _('Deposito Punto de venta'),
                                                },
                                                {
                                                    id: 'IsDepositPvPointSale', // ID for the switch
                                                    view: 'switch', // Switch for enabling/disabling
                                                    labelWidth: 50, // Width of the label
                                                    onLabel: _('Si'), // Label when switch is on
                                                    offLabel: _('No'), // Label when switch is off
                                                    on: {
                                                        onChange: function (newv, oldv) {
                                                            // Event handler for switch change
                                                            if (newv === 1) {
                                                                $$('DepositPvPointSale').show(); // Show input field
                                                            } else {
                                                                $$('DepositPvPointSale').hide(); // Hide input field
                                                            }
                                                        },
                                                    },
                                                },
                                                {
                                                    hidden: true, // Initially hidden input field
                                                    view: 'text', // Text input for commission percentage
                                                    name: 'DepositPvPointSale',
                                                    id: 'DepositPvPointSale',
                                                    label: _('% Comisión'), // Label for the input field
                                                    labelPosition: 'top', // Position of the label
                                                    placeholder: 'Comisión', // Placeholder text
                                                    invalidMessage: 'Campo Requerido', // Message for required field
                                                    type: 'number', // Input type
                                                },
                                            ],
                                        },
                                        {
                                            view: 'form', // Form for Notas de retiro Punto de venta
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                            rows: [
                                                {
                                                    view: 'label', // Label for the input field
                                                    label: _('Notas de retiro Punto de venta'),
                                                },
                                                {
                                                    id: 'IsWithdrawalsNotesPvPointSale', // ID for the switch
                                                    view: 'switch', // Switch for enabling/disabling
                                                    labelWidth: 50, // Width of the label
                                                    onLabel: _('Si'), // Label when switch is on
                                                    offLabel: _('No'), // Label when switch is off
                                                    on: {
                                                        onChange: function (newv, oldv) {
                                                            // Event handler for switch change
                                                            if (newv === 1) {
                                                                $$('WithdrawalsNotesPvPointSale').show(); // Show input field
                                                            } else {
                                                                $$('WithdrawalsNotesPvPointSale').hide(); // Hide input field
                                                            }
                                                        },
                                                    },
                                                },
                                                {
                                                    hidden: true, // Initially hidden input field
                                                    view: 'text', // Text input for commission percentage
                                                    name: 'WithdrawalsNotesPvPointSale',
                                                    id: 'WithdrawalsNotesPvPointSale',
                                                    label: _('% Comisión'), // Label for the input field
                                                    labelPosition: 'top', // Position of the label
                                                    placeholder: 'Comisión', // Placeholder text
                                                    invalidMessage: 'Campo Requerido', // Message for required field
                                                    type: 'number', // Input type
                                                },
                                            ],
                                        },
                                        {
                                            view: 'form', // Form for Sportbook GGR Afiliados
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                            rows: [
                                                {
                                                    view: 'label', // Label for the input field
                                                    label: _('Sportbook GGR Afiliados'),
                                                },
                                                {
                                                    id: 'IsSportbookGgrAfPointSale', // ID for the switch
                                                    view: 'switch', // Switch for enabling/disabling
                                                    labelWidth: 50, // Width of the label
                                                    onLabel: _('Si'), // Label when switch is on
                                                    offLabel: _('No'), // Label when switch is off
                                                    on: {
                                                        onChange: function (newv, oldv) {
                                                            // Event handler for switch change
                                                            if (newv === 1) {
                                                                $$('SportbookGgrAfPointSale').show(); // Show input field
                                                            } else {
                                                                $$('SportbookGgrAfPointSale').hide(); // Hide input field
                                                            }
                                                        },
                                                    },
                                                },
                                                {
                                                    hidden: true, // Initially hidden input field
                                                    view: 'text', // Text input for commission percentage
                                                    name: 'SportbookGgrAfPointSale',
                                                    id: 'SportbookGgrAfPointSale',
                                                    label: _('% Comisión'), // Label for the input field
                                                    labelPosition: 'top', // Position of the label
                                                    placeholder: 'Comisión', // Placeholder text
                                                    invalidMessage: 'Campo Requerido', // Message for required field
                                                    type: 'number', // Input type
                                                },
                                            ],
                                        },
                                        {
                                            view: 'form', // Form for Sportbook NGR Afiliados
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                            rows: [
                                                {
                                                    view: 'label', // Label for the input field
                                                    label: _('Sportbook NGR Afiliados'),
                                                },
                                                {
                                                    id: 'IsSportbookNgrAfPointSale', // ID for the switch
                                                    view: 'switch', // Switch for enabling/disabling
                                                    labelWidth: 50, // Width of the label
                                                    onLabel: _('Si'), // Label when switch is on
                                                    offLabel: _('No'), // Label when switch is off
                                                    on: {
                                                        onChange: function (newv, oldv) {
                                                            // Event handler for switch change
                                                            if (newv === 1) {
                                                                $$('SportbookNgrAfPointSale').show(); // Show input field
                                                            } else {
                                                                $$('SportbookNgrAfPointSale').hide(); // Hide input field
                                                            }
                                                        },
                                                    },
                                                },
                                                {
                                                    hidden: true, // Initially hidden input field
                                                    view: 'text', // Text input for commission percentage
                                                    name: 'SportbookNgrAfPointSale',
                                                    id: 'SportbookNgrAfPointSale',
                                                    label: _('% Comisión'), // Label for the input field
                                                    labelPosition: 'top', // Position of the label
                                                    placeholder: 'Comisión', // Placeholder text
                                                    invalidMessage: 'Campo Requerido', // Message for required field
                                                    type: 'number', // Input type
                                                },
                                            ],
                                        },
                                    ],
                                },
                                {
                                    cols: [
                                        // Columns for layout of additional input fields
                                        {
                                            view: 'form', // Form for Sportbook GGR Punto de venta
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                            rows: [
                                                {
                                                    view: 'label', // Label for the input field
                                                    label: _('Sportbook GGR Punto de venta'),
                                                },
                                                {
                                                    id: 'IsSportbookGgrPvPointSale', // ID for the switch
                                                    view: 'switch', // Switch for enabling/disabling
                                                    labelWidth: 50, // Width of the label
                                                    onLabel: _('Si'), // Label when switch is on
                                                    offLabel: _('No'), // Label when switch is off
                                                    on: {
                                                        onChange: function (newv, oldv) {
                                                            // Event handler for switch change
                                                            if (newv === 1) {
                                                                $$('SportbookGgrPvPointSale').show(); // Show input field
                                                            } else {
                                                                $$('SportbookGgrPvPointSale').hide(); // Hide input field
                                                            }
                                                        },
                                                    },
                                                },
                                                {
                                                    hidden: true, // Initially hidden input field
                                                    view: 'text', // Text input for commission percentage
                                                    name: 'SportbookGgrPvPointSale',
                                                    id: 'SportbookGgrPvPointSale',
                                                    label: _('% Comisión'), // Label for the input field
                                                    labelPosition: 'top', // Position of the label
                                                    placeholder: 'Comisión', // Placeholder text
                                                    invalidMessage: 'Campo Requerido', // Message for required field
                                                    type: 'number', // Input type
                                                },
                                            ],
                                        },
                                        {
                                            view: 'form', // Form for Apuestas Sport Punto de venta
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                            rows: [
                                                {
                                                    view: 'label', // Label for the input field
                                                    label: _('Apuestas Sport Punto de venta'),
                                                },
                                                {
                                                    id: 'IsBetSportPvPointSale', // ID for the switch
                                                    view: 'switch', // Switch for enabling/disabling
                                                    labelWidth: 50, // Width of the label
                                                    onLabel: _('Si'), // Label when switch is on
                                                    offLabel: _('No'), // Label when switch is off
                                                    on: {
                                                        onChange: function (newv, oldv) {
                                                            // Event handler for switch change
                                                            if (newv === 1) {
                                                                $$('BetSportPvPointSale').show(); // Show input field
                                                            } else {
                                                                $$('BetSportPvPointSale').hide(); // Hide input field
                                                            }
                                                        },
                                                    },
                                                },
                                                {
                                                    hidden: true, // Initially hidden input field
                                                    view: 'text', // Text input for commission percentage
                                                    name: 'BetSportPvPointSale',
                                                    id: 'BetSportPvPointSale',
                                                    label: _('% Comisión'), // Label for the input field
                                                    labelPosition: 'top', // Position of the label
                                                    placeholder: 'Comisión', // Placeholder text
                                                    invalidMessage: 'Campo Requerido', // Message for required field
                                                    type: 'number', // Input type
                                                },
                                            ],
                                        },
                                        {
                                            view: 'form', // Form for Casino NGR Afiliados
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                            rows: [
                                                {
                                                    view: 'label', // Label for the input field
                                                    label: _('Casino NGR Afiliados'),
                                                },
                                                {
                                                    id: 'IsCasinoNgrAfPointSale', // ID for the switch
                                                    view: 'switch', // Switch for enabling/disabling
                                                    labelWidth: 50, // Width of the label
                                                    onLabel: _('Si'), // Label when switch is on
                                                    offLabel: _('No'), // Label when switch is off
                                                    on: {
                                                        onChange: function (newv, oldv) {
                                                            // Event handler for switch change
                                                            if (newv === 1) {
                                                                $$('CasinoNgrAfPointSale').show(); // Show input field
                                                            } else {
                                                                $$('CasinoNgrAfPointSale').hide(); // Hide input field
                                                            }
                                                        },
                                                    },
                                                },
                                                {
                                                    hidden: true, // Initially hidden input field
                                                    view: 'text', // Text input for commission percentage
                                                    name: 'CasinoNgrAfPointSale',
                                                    id: 'CasinoNgrAfPointSale',
                                                    label: _('% Comisión'), // Label for the input field
                                                    labelPosition: 'top', // Position of the label
                                                    placeholder: 'Comisión', // Placeholder text
                                                    invalidMessage: 'Campo Requerido', // Message for required field
                                                    type: 'number', // Input type
                                                },
                                            ],
                                        },
                                        {
                                            view: 'form', // Form for Deposito Comision por Transaccion
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                            rows: [
                                                {
                                                    view: 'label', // Label for the input field
                                                    label: _('Deposito Comision por Transaccion'),
                                                },
                                                {
                                                    id: 'IsDepositCommissionTransactionPointSale', // ID for the switch
                                                    view: 'switch', // Switch for enabling/disabling
                                                    labelWidth: 50, // Width of the label
                                                    onLabel: _('Si'), // Label when switch is on
                                                    offLabel: _('No'), // Label when switch is off
                                                    on: {
                                                        onChange: function (newv, oldv) {
                                                            // Event handler for switch change
                                                            if (newv === 1) {
                                                                $$('DepositCommissionTransactionPointSale').show(); // Show input field
                                                            } else {
                                                                $$('DepositCommissionTransactionPointSale').hide(); // Hide input field
                                                            }
                                                        },
                                                    },
                                                },
                                                {
                                                    hidden: true, // Initially hidden input field
                                                    view: 'text', // Text input for commission percentage
                                                    name: 'DepositCommissionTransactionPointSale',
                                                    id: 'DepositCommissionTransactionPointSale',
                                                    label: _('% Comisión'), // Label for the input field
                                                    labelPosition: 'top', // Position of the label
                                                    placeholder: 'Comisión', // Placeholder text
                                                    invalidMessage: 'Campo Requerido', // Message for required field
                                                    type: 'number', // Input type
                                                },
                                            ],
                                        },
                                        {
                                            view: 'form', // Form for Deposito Afiliados
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                            rows: [
                                                {
                                                    view: 'label', // Label for the input field
                                                    label: _('Deposito Afiliados'),
                                                },
                                                {
                                                    id: 'IsDepositAfPointSale', // ID for the switch
                                                    view: 'switch', // Switch for enabling/disabling
                                                    labelWidth: 50, // Width of the label
                                                    onLabel: _('Si'), // Label when switch is on
                                                    offLabel: _('No'), // Label when switch is off
                                                    on: {
                                                        onChange: function (newv, oldv) {
                                                            // Event handler for switch change
                                                            if (newv === 1) {
                                                                $$('DepositAfPointSale').show(); // Show input field
                                                            } else {
                                                                $$('DepositAfPointSale').hide(); // Hide input field
                                                            }
                                                        },
                                                    },
                                                },
                                                {
                                                    hidden: true, // Initially hidden input field
                                                    view: 'text', // Text input for commission percentage
                                                    name: 'DepositAfPointSale',
                                                    id: 'DepositAfPointSale',
                                                    label: _('% Comisión'), // Label for the input field
                                                    labelPosition: 'top', // Position of the label
                                                    placeholder: 'Comisión', // Placeholder text
                                                    invalidMessage: 'Campo Requerido', // Message for required field
                                                    type: 'number', // Input type
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            margin: 10,
                            css: 'on-row', // CSS class for styling
                            view: 'form', // Form view for Afiliador details
                            id: 'a72',
                            batch: 'Afiliador', // Batch identifier for grouping
                            hidden: true, // Initially hidden
                            rows: [
                                {
                                    view: 'label', // Label for the Afiliador section
                                    label: "<div class='tittle'>" + _('Afiliador') + '</div>',
                                },
                                {
                                    cols: [
                                        // Columns for layout of input fields
                                        {
                                            view: 'form', // Form for Sportbook GGR Punto de venta IP
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                            rows: [
                                                {
                                                    view: 'label', // Label for the input field
                                                    label: _('Sportbook GGR Punto de venta IP'),
                                                },
                                                {
                                                    id: 'IsSportbookGgrPvIpAffiliate', // ID for the switch
                                                    view: 'switch', // Switch for enabling/disabling
                                                    labelWidth: 50, // Width of the label
                                                    onLabel: _('Si'), // Label when switch is on
                                                    offLabel: _('No'), // Label when switch is off
                                                    on: {
                                                        onChange: function (newv, oldv) {
                                                            // Event handler for switch change
                                                            if (newv === 1) {
                                                                $$('SportbookGgrPvIpAffiliate').show(); // Show input field
                                                            } else {
                                                                $$('SportbookGgrPvIpAffiliate').hide(); // Hide input field
                                                            }
                                                        },
                                                    },
                                                },
                                                {
                                                    hidden: true, // Initially hidden input field
                                                    view: 'text', // Text input for commission percentage
                                                    name: 'SportbookGgrPvIpAffiliate',
                                                    id: 'SportbookGgrPvIpAffiliate',
                                                    label: _('% Comisión'), // Label for the input field
                                                    labelPosition: 'top', // Position of the label
                                                    placeholder: 'Comisión', // Placeholder text
                                                    invalidMessage: 'Campo Requerido', // Message for required field
                                                    type: 'number', // Input type
                                                },
                                            ],
                                        },
                                        {
                                            view: 'form', // Form for Deposito Punto de venta
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                            rows: [
                                                {
                                                    view: 'label', // Label for the input field
                                                    label: _('Deposito Punto de venta'),
                                                },
                                                {
                                                    id: 'IsDepositPvAffiliate', // ID for the switch
                                                    view: 'switch', // Switch for enabling/disabling
                                                    labelWidth: 50, // Width of the label
                                                    onLabel: _('Si'), // Label when switch is on
                                                    offLabel: _('No'), // Label when switch is off
                                                    on: {
                                                        onChange: function (newv, oldv) {
                                                            // Event handler for switch change
                                                            if (newv === 1) {
                                                                $$('DepositPvAffiliate').show(); // Show input field
                                                            } else {
                                                                $$('DepositPvAffiliate').hide(); // Hide input field
                                                            }
                                                        },
                                                    },
                                                },
                                                {
                                                    hidden: true, // Initially hidden input field
                                                    view: 'text', // Text input for commission percentage
                                                    name: 'DepositPvAffiliate',
                                                    id: 'DepositPvAffiliate',
                                                    label: _('% Comisión'), // Label for the input field
                                                    labelPosition: 'top', // Position of the label
                                                    placeholder: 'Comisión', // Placeholder text
                                                    invalidMessage: 'Campo Requerido', // Message for required field
                                                    type: 'number', // Input type
                                                },
                                            ],
                                        },
                                        {
                                            view: 'form', // Form for Notas de retiro Punto de venta
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                            rows: [
                                                {
                                                    view: 'label', // Label for the input field
                                                    label: _('Notas de retiro Punto de venta'),
                                                },
                                                {
                                                    id: 'IsWithdrawalsNotesPvAffiliate', // ID for the switch
                                                    view: 'switch', // Switch for enabling/disabling
                                                    labelWidth: 50, // Width of the label
                                                    onLabel: _('Si'), // Label when switch is on
                                                    offLabel: _('No'), // Label when switch is off
                                                    on: {
                                                        onChange: function (newv, oldv) {
                                                            // Event handler for switch change
                                                            if (newv === 1) {
                                                                $$('WithdrawalsNotesPvAffiliate').show(); // Show input field
                                                            } else {
                                                                $$('WithdrawalsNotesPvAffiliate').hide(); // Hide input field
                                                            }
                                                        },
                                                    },
                                                },
                                                {
                                                    hidden: true, // Initially hidden input field
                                                    view: 'text', // Text input for commission percentage
                                                    name: 'WithdrawalsNotesPvAffiliate',
                                                    id: 'WithdrawalsNotesPvAffiliate',
                                                    label: _('% Comisión'), // Label for the input field
                                                    labelPosition: 'top', // Position of the label
                                                    placeholder: 'Comisión', // Placeholder text
                                                    invalidMessage: 'Campo Requerido', // Message for required field
                                                    type: 'number', // Input type
                                                },
                                            ],
                                        },
                                        {
                                            view: 'form', // Form for Sportbook GGR Afiliados
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                            rows: [
                                                {
                                                    view: 'label', // Label for the input field
                                                    label: _('Sportbook GGR Afiliados'),
                                                },
                                                {
                                                    id: 'IsSportbookGgrAfAffiliate', // ID for the switch
                                                    view: 'switch', // Switch for enabling/disabling
                                                    labelWidth: 50, // Width of the label
                                                    onLabel: _('Si'), // Label when switch is on
                                                    offLabel: _('No'), // Label when switch is off
                                                    on: {
                                                        onChange: function (newv, oldv) {
                                                            // Event handler for switch change
                                                            if (newv === 1) {
                                                                $$('SportbookGgrAfAffiliate').show(); // Show input field
                                                            } else {
                                                                $$('SportbookGgrAfAffiliate').hide(); // Hide input field
                                                            }
                                                        },
                                                    },
                                                },
                                                {
                                                    hidden: true, // Initially hidden input field
                                                    view: 'text', // Text input for commission percentage
                                                    name: 'SportbookGgrAfAffiliate',
                                                    id: 'SportbookGgrAfAffiliate',
                                                    label: _('% Comisión'), // Label for the input field
                                                    labelPosition: 'top', // Position of the label
                                                    placeholder: 'Comisión', // Placeholder text
                                                    invalidMessage: 'Campo Requerido', // Message for required field
                                                    type: 'number', // Input type
                                                },
                                            ],
                                        },
                                        {
                                            view: 'form', // Form for Sportbook NGR Afiliados
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                            rows: [
                                                {
                                                    view: 'label', // Label for the input field
                                                    label: _('Sportbook NGR Afiliados'),
                                                },
                                                {
                                                    id: 'IsSportbookNgrAfAffiliate', // ID for the switch
                                                    view: 'switch', // Switch for enabling/disabling
                                                    labelWidth: 50, // Width of the label
                                                    onLabel: _('Si'), // Label when switch is on
                                                    offLabel: _('No'), // Label when switch is off
                                                    on: {
                                                        onChange: function (newv, oldv) {
                                                            // Event handler for switch change
                                                            if (newv === 1) {
                                                                $$('SportbookNgrAfAffiliate').show(); // Show input field
                                                            } else {
                                                                $$('SportbookNgrAfAffiliate').hide(); // Hide input field
                                                            }
                                                        },
                                                    },
                                                },
                                                {
                                                    hidden: true, // Initially hidden input field
                                                    view: 'text', // Text input for commission percentage
                                                    name: 'SportbookNgrAfAffiliate',
                                                    id: 'SportbookNgrAfAffiliate',
                                                    label: _('% Comisión'), // Label for the input field
                                                    labelPosition: 'top', // Position of the label
                                                    placeholder: 'Comisión', // Placeholder text
                                                    invalidMessage: 'Campo Requerido', // Message for required field
                                                    type: 'number', // Input type
                                                },
                                            ],
                                        },
                                    ],
                                },
                                {
                                    cols: [
                                        // Columns for layout of additional input fields
                                        {
                                            view: 'form', // Form for Sportbook GGR Punto de venta
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                            rows: [
                                                {
                                                    view: 'label', // Label for the input field
                                                    label: _('Sportbook GGR Punto de venta'),
                                                },
                                                {
                                                    id: 'IsSportbookGgrPvAffiliate', // ID for the switch
                                                    view: 'switch', // Switch for enabling/disabling
                                                    labelWidth: 50, // Width of the label
                                                    onLabel: _('Si'), // Label when switch is on
                                                    offLabel: _('No'), // Label when switch is off
                                                    on: {
                                                        onChange: function (newv, oldv) {
                                                            // Event handler for switch change
                                                            if (newv === 1) {
                                                                $$('SportbookGgrPvAffiliate').show(); // Show input field
                                                            } else {
                                                                $$('SportbookGgrPvAffiliate').hide(); // Hide input field
                                                            }
                                                        },
                                                    },
                                                },
                                                {
                                                    hidden: true, // Initially hidden input field
                                                    view: 'text', // Text input for commission percentage
                                                    name: 'SportbookGgrPvAffiliate',
                                                    id: 'SportbookGgrPvAffiliate',
                                                    label: _('% Comisión'), // Label for the input field
                                                    labelPosition: 'top', // Position of the label
                                                    placeholder: 'Comisión', // Placeholder text
                                                    invalidMessage: 'Campo Requerido', // Message for required field
                                                    type: 'number', // Input type
                                                },
                                            ],
                                        },
                                        {
                                            view: 'form', // Form for Apuestas Sport Punto de venta
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                            rows: [
                                                {
                                                    view: 'label', // Label for the input field
                                                    label: _('Apuestas Sport Punto de venta'),
                                                },
                                                {
                                                    id: 'IsBetSportPvAffiliate', // ID for the switch
                                                    view: 'switch', // Switch for enabling/disabling
                                                    labelWidth: 50, // Width of the label
                                                    onLabel: _('Si'), // Label when switch is on
                                                    offLabel: _('No'), // Label when switch is off
                                                    on: {
                                                        onChange: function (newv, oldv) {
                                                            // Event handler for switch change
                                                            if (newv === 1) {
                                                                $$('BetSportPvAffiliate').show(); // Show input field
                                                            } else {
                                                                $$('BetSportPvAffiliate').hide(); // Hide input field
                                                            }
                                                        },
                                                    },
                                                },
                                                {
                                                    hidden: true, // Initially hidden input field
                                                    view: 'text', // Text input for commission percentage
                                                    name: 'BetSportPvAffiliate',
                                                    id: 'BetSportPvAffiliate',
                                                    label: _('% Comisión'), // Label for the input field
                                                    labelPosition: 'top', // Position of the label
                                                    placeholder: 'Comisión', // Placeholder text
                                                    invalidMessage: 'Campo Requerido', // Message for required field
                                                    type: 'number', // Input type
                                                },
                                            ],
                                        },
                                        {
                                            view: 'form', // Form for Casino NGR Afiliados
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                            rows: [
                                                {
                                                    view: 'label', // Label for the input field
                                                    label: _('Casino NGR Afiliados'),
                                                },
                                                {
                                                    id: 'IsCasinoNgrAfAffiliate', // ID for the switch
                                                    view: 'switch', // Switch for enabling/disabling
                                                    labelWidth: 50, // Width of the label
                                                    onLabel: _('Si'), // Label when switch is on
                                                    offLabel: _('No'), // Label when switch is off
                                                    on: {
                                                        onChange: function (newv, oldv) {
                                                            // Event handler for switch change
                                                            if (newv === 1) {
                                                                $$('CasinoNgrAfAffiliate').show(); // Show input field
                                                            } else {
                                                                $$('CasinoNgrAfAffiliate').hide(); // Hide input field
                                                            }
                                                        },
                                                    },
                                                },
                                                {
                                                    hidden: true, // Initially hidden input field
                                                    view: 'text', // Text input for commission percentage
                                                    name: 'CasinoNgrAfAffiliate',
                                                    id: 'CasinoNgrAfAffiliate',
                                                    label: _('% Comisión'), // Label for the input field
                                                    labelPosition: 'top', // Position of the label
                                                    placeholder: 'Comisión', // Placeholder text
                                                    invalidMessage: 'Campo Requerido', // Message for required field
                                                    type: 'number', // Input type
                                                },
                                            ],
                                        },
                                        {
                                            view: 'form', // Form for Deposito Comision por Transaccion
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                            rows: [
                                                {
                                                    view: 'label', // Label for the input field
                                                    label: _('Deposito Comision por Transaccion'),
                                                },
                                                {
                                                    id: 'IsDepositCommissionTransactionAffiliate', // ID for the switch
                                                    view: 'switch', // Switch for enabling/disabling
                                                    labelWidth: 50, // Width of the label
                                                    onLabel: _('Si'), // Label when switch is on
                                                    offLabel: _('No'), // Label when switch is off
                                                    on: {
                                                        onChange: function (newv, oldv) {
                                                            // Event handler for switch change
                                                            if (newv === 1) {
                                                                $$('DepositCommissionTransactionAffiliate').show(); // Show input field
                                                            } else {
                                                                $$('DepositCommissionTransactionAffiliate').hide(); // Hide input field
                                                            }
                                                        },
                                                    },
                                                },
                                                {
                                                    hidden: true, // Initially hidden input field
                                                    view: 'text', // Text input for commission percentage
                                                    name: 'DepositCommissionTransactionAffiliate',
                                                    id: 'DepositCommissionTransactionAffiliate',
                                                    label: _('% Comisión'), // Label for the input field
                                                    labelPosition: 'top', // Position of the label
                                                    placeholder: 'Comisión', // Placeholder text
                                                    invalidMessage: 'Campo Requerido', // Message for required field
                                                    type: 'number', // Input type
                                                },
                                            ],
                                        },
                                        {
                                            view: 'form', // Form for Deposito Afiliados
                                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch',
                                            rows: [
                                                {
                                                    view: 'label', // Label for the input field
                                                    label: _('Deposito Afiliados'),
                                                },
                                                {
                                                    id: 'IsDepositAfAffiliate', // ID for the switch
                                                    view: 'switch', // Switch for enabling/disabling
                                                    labelWidth: 50, // Width of the label
                                                    onLabel: _('Si'), // Label when switch is on
                                                    offLabel: _('No'), // Label when switch is off
                                                    on: {
                                                        onChange: function (newv, oldv) {
                                                            // Event handler for switch change
                                                            if (newv === 1) {
                                                                $$('DepositAfAffiliate').show(); // Show input field
                                                            } else {
                                                                $$('DepositAfAffiliate').hide(); // Hide input field
                                                            }
                                                        },
                                                    },
                                                },
                                                {
                                                    hidden: true, // Initially hidden input field
                                                    view: 'text', // Text input for commission percentage
                                                    name: 'DepositAfAffiliate',
                                                    id: 'DepositAfAffiliate',
                                                    label: _('% Comisión'), // Label for the input field
                                                    labelPosition: 'top', // Position of the label
                                                    placeholder: 'Comisión', // Placeholder text
                                                    invalidMessage: 'Campo Requerido', // Message for required field
                                                    type: 'number', // Input type
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
            ],
        };

        /**
         * Configuration for the upper section of fiscal settings.
         * @type {Object}
         */
        const upper_section_fiscal = {
            id: 'a6',
            rows: [
                {
                    responsive: 'a6',
                    margin: 10,
                    cols: [
                        left_fiscal, // Left column for fiscal settings
                        center_left_fiscal, // Center left column for fiscal settings
                        center_right_fiscal, // Center right column for fiscal settings
                        right_fiscal, // Right column for fiscal settings
                        right2_fiscal, // Additional right column for fiscal settings
                    ],
                },
            ],
        };

        /**
         * Configuration for the left section of security settings.
         * @type {Object}
         */
        const left_Security = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'UserPasswordExpireDays', // Field for user password expiration days
                    type: 'number',
                    label: "<div class='tittle'>" + _('Días de expiración de la contraseña') + '</div>',
                    labelPosition: 'top',
                    placeholder: _('Días de expiración de la contraseña'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
                {
                    view: 'richselect',
                    name: 'UserPasswordRegularExpression', // Field for user password regular expression
                    label:
                        "<label class='tittle'>" +
                        _('Regular Expresión contraseña usuario') +
                        '</label>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Expresión regular que valide una contraseña. ') +
                        '<br>' +
                        _('Ej: Que tenga entre 4 y 16 caracteres.') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: [], // Options for the regular expression selection
                },
                {
                    view: 'text',
                    name: 'BoUserPasswordExpireDays', // Field for backoffice user password expiration days
                    id: 'BoUserPasswordExpireDays',
                    type: 'number',
                    label: "<div class='tittle'>" + _('Días de expiración de la contraseña backoffice') + '</div>',
                    labelPosition: 'top',
                    placeholder: _('Días de expiración de la contraseña backoffice'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
                {
                    view: 'label',
                    label:
                        "<div class='tittle'>" +
                        _('Doble Factor De Autenticación') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Activar o Desactivar el Doble Factor De Autenticación') +
                        '</span></div>',
                    hidden: !devConfig.getPermAction('Autentication2FAUsersOnlineSwitch', 'Switch'), // Visibility based on permissions
                },
                {
                    css: 'centrar',
                    id: 'Autentication2FAUsersOnline', // Switch for enabling/disabling ValidateCompliance
                    view: 'switch',
                    hidden: !devConfig.getPermAction('Autentication2FAUsersOnlineSwitch', 'Switch'), // Visibility based on permissions
                    labelWidth: 55,
                    onLabel: _('Activo'),
                    offLabel: _('Inactivo'),
                    on: {
                        //Onchange event handler for the 2FA switch to show/hide the DaysFor2FA field based on the switch state
                        onChange: function (newv) {
                            if (!devConfig.getPermAction('Autentication2FAUsersOnlineSwitch', 'Switch')) {
                                $$('DaysFor2FA').hide();
                                return;
                            }
                            if (newv === 1) {
                                $$('DaysFor2FA').show();
                            } else {
                                $$('DaysFor2FA').hide();
                            }
                        },
                    },
                },
                {
                    view: 'text',
                    hidden: !devConfig.getPermAction('Autentication2FAUsersOnlineSwitch', 'Switch'), // Visibility based on permissions
                    name: 'DaysFor2FA', // Field for DaysFor2FA expiration days
                    id: 'DaysFor2FA',
                    label: _('Periodicidad de verificación en dispositivos seguros (días)'),
                    labelPosition: 'top',
                    placeholder: _('Periodicidad de verificación en dispositivos seguros (días)'),
                    type: 'number',
                    invalidMessage: '',
                    on: {
                        onChange: function (newValue) {
                            if (newValue === '0') {
                                this.setValue(''); // Clear value if 0
                            }
                        },
                        onKeyPress: function (code) {
                            if (code >= 37 && code <= 40) {
                                return true; // Allow arrow keys
                            }
                            if (code === 8) {
                                return true; // Allow backspace
                            }
                            if (code < 48 || code > 57) {
                                return false; // Block non-numeric input
                            }
                            if (code === 48 && this.getValue().length === 0) {
                                return false; // Block leading zero
                            }
                            return true; // Allow valid input
                        },
                    },
                },
            ],
        };

        /**
         * Configuration for the center left section of security settings.
         * @type {Object}
         */
        const center_left_Security = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'UserTempPasswordExpireDays', // Field for temporary password expiration days
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Días de expiración contraseña temporal') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Días de expiración de la contraseña temporal') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Días de expiración de la contraseña temporal'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
                {
                    view: 'text',
                    name: 'UserWrongLoginAttempts', // Field for maximum login attempts
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Máximo intentos inicio sesión') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el número máximo de intentos para iniciar sesión') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Máximo intentos inicio sesión'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
                {
                    view: 'label',
                    label:
                        "<div class='tittle'>" +
                        _('Email máximo intentos inicio sesión') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Activa o inactiva el email de máximo intentos inicio sesión') +
                        '</span></div>',
                },
                {
                    css: 'centrar',
                    id: 'EmailWrongLoginAttempts', // Switch for enabling/disabling email notifications for login attempts
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'),
                    offLabel: _('Inactivo'),
                },
                {
                    view: 'label',
                    label:
                        "<div class='tittle'>" +
                        _('Inactivo por regla automática') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('usuarios con coincidencias en listas de observados serán inactivados automáticamente.') +
                        '</span></div>',
                },
                {
                    css: 'centrar',
                    id: 'InactiveAutomaticRule', // Switch for enabling/disabling email notifications for login attempts
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'),
                    offLabel: _('Inactivo'),
                },
            ],
        };

        /**
         * Configuration for the center right section of security settings.
         * @type {Object}
         */
        const center_right_Security = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'UserPasswordMinLength', // Field for minimum password length
                    type: 'number',
                    label: "<div class='tittle'>" + _('Mínima longitud de la contraseña') + '</div>',
                    labelPosition: 'top',
                    placeholder: _('Mínima longitud de la contraseña'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
                {
                    view: 'text',
                    name: 'DaysNotifyBeforePasswordExpire', // Field for days to notify before password expiration
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Días antes de notificación de expiración') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Cuantos días antes de que expire la contraseña, se le notificara el cambio') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Días antes de notificación de expiración'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
                {
                    view: 'label',
                    label:
                        "<div class='tittle'>" +
                        _('Enviar datos de verificados a Compliance') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _(
                            'Activar o Desactivar el envió de información de usuarios verificados al proveedor de compliance',
                        ) +
                        '</span></div>',
                },
                {
                    css: 'centrar',
                    id: 'ValidateCompliance', // Switch for enabling/disabling ValidateCompliance
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Si'),
                    offLabel: _('No'),
                },
            ],
        };

        /**
         * Configuration for the right section of security settings.
         * @type {Object}
         */
        const right_Security = {
            margin: 5,
            minWidth: 200,
            rows: [], // No rows defined for this section
        };

        /**
         * Configuration for the upper section of security settings.
         * @type {Object}
         */
        const upper_section_Security = {
            id: 'a2',
            rows: [
                {
                    responsive: 'a2',
                    margin: 10,
                    cols: [
                        left_Security, // Left column for security settings
                        center_left_Security, // Center left column for security settings
                        center_right_Security, // Center right column for security settings
                    ],
                },
            ],
        };

        /**
         * Configuration for the left section of client withdrawal settings.
         * @type {Object}
         */
        const left_client_withdrawal = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'MaxRequestsPerDay', // Field for maximum requests per day
                    type: 'number',
                    label: "<div class='tittle'>" + _('Máximo solicitudes por día') + '</div>',
                    labelPosition: 'top',
                    placeholder: _('Máximo solicitudes por día'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
                {
                    view: 'text',
                    name: 'MinPercentageWagered', // Field for minimum percentage wagered/deposited
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Porcentaje mínimo apostado/depositado') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el porcentaje mínimo apostado sobre lo depositado.') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Porcentaje mínimo apostado sobre lo depositado'),
                    invalidMessage: _('Porcentaje Invalido'), // Invalid percentage message
                },
                {
                    view: 'text',
                    name: 'RequestMinAmountWithdrawBankAccount', // Field for minimum withdrawal amount for bank account
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Minimo monto solicitud de retiro Cuenta bancaria') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el monto minimo para una solicitud de retiro por Cuenta bancaria.') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Minimo monto solicitud de retiro Cuenta bancaria'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
                {
                    view: 'text',
                    name: 'RequestMaxAmountWithdrawBetShop', // Field for maximum withdrawal amount for betting shop
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Máximo monto retiro por punto de venta') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el monto máximo para retirar por punto de venta') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Máximo monto retiro por punto de venta'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
                {
                    view: 'text',
                    name: 'MaximumAmountDailyWithdrawalsClient', // Field for maximum daily withdrawals for client
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Monto limite de retiro para el cliente final') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el monto limite de retiro para el cliente final') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Monto limite de retiro para el cliente final'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
                {
                    view: 'label',
                    label:
                        "<div class='tittle'>" +
                        _('Requiere primer depósito para retirar?') +
                        "</div><div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique si el usuario necesita realizar un primer depósito para poder retirar') +
                        '</span></div>',
                },
                {
                    css: 'centrar',
                    id: 'FirstDeposit', // Switch for requiring first deposit to withdraw
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'),
                    offLabel: _('Inactivo'),
                },
                {
                    rows: [
                        {
                            id: 'IsActivateOtpNotesPuntoDeVenta', // Switch for enabling OTP for point of sale withdrawals
                            view: 'switch',
                            labelPosition: 'top',
                            labelWidth: 110,
                            label: _('Retiros en punto de venta (PV) (OTP).'),
                            onLabel: _('Si'),
                            offLabel: _('No'),
                            on: {
                                onChange: function (newv) {
                                    let valueOPTCB = $$('IsActivateOtpNotesCuentaBancaria').getValue();
                                    if (newv === 1) {
                                        $$('OtpNotesTime').show();
                                        $$('IsActivateOtpNotesEmailPV').show();
                                        $$('IsActivateOtpNotesEmailPV').setValue(1);
                                        $$('IsActivateOtpNotesSmsPV').show();
                                    } else if (newv !== 1 && valueOPTCB === 1) {
                                        $$('OtpNotesTime').show();
                                        $$('IsActivateOtpNotesEmailPV').hide();
                                        $$('IsActivateOtpNotesSmsPV').hide();
                                        $$('IsActivateOtpNotesSmsPV').setValue(0);
                                    } else {
                                        $$('OtpNotesTime').hide();
                                        $$('IsActivateOtpNotesEmailPV').hide();
                                        $$('IsActivateOtpNotesSmsPV').hide();
                                        $$('IsActivateOtpNotesSmsPV').setValue(0);
                                    }
                                },
                            },
                        },
                        {
                            id: 'IsActivateOtpNotesEmailPV', // Switch for enabling OTP via email for point of sale
                            view: 'switch',
                            labelPosition: 'top',
                            labelWidth: 110,
                            label: _('Switch OTP por Email'),
                            onLabel: _('Si'),
                            offLabel: _('No'),
                            hidden: true, // Initially hidden
                        },
                        {
                            id: 'IsActivateOtpNotesSmsPV', // Switch for enabling OTP via SMS for point of sale
                            view: 'switch',
                            labelPosition: 'top',
                            labelWidth: 110,
                            label: _('Switch OTP por SMS'),
                            onLabel: _('Si'),
                            offLabel: _('No'),
                            hidden: true, // Initially hidden
                        },
                        {
                            view: 'text',
                            name: 'OtpNotesTime', // Field for OTP token duration in milliseconds
                            id: 'OtpNotesTime',
                            label: _('Duración token en milisegundos'),
                            labelPosition: 'top',
                            placeholder: _('Tiempo en milisegundos'),
                            type: 'number',
                            hidden: true, // Initially hidden
                        },
                    ],
                },
                {
                    rows: [
                        {
                            cols: [
                                {
                                    view: 'label',
                                    label: _('Activar tiempo de expiración'), // Label for activating expiration time
                                    width: 200,
                                    align: 'right',
                                },
                                {
                                    id: 'ActiveWithdrawExpiration', // Switch for enabling withdrawal expiration time
                                    view: 'switch',
                                    onLabel: _('Si'),
                                    offLabel: _('No'),
                                    on: {
                                        onChange: function (newv) {
                                            if (newv === 1) {
                                                $$('WithdrawExpirationTime').show();
                                            } else {
                                                $$('WithdrawExpirationTime').hide();
                                            }
                                        },
                                    },
                                },
                            ],
                        },
                        {
                            view: 'text',
                            name: 'WithdrawExpirationTime', // Field for withdrawal expiration time
                            id: 'WithdrawExpirationTime',
                            label: _('Tiempo de caducidad de Retiros'),
                            labelPosition: 'top',
                            placeholder: _('Tiempo de caducidad de Retiros'),
                            type: 'number',
                            hidden: true, // Initially hidden
                            on: {
                                onChange: function (newValue) {
                                    if (newValue === '0') {
                                        this.setValue(''); // Clear value if 0
                                    }
                                },
                                onKeyPress: function (code) {
                                    if (code >= 37 && code <= 40) {
                                        return true; // Allow arrow keys
                                    }
                                    if (code === 8) {
                                        return true; // Allow backspace
                                    }
                                    if (code < 48 || code > 57) {
                                        return false; // Block non-numeric input
                                    }
                                    if (code === 48 && this.getValue().length === 0) {
                                        return false; // Block leading zero
                                    }
                                    return true; // Allow valid input
                                },
                            },
                        },
                    ],
                },
            ],
        };

        /**
         * Configuration for the center left section of client withdrawal settings.
         * @type {Object}
         */
        const center_left_client_withdrawal = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'RequestMinAmountWithdraw', // Field for minimum withdrawal request amount
                    type: 'number',
                    label: "<div class='tittle'>" + _('Mínimo monto en solicitud de retiro') + '</div>',
                    labelPosition: 'top',
                    placeholder: _('Mínimo monto en solicitud de retiro'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
                {
                    view: 'text',
                    name: 'RequestMinAmountWithdrawBetShop', // Field for minimum withdrawal amount for betting shop
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Mínimo retiros punto') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Mínimo monto en solicitud de retiro por punto de venta') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Mínimo retiros punto'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
                {
                    view: 'text',
                    name: 'MaxActiveRequests', // Field for maximum active requests
                    type: 'number',
                    label: "<div class='tittle'>" + _('Máxima cantidad de solicitudes activas') + '</div>',
                    labelPosition: 'top',
                    placeholder: _('Máxima cantidad de solicitudes activas'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
                {
                    view: 'text',
                    name: 'MinAmountWithdrawKasnet', // Field for minimum withdrawal amount for kasnet
                    type: 'number',
                    label: "<div class='tittle'>" + _('Mínimo monto en solicitud de retiro kasnet') + '</div>',
                    labelPosition: 'top',
                    placeholder: _('Mínimo monto en solicitud de retiro kasnet'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
                {
                    view: 'text',
                    name: 'MaxAmountWithdrawKasnet', // Field for maximum withdrawal amount for kasnet
                    type: 'number',
                    label: "<div class='tittle'>" + _('Máximo monto en solicitud de retiro kasnet') + '</div>',
                    labelPosition: 'top',
                    placeholder: _('Moximo monto en solicitud de retiro kasnet'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
                {
                    view: 'label',
                    label:
                        "<div class='tittle'>" +
                        _('Requiere correo verificado para retirar?') +
                        "</div><div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique si el usuario necesita verificar su correo para poder retirar') +
                        '</span></div>',
                },
                {
                    css: 'centrar',
                    id: 'VerifiedMail', // Switch for requiring verified email to withdraw
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'),
                    offLabel: _('Inactivo'),
                },
                {
                    id: 'IsActivateOtpNotesCuentaBancaria', // Switch for enabling OTP for bank account withdrawals
                    view: 'switch',
                    labelPosition: 'top',
                    labelWidth: 110,
                    label: _('Retiros por transferencia bancaria (OTP).'),
                    onLabel: _('Si'),
                    offLabel: _('No'),
                    on: {
                        onChange: function (newv) {
                            let valueOPTPV = $$('IsActivateOtpNotesPuntoDeVenta').getValue();
                            if (newv === 1) {
                                $$('OtpNotesTime').show();
                                $$('IsActivateOtpNotesEmailCB').show();
                                $$('IsActivateOtpNotesEmailCB').setValue(1);
                                $$('IsActivateOtpNotesSmsCB').show();
                            } else if (newv !== 1 && valueOPTPV === 1) {
                                $$('OtpNotesTime').show();
                                $$('IsActivateOtpNotesEmailCB').hide();
                                $$('IsActivateOtpNotesSmsCB').hide();
                                $$('IsActivateOtpNotesSmsCB').setValue(0);
                            } else {
                                $$('OtpNotesTime').hide();
                                $$('IsActivateOtpNotesEmailCB').hide();
                                $$('IsActivateOtpNotesSmsCB').hide();
                                $$('IsActivateOtpNotesSmsCB').setValue(0);
                            }
                        },
                    },
                },
                {
                    id: 'IsActivateOtpNotesEmailCB', // Switch for enabling OTP via email for bank account
                    view: 'switch',
                    labelPosition: 'top',
                    labelWidth: 110,
                    label: _('Switch OTP por Email'),
                    onLabel: _('Si'),
                    offLabel: _('No'),
                    hidden: true, // Initially hidden
                },
                {
                    id: 'IsActivateOtpNotesSmsCB', // Switch for enabling OTP via SMS for bank account
                    view: 'switch',
                    labelPosition: 'top',
                    labelWidth: 110,
                    label: _('Switch OTP por SMS'),
                    onLabel: _('Si'),
                    offLabel: _('No'),
                    hidden: true, // Initially hidden
                },
            ],
        };

        /**
         * Configuration for the center right section of client withdrawal settings.
         * @type {Object}
         */
        const center_right_client_withdrawal = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'RequestMaxAmountWithdraw', // Field for maximum withdrawal request amount
                    type: 'number',
                    label: "<div class='tittle'>" + _('Máximo monto en solicitud de retiro') + '</div>',
                    labelPosition: 'top',
                    placeholder: _('Máximo monto en solicitud de retiro'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
                {
                    view: 'label',
                    label:
                        "<div class='tittle'>" +
                        _('Requiere registro activo para retirar?') +
                        "</div><div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique si el usuario necesita tener el registro activado para poder retirar') +
                        '</span></div>',
                },
                {
                    css: 'centrar',
                    id: 'StateSwith6', // Switch for requiring active registration to withdraw
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'),
                    offLabel: _('Inactivo'),
                },
                {
                    view: 'label',
                    label:
                        "<div class='tittle'>" +
                        _('Requiere verificación de cuenta para retirar?') +
                        "</div><div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique si el usuario necesita verificar cuenta para poder retirar') +
                        '</span></div>',
                },
                {
                    css: 'centrar',
                    id: 'StateSwith7', // Switch for requiring account verification to withdraw
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'),
                    offLabel: _('Inactivo'),
                },
                {
                    view: 'label',
                    label:
                        "<div class='tittle'>" +
                        _('Todos los retiros por puntos de venta pasan a estado por aprobación') +
                        "</div><div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique si el usuario necesita verificar cuenta para poder retirar') +
                        '</span></div>',
                },
                {
                    css: 'centrar',
                    id: 'ActivateWithdrawalNotes', // Switch for requiring approval for all point of sale withdrawals
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'),
                    offLabel: _('Inactivo'),
                },
                {
                    view: 'label',
                    label:
                        "<div class='tittle'>" +
                        _('Requiere celular verificado para retirar?') +
                        "</div><div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique si el usuario necesita verificar su celular para poder retirar') +
                        '</span></div>',
                },
                {
                    css: 'centrar',
                    id: 'VerifiedPhone', // Switch for requiring verified phone to withdraw
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'),
                    offLabel: _('Inactivo'),
                },
                {
                    view: 'text',
                    name: 'CombinationOfWallets', // Field for maximum withdrawal request amount
                    type: 'number',
                    label: "<div class='tittle'>" + _('Máximo de Wallets Cripto') + '</div>',
                    labelPosition: 'top',
                    placeholder: _('Máximo de Wallets Crypto'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
            ],
        };

        /**
         * Configuration for the right section of client withdrawal settings.
         * @type {Object}
         */
        const right_client_withdrawal = {
            margin: 5,
            minWidth: 200,
            rows: [], // No rows defined for this section
        };

        /**
         * Configuration for the upper section of client withdrawal settings.
         * @type {Object}
         */
        const upper_section_client_withdrawal = {
            id: 'a3',
            rows: [
                {
                    responsive: 'a3',
                    margin: 10,
                    cols: [
                        left_client_withdrawal, // Left column for client withdrawal settings
                        center_left_client_withdrawal, // Center left column for client withdrawal settings
                        center_right_client_withdrawal, // Center right column for client withdrawal settings
                    ],
                },
            ],
        };

        /**
         * Configuration for the left section of client deposit settings.
         * @type {Object}
         */
        const left_client_deposit = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'RequestMinAmount', // Field for minimum deposit request amount
                    type: 'number',
                    label: "<div class='tittle'>" + _('Mínimo monto de solicitud de deposito') + '</div>',
                    labelPosition: 'top',
                    placeholder: _('Mínimo monto de solicitud de deposito'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
                {
                    view: 'text',
                    name: 'LimitDepositDayGlobal', // Field for global daily deposit limit
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Limite depósito día global') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el límite de depósito diario global') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Limite depósito día global'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
                {
                    view: 'label',
                    label:
                        "<div class='tittle'>" +
                        _('Requiere verificación de cuenta para depositar?') +
                        "</div><div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique si el usuario necesita verificar cuenta para poder depositar') +
                        '</span></div>',
                },
                {
                    css: 'centrar',
                    id: 'StateSwith5', // Switch for requiring account verification to deposit
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'),
                    offLabel: _('Inactivo'),
                },
                {
                    view: 'text',
                    name: 'DefaultAmountDeposits', // Field for default deposit amount
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Monto de depósitos por defecto') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el monto de depósitos por defecto') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Monto depósito por defecto'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
            ],
        };

        /**
         * Configuration for the center left section of client deposit settings.
         * @type {Object}
         */
        const center_left_client_deposit = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'RequestMaxAmount', // Field for maximum deposit request amount
                    type: 'number',
                    label: "<div class='tittle'>" + _('Máximo monto de solicitud de deposito') + '</div>',
                    labelPosition: 'top',
                    placeholder: _('Máximo monto de solicitud de deposito'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
                {
                    view: 'text',
                    name: 'LimitDepositWeekGlobal', // Field for global weekly deposit limit
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Limite depósito semana global') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el límite de depósito semanal global') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Limite depósito semana global'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
                {
                    view: 'text',
                    name: 'LimitCancelDepositExecutions', // Field for limit of cancellations per day per point of sale
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Limite de cancelaciones por día por PV') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el limite de cancelaciones por día por PV') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Limite de cancelaciones por día por PV'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
                {
                    view: 'label',
                    label: "<div class='tittle'>" + _(' Activación tiempo de recarga por PDV?') + '</span></div>',
                },
                {
                    css: 'centrar',
                    id: 'IsActivateDepositTimePDV',
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'),
                    offLabel: _('Inactivo'),
                    on: {
                        onChange: function (newv) {
                            const time = $$('TimeForDepositPDV');
                            if (newv === 1) {
                                time.show();
                            } else {
                                time.hide();
                            }
                        },
                    },
                },
                {
                    id: 'TimeForDepositPDV',
                    view: 'text',
                    name: 'TimeForDepositPDV', // Field for default PDVRechargeTime
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Limite tiempo de recarga por PDV') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el limite de tiempo en segundos de la recarga por punto de venta') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Limite tiempo de recarga por punto de venta'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
            ],
        };

        /**
         * Configuration for the center right section of client deposit settings.
         * @type {Object}
         */
        const center_right_client_deposit = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'label',
                    label:
                        "<div class='tittle'>" +
                        _('Requiere registro activo para depositar?') +
                        "</div><div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique si el usuario necesita tener el registro activado para poder depositar') +
                        '</span></div>',
                },
                {
                    css: 'centrar',
                    id: 'StateSwith4', // Switch for requiring active registration to deposit
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'),
                    offLabel: _('Inactivo'),
                },
                {
                    view: 'text',
                    name: 'LimitDepositMonthGlobal', // Field for global monthly deposit limit
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Limite depósito mes global') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el límite de depósito mensual global') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Limite depósito mes global'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
                {
                    view: 'text',
                    name: 'LimitHoursCancelDeposit', // Field for limit of hours for deposit cancellation
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Limite de horas anulación deposito') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el limite de horas anulación deposito por punto de venta') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Limite de horas anulación deposito'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
            ],
        };

        /**
         * Configuration for the right section of client deposit settings.
         * @type {Object}
         */
        const right_client_deposit = {
            margin: 5,
            minWidth: 200,
            rows: [], // No rows defined for this section
        };

        /**
         * Configuration for the left section of general settings.
         * @type {Object}
         */
        const left_setings_general = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'TaxWithdrawBalanceDeposit', // Field for tax on withdrawal balance deposit
                    type: 'number',
                    label: "<div class='tittle'>" + _('Impuesto Retiro Saldo Deposito') + '</div>',
                    labelPosition: 'top',
                    placeholder: _('Impuesto Retiro Saldo Deposito'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
                {
                    view: 'text',
                    name: 'TaxWithdrawBalanceDepositFrom', // Field for tax on withdrawal balance deposit from a certain value
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Impuesto Retiro Saldo Deposito a partir de') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Impuesto por Retiro Saldo Deposito a partir de un valor') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Impuesto Retiro Saldo Deposito a partir de'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
                {
                    view: 'text',
                    name: 'TaxWithdrawBalanceAwardFrom', // Field for tax on withdrawal balance award from a certain value
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Impuesto Retiro Saldo Premios a partir de') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Impuesto por Retiro Saldo Premios a partir de un valor.') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Impuesto Retiro Saldo Premios a partir de'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
                {
                    view: 'richselect',
                    name: 'ApproveBankAccounts', // Field for approving bank accounts
                    localId: 'State:combo',
                    label: "<div class='tittle'>" + _('Aprobar cuentas bancarias?') + '</div>',
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: [
                        { id: 'A', value: _('Activo') }, // Active option
                        { id: 'I', value: _('Inactivo') }, // Inactive option
                    ],
                },
                {
                    view: 'text',
                    name: 'PenaltyWithdrawalBalanceWithdrawal', // Field for penalty percentage on withdrawal balance
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Porcentaje Penalidad Retiro Saldo Retiros') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el porcentaje de la penalidad por retiro a saldo de retiros.') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Porcentaje Penalidad Retiro Saldo Retiros'),
                    invalidMessage: _('Porcentaje Invalido'), // Invalid percentage message
                },
                {
                    view: 'text',
                    name: 'DaysAlertUpdateData', // Field for days to alert for data update
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Días para alerta de actualización de datos') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Días para alerta de actualización de datos del usuario.') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Días para alerta de actualización de datos'),
                },
                {
                    view: 'richselect',
                    name: 'TypeCommissionBetshop', // Field for type of commission for betting shops
                    label:
                        "<label class='tittle'>" +
                        _('Tipo de comisión puntos de venta') +
                        '</label>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el tipo de comisión para los puntos de venta.') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    value: 0,
                    options: [
                        { id: '0', value: _('Apuestas Pagadas') }, // Paid bets option
                        { id: '1', value: _('Apuestas Cerras') }, // Closed bets option
                    ],
                },
                {
                    view: 'text',
                    name: 'URLFundCasino', // Field for casino fund URL
                    label:
                        "<div class='tittle'>" +
                        _('URL fondo casino') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Establezca la URL de la imagen para fondo de casino.') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('URL fondo casino'),
                },
                {
                    view: 'label',
                    label:
                        "<div class='tittle'>" +
                        _('Saldo bonos') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Activa o inactiva el tipo de saldo bonos') +
                        '</span></div>',
                },
                {
                    css: 'centrar',
                    id: 'StateSwith11', // Switch for activating/deactivating bonus balance
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'),
                    offLabel: _('Inactivo'),
                },
                {
                    view: 'form',
                    margin: 10,
                    minWidth: 200,
                    css: 'secutity',
                    id: 'contigencia', // Form for contingency settings
                    rows: [
                        { view: 'label', label: _('Liquidaciones generadas') }, // Label for generated settlements
                        {
                            css: 'centrar',
                            id: 'StateSwith2', // Switch for automatic/manual settlements
                            view: 'switch',
                            labelWidth: 55,
                            onLabel: _('Automáticas'),
                            offLabel: _('Manuales'),
                        },
                        { view: 'label', label: _('Contigencia Total') }, // Label for total contingency
                        {
                            css: 'centrar',
                            id: 'StateSwith', // Switch for activating/deactivating total contingency
                            view: 'switch',
                            labelWidth: 55,
                            onLabel: _('Activo'),
                            offLabel: _('Inactivo'),
                        },
                        {
                            view: 'label',
                            label: _('Transacciones sin comisión'),
                            hidden: !devConfig.getPermAction('RestrictionTime', 'Add'),
                            css: 'prm-RestrictionTime',
                        },
                        {
                            css: 'centrar',
                            id: 'StateSwith15',
                            view: 'switch',
                            hidden: !devConfig.getPermAction('RestrictionTime', 'Add'),
                            labelWidth: 55,
                            onLabel: _('Activo'),
                            offLabel: _('Inactivo'),
                            on: {
                                onChange: function (newv) {
                                    if (newv === 1 && devConfig.getPermAction('RestrictionTime', 'Add')) {
                                        $$('RestrictionTime').show();
                                    } else {
                                        $$('RestrictionTime').hide();
                                    }
                                },
                            },
                        },
                        {
                            view: 'text',
                            name: 'RestrictionTime',
                            id: 'RestrictionTime',
                            label: _('Tiempo de Restricción'),
                            labelPosition: 'top',
                            placeholder: _('Tiempo en minutos'),
                            type: 'number',
                            hidden: true,
                        },
                        { view: 'label', label: _('Requiere verificación para comprar en Lealtad') },
                        {
                            css: 'centrar',
                            id: 'StateSwith17',
                            view: 'switch',
                            labelWidth: 55,
                            onLabel: _('Activo'),
                            offLabel: _('Inactivo'),
                        },
                        { view: 'label', label: _('Actualiza tipo de documento') },
                        {
                            css: 'centrar',
                            id: 'StateSwith19', // Switch for updating document type
                            view: 'switch',
                            labelWidth: 55,
                            onLabel: _('Activo'),
                            offLabel: _('Inactivo'),
                        },
                    ],
                },
            ],
        };

        /**
         * Configuration for the center left section of general settings.
         * @type {Object}
         */
        const center_left_setings_general = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'TaxWithdrawBalanceAward',
                    type: 'number',
                    label:
                        _('Impuesto Retiro Saldo Premios') +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el porcenta del impuesto que se le aplicará a las notas de retiro') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Impuesto Retiro Saldo Premios'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
                {
                    view: 'text',
                    name: 'TaxWithdrawBalanceAward2',
                    type: 'number',
                    label:
                        _('Impuesto Retiro Saldo Premios 2') +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _(
                            'Especifique el porcenta del impuesto que se le aplicara a el valor del retiro despues de aplicado el Impuesto Retiro Saldo Premios',
                        ) +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Impuesto Retiro Saldo Premios 2'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
                {
                    view: 'text',
                    name: 'TaxBetPayPrize', // Field for tax on bets when paying prizes
                    type: 'number',
                    label:
                        _('Impuesto sobre apuesta al pagar premio') +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Impuesto sobre el monto de la apuesta al momento de pagar el premio') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Impuesto sobre apuesta al pagar premio'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
                {
                    view: 'text',
                    name: 'TaxRegulatorFrom', // Field for tax to the regulatory body from a certain value
                    type: 'number',
                    label: "<div class='tittle'>" + _('Impuesto al ente regulador a partir de') + '</div>',
                    labelPosition: 'top',
                    placeholder: _('Impuesto al ente regulador a partir de'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
                {
                    view: 'richselect',
                    name: 'ApproveChangesInformation', // Field for approving changes to personal information
                    localId: 'State:combo',
                    label:
                        "<label class='tittle'>" +
                        _('Aprobar cambios de información personal?') +
                        '</label>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Aprobar los cambios de información personal hechos por el usuario?') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: [
                        { id: 'A', value: _('Activo') }, // Active option
                        { id: 'I', value: _('Inactivo') }, // Inactive option
                    ],
                },
                {
                    view: 'text',
                    name: 'MinimumWithdrawalBalanceWithdrawalsPenalty', // Field for minimum withdrawal balance for penalty
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Mínimo Retiro de Saldo Retiros para Penalizar') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el monto mínimo de retiro de saldo retiros para penalizar.') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Mínimo Retiro de Saldo Retiros para Penalizar'),
                    invalidMessage: _('Porcentaje Invalido'), // Invalid percentage message
                },
                {
                    view: 'text',
                    name: 'DaysAlertChangePassword', // Field for days to alert for password change
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Días para alerta de cambio de contraseña') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Días para alerta de cambio de contraseña') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Días para alerta de cambio de contraseña'),
                },
                {
                    view: 'richselect',
                    name: 'TypeCommissionSettlements', // Field for type of commission for settlements
                    label:
                        "<label class='tittle'>" +
                        _('Tipo de liquidaciones comisiones') +
                        '</label>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el tipo de liquidaciones para las comisiones, sea por caja o por cierre.') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    value: 0,
                    options: [
                        { id: '0', value: _('Cierre Pagada') }, // Paid closure option
                        { id: '1', value: _('Cierre') }, // Closure option
                        { id: '2', value: _('Caja') }, // Cash option
                    ],
                },
                {
                    view: 'richselect',
                    name: 'ActivateRegisterUser', // Field for requiring active registration to log in
                    localId: 'State:combo',
                    label: "<div class='tittle'>" + _('Requiere registro activo para iniciar sesión?') + '</div>',
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: [
                        { id: 'A', value: _('Activo') }, // Active option
                        { id: 'I', value: _('Inactivo') }, // Inactive option
                    ],
                },
                {
                    view: 'label',
                    label:
                        "<div class='tittle'>" +
                        _('Saldo recargas') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Activa o inactiva el tipo de saldo recargas') +
                        '</span></div>',
                },
                {
                    css: 'centrar',
                    id: 'StateSwith9', // Switch for activating/deactivating recharge balance
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'),
                    offLabel: _('Inactivo'),
                },
                {
                    view: 'label',
                    label:
                        "<div class='tittle'>" +
                        _('Saldo freebet') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Activa o inactiva el tipo de saldo freebet') +
                        '</span></div>',
                },
                {
                    css: 'centrar',
                    id: 'StateSwith12', // Switch for activating/deactivating freebet balance
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'),
                    offLabel: _('Inactivo'),
                },
                {
                    view: 'template',
                    template: ' ',
                    height: 0.5,
                    css: {
                        background: 'rgba(0, 0, 0, 0.05)',
                        margin: '6px 0',
                    },
                },
                {
                    view: 'label',
                    label:
                        "<div class='tittle'>" +
                        _('Venta de Apuestas Anónimas') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Activa o inactiva las apuestas anonimas v2') +
                        '</span></div>', //V2
                },
                {
                    css: 'centrar',
                    id: 'IsActiveAnonymousBets', // Switch for activating/deactivating anonymous bets
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'),
                    offLabel: _('Inactivo'),
                    // Event listener for a general switch (e.g., to enable anonymous betting)
                    on: {
                        onChange: function (newVal) {
                            // If the new value is 1 (activated)
                            if (newVal === 1) {
                                // Show all related fields and labels for anonymous betting
                                $$('IsActiveAnonymousDocument').show(); // Show the Document switch
                                $$('IsActiveAnonymousPhone').show(); // Show the Phone switch
                                $$('IsActiveAnonymousDocumentTitle').show(); // Show the Document title
                                $$('IsActiveAnonymousPhoneTitle').show(); // Show the Phone title
                                $$('IsActiveAnonymousBetsTitle').show(); // Show the main section title
                            } else {
                                // If deactivated, hide all related fields and labels
                                $$('IsActiveAnonymousDocument').hide(); // Hide the Document switch
                                $$('IsActiveAnonymousPhone').hide(); // Hide the Phone switch
                                $$('IsActiveAnonymousDocumentTitle').hide(); // Hide the Document title
                                $$('IsActiveAnonymousPhoneTitle').hide(); // Hide the Phone title
                                $$('IsActiveAnonymousBetsTitle').hide(); // Hide the main section title
                            }
                        },
                    },
                },

                // Main label for the section "Allowed data type for identification"
                {
                    id: 'IsActiveAnonymousBetsTitle',
                    view: 'label',
                    label: "<div class='tittle'>" + _('Tipo de dato permitido para identificación') + '</div>',
                },

                // Label for the Document switch, includes informational tooltip
                {
                    id: 'IsActiveAnonymousDocumentTitle',
                    view: 'label',
                    label:
                        "<div class='tittle'>" +
                        _('Documento de identidad') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'>" +
                        "<span class='div-to-display'>" +
                        _('Activa o inactiva las apuestas anonimas con número de documento') +
                        '</span></div>',
                },
                // Switch to enable/disable anonymous bets using document number
                {
                    id: 'IsActiveAnonymousDocument',
                    view: 'switch', // Type of UI component: switch
                    labelWidth: 55, // Width for the label section
                    onLabel: _('Activo'), // Label when switch is ON
                    offLabel: _('Inactivo'), // Label when switch is OFF
                    hidden: true, // Initially hidden
                },
                // Label for the Phone switch, includes informational tooltip
                {
                    id: 'IsActiveAnonymousPhoneTitle',
                    view: 'label',
                    label:
                        "<div class='tittle'>" +
                        _('Número de celular') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'>" +
                        "<span class='div-to-display'>" +
                        _('Activa o inactiva las apuestas anonimas con número de celular') +
                        '</span></div>',
                },
                // Switch to enable/disable anonymous bets using phone number
                {
                    id: 'IsActiveAnonymousPhone',
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'), // Label when switch is ON
                    offLabel: _('Inactivo'), // Label when switch is OFF
                    hidden: true, // Initially hidden
                },
                // Visual separator between sections (decorative element)
                {
                    view: 'template',
                    template: ' ', // Empty content (used for spacing)
                    height: 1, // Height of 1px
                    css: {
                        background: 'rgba(0, 0, 0, 0.05)', // Light gray semi-transparent line
                        margin: '6px 0', // Vertical margin
                    },
                },
                {
                    view: 'label',
                    label:
                        "<div class='tittle'>" +
                        _('Configuración de selección de bono') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Activa o inactiva la configuración de selección de bono') +
                        '</span></div>',
                },
                {
                    css: 'centrar',
                    id: 'IsActivateSelectBonus', // Switch for activating/deactivating freebet balance
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'),
                    offLabel: _('Inactivo'),
                },
            ],
        };

        /**
         * Configuration object for center right settings in the general section.
         * @type {Object}
         */
        const center_right_setings_general = {
            margin: 5, // Margin around the settings section
            minWidth: 200, // Minimum width of the settings section
            rows: [
                // Array of row configurations
                {
                    view: 'text', // Type of input view
                    name: 'TaxRegulator', // Name of the input field
                    type: 'number', // Input type
                    label: "<div class='tittle'>" + _('Impuesto al ente regulador') + '</div>', // Label for the input
                    labelPosition: 'top', // Position of the label
                    placeholder: _('Impuesto al ente regulador'), // Placeholder text
                    invalidMessage: _('Campo Requerido'), // Message shown when input is invalid
                },
                {
                    view: 'text',
                    name: 'TaxBetShopPhysical',
                    type: 'number',
                    label:
                        _('Impuesto apuesta por punto de venta fisico') +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _(
                            'Impuesto sobre el monto de la apuesta por punto de venta fisico al momento de realizar la apuesta',
                        ) +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Impuesto apuesta por punto de venta fisico'),
                    invalidMessage: _('Campo Requerido'),
                },
                {
                    view: 'text',
                    name: 'TaxPrizeBetShop',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Impuesto del GGR de la apuesta al momento de pagar') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Impuesto del GGR de la apuesta al momento de pagar') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Impuesto del GGR de la apuesta al momento de pagar'),
                    invalidMessage: _('Campo Requerido'),
                },
                {
                    view: 'text',
                    name: 'MaxAccountsBank',
                    type: 'number',
                    label: "<div class='tittle'>" + _('Máximo cuentas bancarias') + '</div>',
                    labelPosition: 'top',
                    placeholder: _('Máximo cuentas bancarias'),
                    invalidMessage: _('Campo Requerido'),
                },
                {
                    view: 'text',
                    name: 'PenaltyWithdrawalBalanceRecharge',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Porcentaje Penalidad Retiro Saldo Recargas') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el porcentaje de la penalidad por retiro a saldo de recargas.') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Porcentaje Penalidad Retiro Saldo Recargas'),
                    invalidMessage: _('Porcentaje Invalido'),
                },
                {
                    view: 'text',
                    name: 'SessionInativityLength',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Inactividad de sesión en minutos') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Establezca el tiempo de inactividad en minutos para el cierre de sesión.') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Inactividad de sesión en minutos'),
                },
                {
                    view: 'text',
                    name: 'SessionLength',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Duración de la sesión en minutos') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Establezca la duración de la sesión de juego en minutos.') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Duración de la sesión en minutos'),
                },
                {
                    view: 'text',
                    name: 'MinimumWithdrawalRefillsPenalty',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Mínimo Retiro de Recargas para Penalizar') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el monto mínimo de retiro de saldo recargas para penalizar.') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Mínimo Retiro de Recargas para Penalizar'),
                    invalidMessage: _('Porcentaje Invalido'),
                },
                {
                    view: 'text',
                    name: 'PlatformCost',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Costo Plataforma') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el porcentaje del costo que se le aplicará a las comisiones de los afiliados.') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Costo Plataforma'),
                    invalidMessage: _('Porcentaje Invalido'),
                },
                {
                    view: 'label',
                    label:
                        "<div class='tittle'>" +
                        _('Saldo retiros') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Activa o inactiva el tipo de saldo retiros') +
                        '</span></div>',
                },
                {
                    css: 'centrar', // CSS class for centering
                    id: 'StateSwith10', // Unique identifier for the switch
                    view: 'switch', // Type of input view
                    labelWidth: 55, // Width of the label
                    onLabel: _('Activo'), // Label when switch is on
                    offLabel: _('Inactivo'), // Label when switch is off
                },
                {
                    view: 'label',
                    label:
                        "<div class='tittle'>" +
                        _('Saldo freecasino') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Activa o inactiva el tipo de saldo freecasino') +
                        '</span></div>',
                },
                {
                    css: 'centrar',
                    id: 'StateSwith13',
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'),
                    offLabel: _('Inactivo'),
                },
                {
                    view: 'label',
                    label:
                        "<div class='tittle'>" +
                        _('Activacion de Nivel de Riesgo') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Activa o inactiva del nivel de riesgo') +
                        '</span></div>',
                },
                {
                    css: 'centrar',
                    id: 'StateSwith14',
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'),
                    offLabel: _('Inactivo'),
                },
                {
                    view: 'label',
                    label:
                        "<div class='tittle'>" +
                        _('Validar cuentas bancarias únicas por usuario') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Activa o inactiva del nivel de riesgo') +
                        '</span></div>',
                },
                {
                    css: 'centrar',
                    id: 'ActivateBankAccountValidation', // Unique identifier for the switch
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'),
                    offLabel: _('Inactivo'),
                },
                {
                    view: 'label', // Creates a label element
                    label:
                        "<div class='tittle'>" +
                        _('Validación de Registro Regulación') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Activa o inactiva del nivel de riesgo') +
                        '</span></div>', // Sets the label text and tooltip for regulatory registration validation
                },
                {
                    css: 'centrar', // Applies a CSS class to center the switch
                    id: 'VerificationMincetur', // Unique identifier for the switch component
                    view: 'switch', // Creates a switch element
                    labelWidth: 55, // Sets the width of the label
                    onLabel: _('Activo'), // Label displayed when the switch is ON
                    offLabel: _('Inactivo'), // Label displayed when the switch is OFF
                },
                {
                    view: 'label', // Creates a label element
                    id: 'multiCountryLoginLabel',
                    hidden: true,
                    label: '<div class=\'tittle\'>' + _('¿La marca permite registro Multipais?') + '</div>' + '<div id=\'info\' class=\'icon-exclamation-circle info\'><span class=\'div-to-display\'>' + _('Activa o inactiva del nivel de riesgo') + '</span></div>', // Sets the label text and tooltip for regulatory registration validation
                },
                {
                    css: 'centrar', // Applies a CSS class to center the switch
                    id: 'IsActiveMultiCountryLogin', // Unique identifier for the switch component
                    view: 'switch', // Creates a switch element
                    labelWidth: 55, // Sets the width of the label
                    hidden: true,
                    onLabel: _('Activo'), // Label displayed when the switch is ON
                    offLabel: _('Inactivo'), // Label displayed when the switch is OFF
                },
            ],
        };

        /**
         * Configuration object for right settings in the general section.
         * @type {Object}
         */
        const right_setings_general = {
            margin: 5, // Margin around the settings section
            minWidth: 200, // Minimum width of the settings section
            rows: [], // Array of row configurations (currently empty)
        };

        /**
         * Configuration object for the upper section of client deposits.
         * @type {Object}
         */
        const upper_section_client_deposit = {
            id: 'a4', // Unique identifier for the section
            rows: [
                {
                    responsive: 'a4', // Responsive design identifier
                    margin: 10, // Margin around the section
                    cols: [
                        // Array of column configurations
                        left_client_deposit, // Left column configuration
                        center_left_client_deposit, // Center left column configuration
                        center_right_client_deposit, // Center right column configuration
                    ],
                },
            ],
        };

        /**
         * Configuration object for the upper section of general settings.
         * @type {Object}
         */
        const upper_section_setings_general = {
            id: 'a5', // Unique identifier for the section
            rows: [
                {
                    responsive: 'a5', // Responsive design identifier
                    margin: 10, // Margin around the section
                    cols: [
                        // Array of column configurations
                        left_setings_general, // Left column configuration
                        center_left_setings_general, // Center left column configuration
                        center_right_setings_general, // Center right column configuration
                    ],
                },
            ],
        };

        /**
         * Configuration object for the accordion section.
         * @type {Object}
         */
        const accordion_section = {
            id: 'b5', // Unique identifier for the section
            rows: [
                // Array of row configurations
                {
                    multi: true, // Allows multiple sections to be opened
                    view: 'accordion', // Type of view
                    css: 'betShop', // CSS class for styling
                    collapsed: false, // Initial state of the accordion (expanded)
                    paddingY: 10, // Vertical padding
                    type: 'clean', // Type of accordion
                    rows: [
                        // Array of rows within the accordion
                        {
                            header: _('General'),
                            body: {
                                padding: 10, // Padding around the body
                                rows: [upper_section_general], // Rows to display in this section
                            },
                        },
                    ],
                },
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true, // Initial state of the accordion (collapsed)
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            paddingY: 10,
                            header: _('Seguridad'),
                            body: {
                                padding: 10,
                                rows: [upper_section_Security], // Rows to display in this section
                            },
                        },
                    ],
                },
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            paddingY: 10,
                            header: _('Solicitud de retiro de clientes'),
                            body: {
                                padding: 10,
                                rows: [upper_section_client_withdrawal], // Rows to display in this section
                            },
                        },
                    ],
                },
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            paddingY: 10,
                            header: _('Solicitud de depósito de clientes'),
                            body: {
                                padding: 10,
                                rows: [upper_section_client_deposit], // Rows to display in this section
                            },
                        },
                    ],
                },
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            paddingY: 10,
                            header: _('Ajustes Generales'),
                            body: {
                                padding: 10,
                                rows: [upper_section_setings_general], // Rows to display in this section
                            },
                        },
                    ],
                },
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Contabilidad'),
                            body: {
                                padding: 10,
                                rows: [upper_section_accounting], // Rows to display in this section
                            },
                        },
                    ],
                },
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Impuesto'),
                            body: {
                                padding: 10,
                                rows: [upper_section_tax], // Rows to display in this section
                            },
                        },
                    ],
                },
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Impuestos para comisiones'),
                            body: {
                                padding: 10,
                                rows: [upper_section_for_comission_tax], // Rows to display in this section
                            },
                        },
                    ],
                },
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Registro'),
                            body: {
                                padding: 10,
                                rows: [upper_section_register], // Rows to display in this section
                            },
                        },
                    ],
                },
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Proveedores internos'),
                            body: {
                                padding: 10,
                                rows: [upper_section_provider], // Rows to display in this section
                            },
                        },
                    ],
                },
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Puntos equivalentes por nivel'),
                            body: {
                                padding: 10,
                                rows: [upper_section_loyalty], // Rows to display in this section
                            },
                        },
                    ],
                },
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header:
                                _('Tipos de movimientos') +
                                ' ' +
                                _('(Nota: Por cada monto en XXX va a obtener Z puntos base)'),
                            body: {
                                padding: 10,
                                rows: [upper_section_loyalty_], // Rows to display in this section
                            },
                        },
                    ],
                },
                {
                    multi: true,
                    id: 'accordion_section_referrals',
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Lealtad'),
                            id: 'header_loyalty',
                            body: {
                                rows: [upper_section_configuration_loyalty],
                            },
                        },
                    ],
                    hidden: !devConfig.getPermAction('configurationLoyalty', 'Add'),
                },
                {
                    multi: true,
                    id: 'accordion_section_referrals', // Unique identifier for the referrals section
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Referidos'), // Header for the referrals section
                            id: 'header_referrals', // Unique identifier for the header
                            body: {
                                rows: [upper_section_referrals], // Rows to display in this section
                            },
                        },
                    ],
                },
                {
                    multi: true,
                    id: 'accordion_section_vertical', // Unique identifier for the verticals section
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Verticales'), // Header for the verticals section
                            id: 'header_referrals', // Unique identifier for the header
                            body: {
                                padding: 10,
                                rows: [upper_section_verticals], // Rows to display in this section
                            },
                        },
                    ],
                },
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Bonos landing de registro'), // Header for the landing bonuses section
                            body: {
                                padding: 10,
                                rows: [upper_section_landingBonuses], // Rows to display in this section
                            },
                        },
                    ],
                },
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Bonos de cumpleaños'), // Header for the birthday bonuses section
                            body: {
                                padding: 10,
                                rows: [upper_section_birthdayBonuses], // Rows to display in this section
                            },
                        },
                    ],
                },
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Límites de Comisión'), // Header for the commission limits section
                            body: {
                                padding: 10,
                                rows: [upper_section_commission], // Rows to display in this section
                            },
                        },
                    ],
                },
            ],
        };

        /**
         * Configuration object for buttons in the settings section.
         * @type {Object}
         */
        const buttons = {
            id: 'b2', // Unique identifier for the button section
            rows: [
                {
                    margin: 10, // Margin around the button section
                    responsive: 'b2', // Responsive design identifier
                    cols: [
                        // Array of column configurations
                        {
                            view: 'button', // Type of input view
                            value: _('Limpiar'), // Button label
                            minWidth: 200, // Minimum width of the button
                            click: () => {
                                // Click event handler
                                this.getRoot().clear(); // Clears the form
                            },
                        },
                        {
                            view: 'button', // Type of input view
                            id: 'btnSavePartnerSettings',
                            value: _('Guardar'), // Button label
                            hotkey: 'enter', // Hotkey for the button
                            type: 'form', // Type of button
                            minWidth: 200, // Minimum width of the button
                            click: () => {
                                // Click event handler
                                if (this.getRoot().validate()) {
                                    // Validate the form
                                    let filterdata = this.getRoot().getValues(); // Get form values
                                    filterdata.Partner = partnerCountry.Partner; // Add partner information
                                    filterdata.Country = partnerCountry.Country; // Add country information
                                    this.app.callEvent('partnerSettings:save', [filterdata]); // Trigger save event
                                }
                            },
                        },
                    ],
                },
            ],
        };

        // Return the main configuration object for the form
        return {
            view: 'form',
            id: 'formSettingsPartner',
            rows: [
                accordion_section, // Section for accordion layout
                buttons, // Section for buttons
            ],
            rules: {
                // Validation rules for various fields
                MinPercentageWagered: function (value) {
                    return value >= 0 && value <= 100; // Must be between 0 and 100
                },
                BetTaxValue: function (value) {
                    return value >= 0 && value <= 100; // Must be between 0 and 100
                },
                TaxPayments: function (value) {
                    return value >= 0 && value <= 100; // Must be between 0 and 100
                },
                DepositTaxValue: function (value) {
                    return value >= 0 && value <= 100; // Must be between 0 and 100
                },
                PenaltyWithdrawalBalanceRecharge: function (value) {
                    return value >= 0 && value <= 100; // Must be between 0 and 100
                },
                PenaltyWithdrawalBalanceWithdrawal: function (value) {
                    return value >= 0 && value <= 100; // Must be between 0 and 100
                },
                TaxWithdrawBalanceDeposit: function (value) {
                    return value >= 0 && value <= 100; // Must be between 0 and 100
                },
                TaxWithdrawBalanceAward: function (value) {
                    return value >= 0 && value <= 100; // Must be between 0 and 100
                },
                TaxWithdrawBalanceAward2: function (value) {
                    return value >= 0 && value <= 100; // Must be between 0 and 100
                },
                TaxWithdrawBalanceAwardFrom: function (value) {
                    return value >= 0 && value <= 100; // Must be between 0 and 100
                },
                TaxRegulatorFrom: function (value) {
                    return value >= 0 && value <= 100; // Must be between 0 and 100
                },
                TaxRegulator: function (value) {
                    return value >= 0 && value <= 100; // Must be between 0 and 100
                },
                TaxWithdrawBalanceDepositFrom: function (value) {
                    return value >= 0 && value <= 100; // Must be between 0 and 100
                },
                TaxBetPayPrize: function (value) {
                    return value >= 0 && value <= 100; // Must be between 0 and 100
                },
                TaxBetShopPhysical: function (value) {
                    return value >= 0 && value <= 100; // Must be between 0 and 100
                },
                PlatformCost: function (value) {
                    return value >= 0 && value <= 100; // Must be between 0 and 100
                },
                TimeForExchange: function (value) {
                    return value > 0;
                },
                TimeForExchangeGeneral: function (value) {
                    return value > 0;
                },
                //Error message for the required “DaysFor2FA” field 
                DaysFor2FA: function (value) {
                    if ($$('Autentication2FAUsersOnline').getValue() !== 1) {
                        return true;
                    }
                    if (!(value > 0)) {
                        webix.message({
                            text: 'El campo "Periodicidad de verificación" es requerido y debe ser mayor a 0.',
                            type: 'error',
                        });
                        return false;
                    }
                    return true;
                },
            },
        };
    }

    /**
     * Initializes the form settings for the partner.
     * @param {Object} form - The form object to initialize.
     */
    init(form) {
        const _ = this.app.getService('locale')._; // Localization service
        $$('formSettingsPartner').hide(); // Hide the partner settings form
        /**
         * Saves the partner settings via an AJAX request.
         * @param {Object} item - The settings data to be saved.
         */
        function savePartnerSettings(item) {
            item.RestrictionTime = $$('RestrictionTime').getValue();
            item.OtpNotesTime = $$('OtpNotesTime').getValue();
            webix
                .ajax()
                .headers({
                    'Content-type': 'application/json', // Set content type to JSON
                })
                .post(devConfig.geturlApi() + 'es/Setting/UpdatePartnerSettings', item, {
                    error: function (text, data, XmlHttpRequest) {
                        webix.message('Error! '); // Display error message on failure
                    },
                    success: function (text, data, XmlHttpRequest) {
                        let dataResponse = JSON.parse(text); // Parse the response
                        if (dataResponse.HasError) {
                            if (dataResponse.CodeError != 110012) {
                                webix.message({
                                    text: dataResponse.AlertMessage, // Show alert message if there's an error
                                    title: _('¡Mensaje!'),
                                    type: 'alert-error',
                                });
                            }
                        } else {
                            webix.message({
                                text: _('Informacíon Actualizada'), // Show success message
                                title: _('¡Exito!'),
                                type: 'alert-warning',
                            });
                        }
                    },
                });
        }

        /**
         * Event listener for partner settings filter.
         * @param {Object} filterdata - The data used to filter partner settings.
         */
        this.on(this.app, 'partnerSettings:filter', (filterdata) => {
            // AJAX request to fetch provider partner settings
            webix
                .ajax()
                .headers({
                    'Content-type': 'application/json',
                })
                .post(devConfig.geturlApi() + 'es/Select/ProvidersPartnerSetting', filterdata, {
                    error: function (text, data, XmlHttpRequest) {
                        webix.message('Error! '); // Display error message on failure
                    },
                    success: function (text, data, XmlHttpRequest) {
                        var resp = JSON.parse(text); // Parse the response text
                        // Define options for various providers based on the response data
                        $$('ProviderSMS').define('options', resp.Data.providerSMS);
                        $$('ProviderEmail').define('options', resp.Data.providerEmail);
                        $$('ProviderVerification').define('options', resp.Data.providerVerification);
                        $$('ProviderCRM').define('options', resp.Data.providerCRM);
                        $$('ProviderSignature').define('options', resp.Data.providerSignature);
                        $$('ProviderCPF').define('options', resp.Data.providerCPF);
                        $$('ProviderForCreditCardSelected').define('options', resp.Data.providerCreditCard);
                    },
                });

            // AJAX request to fetch partner settings
            webix.ajax().headers({
                'Content-type': 'application/json',
            }).post(devConfig.geturlApi() + 'es/Setting/GetPartnerSettings', filterdata, {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Display error message on failure
                },
                success: function (text, data2, XmlHttpRequest) {
                    devConfig.setAwardsReferrals([]); // Reset awards referrals
                    devConfig.setConditionsReferrals([]); // Reset conditions referrals
                    var data = JSON.parse(text); // Parse the response text
                    loadingPartnerSettings = false;

                    // Set visibility and values based on the response data
                    const has2FAPermission = devConfig.getPermAction('Autentication2FAUsersOnlineSwitch', 'Switch');
                    if (data.data.Autentication2FAUsersOnline == 'A') {
                        $$('Autentication2FAUsersOnline').setValue(1);
                        if (has2FAPermission) {
                            $$('DaysFor2FA').show();
                        } else {
                            $$('DaysFor2FA').hide();
                        }
                    } else {
                        $$('DaysFor2FA').hide();
                        $$('Autentication2FAUsersOnline').setValue(0);
                    }
                    if (data.data.ActiveWithdrawExpiration == 'A') {
                        $$('WithdrawExpirationTime').show();
                        $$('ActiveWithdrawExpiration').setValue(1);
                    } else {
                        $$('WithdrawExpirationTime').hide();
                        $$('ActiveWithdrawExpiration').setValue(0);
                    }
                    if (data.data.Contingency == 'A') {
                        $$('StateSwith').setValue(1);
                    } else {
                        $$('StateSwith').setValue(0);
                    }
                    if (data.data.Liquidations == 'A') {
                        $$('StateSwith2').setValue(1);
                    } else {
                        $$('StateSwith2').setValue(0);
                    }
                    if (data.data.AutomaticallyActive == 'A') {
                        $$('StateSwith3').setValue(1);
                    } else {
                        $$('StateSwith3').setValue(0);
                    }
                    if (data.data.ActiveRegistrationDeposit == 'A') {
                        $$('StateSwith4').setValue(1);
                    } else {
                        $$('StateSwith4').setValue(0);
                    }
                    if (data.data.AccountVerificationDeposit == 'A') {
                        $$('StateSwith5').setValue(1);
                    } else {
                        $$('StateSwith5').setValue(0);
                    }
                    if (data.data.ActiveRegistrationWithdraw == 'A') {
                        $$('StateSwith6').setValue(1);
                    } else {
                        $$('StateSwith6').setValue(0);
                    }
                    if (data.data.AccountVerificationWithdraw == 'A') {
                        $$('StateSwith7').setValue(1);
                    } else {
                        $$('StateSwith7').setValue(0);
                    }
                    if (data.data.ActivateWithdrawalNotes == 'A') {
                        $$('ActivateWithdrawalNotes').setValue(1);
                    } else {
                        $$('ActivateWithdrawalNotes').setValue(0);
                    }
                    if (data.data.TypeRegister == 'C') {
                        $$('StateSwith8').setValue(1);
                    } else {
                        $$('StateSwith8').setValue(0);
                    }
                    if (data.data.RechargeBalance == 'A') {
                        $$('StateSwith9').setValue(1);
                    } else {
                        $$('StateSwith9').setValue(0);
                    }
                    if (data.data.WithdrawalsBalance == 'A') {
                        $$('StateSwith10').setValue(1);
                    } else {
                        $$('StateSwith10').setValue(0);
                    }
                    if (data.data.BonusesBalance == 'A') {
                        $$('StateSwith11').setValue(1);
                    } else {
                        $$('StateSwith11').setValue(0);
                    }
                    if (data.data.FreebetBalance == 'A') {
                        $$('StateSwith12').setValue(1);
                    } else {
                        $$('StateSwith12').setValue(0);
                    }
                    if (data.data.IsActiveAnonymousBets === 'A') {
                        $$('IsActiveAnonymousBets').setValue(1);
                    } else {
                        $$('IsActiveAnonymousBets').setValue(0);
                    }
                    if (data.data.IsActiveAnonymousDocument === 'A') {
                        $$('IsActiveAnonymousDocument').setValue(1);
                    } else {
                        $$('IsActiveAnonymousDocument').setValue(0);
                    }
                    if (data.data.IsActiveAnonymousPhone === 'A') {
                        $$('IsActiveAnonymousPhone').setValue(1);
                    } else {
                        $$('IsActiveAnonymousPhone').setValue(0);
                    }
                    if (data.data.IsActivateSelectBonus === 'A') {
                        $$('IsActivateSelectBonus').setValue(1);
                    } else {
                        $$('IsActivateSelectBonus').setValue(0);
                    }
                    if (data.data.FreecasinoBalance == 'A') {
                        $$('StateSwith13').setValue(1);
                    } else {
                        $$('StateSwith13').setValue(0);
                    }
                    if (data.data.IsActivateRiskStatus == 'A') {
                        $$('StateSwith14').setValue(1);
                    } else {
                        $$('StateSwith14').setValue(0);
                    }
                    //  Set the value of ActivateBankAccountValidation switch based on the response data
                    if (data.data.ActivateBankAccountValidation == 'A') {
                        $$('ActivateBankAccountValidation').setValue(1);
                    } else {
                        $$('ActivateBankAccountValidation').setValue(0);
                    }
                    //  Set the value of VerificationMincetur switch based on the response data
                    if (data.data.VerificationMincetur == 'A') {
                        $$('VerificationMincetur').setValue(1);
                    } else {
                        $$('VerificationMincetur').setValue(0);
                    }

                    //  Set the value of IsActiveMultiCountryLogin switch based on the response data
                    if (data.data.IsActiveMultiCountryLogin == 'A') {
                        $$('IsActiveMultiCountryLogin').setValue(1);
                    } else {
                        $$('IsActiveMultiCountryLogin').setValue(0);
                    }
                    if (data.data.ShowActiveMultiCountryLogin == 'A') {
                        $$('multiCountryLoginLabel').show(); // Show label
                        $$('IsActiveMultiCountryLogin').show(); // Show switch
                    } else {
                        $$('multiCountryLoginLabel').hide(); // Hide label
                        $$('IsActiveMultiCountryLogin').hide(); // Hide switch
                    }

                    if (data.data.CommissionFreeTransactions == 'A') {
                        $$('StateSwith15').setValue(1);
                    } else {
                        $$('StateSwith15').setValue(0);
                    }

                    if (data.data.ExchangeOfTheSameGiftEveryXTime == 'A') {
                        $$('StateSwith18').setValue(1);
                    } else {
                        $$('StateSwith18').setValue(0);
                    }

                    if (data.data.MinimumTimeBetweenAnyExchanges == 'A') {
                        $$('StateSwith16').setValue(1);
                    } else {
                        $$('StateSwith16').setValue(0);
                    }
                    if (data.data.RequiresVerificationForLoyalty == 'A') {
                        $$('StateSwith17').setValue(1);
                    } else {
                        $$('StateSwith17').setValue(0);
                    }
                    // New Jumio Auto Update Type Doc
                    if (data.data.IsActiveJumioAutoUpdateTypeDoc == 'A') {
                        $$('StateSwith19').setValue(1);
                    } else {
                        $$('StateSwith19').setValue(0);
                    }

                    if (data.data.VerificaFiltroPV === 'A') {
                        $$('VerificaFiltroPV').setValue(1);
                    } else {
                        $$('VerificaFiltroPV').setValue(0);
                    }
                    if (data.data.EmailWrongLoginAttempts === 'A') {
                        $$('EmailWrongLoginAttempts').setValue(1);
                    } else {
                        $$('EmailWrongLoginAttempts').setValue(0);
                    }
                    if (data.data.InactiveAutomaticRule === 'A') {
                        $$('InactiveAutomaticRule').setValue(1);
                    } else {
                        $$('InactiveAutomaticRule').setValue(0);
                    }
                    if (data.data.ValidateCompliance === 'A') {
                        $$('ValidateCompliance').setValue(1);
                    } else {
                        $$('ValidateCompliance').setValue(0);
                    }
                    if (data.data.VerificaFiltro === 'A') {
                        $$('VerificaFiltro').setValue(1);
                    } else {
                        $$('VerificaFiltro').setValue(0);
                    }
                    if (data.data.IsActiveSms === 'A') {
                        $$('IsActiveSms').setValue(1);
                    } else {
                        $$('IsActiveSms').setValue(0);
                    }
                    if (data.data.IsActivePopUp === 'A') {
                        $$('IsActivePopUp').setValue(1);
                    } else {
                        $$('IsActivePopUp').setValue(0);
                    }
                    if (data.data.FirstDeposit === 'A') {
                        $$('FirstDeposit').setValue(1);
                    } else {
                        $$('FirstDeposit').setValue(0);
                    }
                    if (data.data.VerifiedMail === 'A') {
                        $$('VerifiedMail').setValue(1);
                    } else {
                        $$('VerifiedMail').setValue(0);
                    }
                    if (data.data.VerifiedPhone === 'A') {
                        $$('VerifiedPhone').setValue(1);
                    } else {
                        $$('VerifiedPhone').setValue(0);
                    }
                    if (data.data.IsActiveEmail === 'A') {
                        $$('IsActiveEmail').setValue(1);
                    } else {
                        $$('IsActiveEmail').setValue(0);
                    }
                    if (data.data.IsActiveInbox === 'A') {
                        $$('IsActiveInbox').setValue(1);
                    } else {
                        $$('IsActiveInbox').setValue(0);
                    }
                    // Set the value of ClearCharacters switch based on the response data
                    if (data.data.ClearCharacters === 'A') {
                        $$('ClearCharacters').setValue(1);
                    } else {
                        $$('ClearCharacters').setValue(0);
                    }
                    if (data.data.SetMins !== null) {
                        $$('SetMins').setValue(data.data.SetMins);
                    }
                    if (data.data.WithdrawExpirationTime !== null && data.data.WithdrawExpirationTime !== '') {
                        $$('WithdrawExpirationTime').setValue(data.data.WithdrawExpirationTime);
                    } else {
                        $$('WithdrawExpirationTime').setValue('');
                    }
                    // Set the value of DaysFor2FA based on the response data
                    if (data.data.DaysFor2FA !== null && data.data.DaysFor2FA !== '') {
                        $$('DaysFor2FA').setValue(data.data.DaysFor2FA);
                    } else {
                        $$('DaysFor2FA').setValue('');
                    }


                    //new variable
                    if (data.data.RestrictionTime !== null && data.data.RestrictionTime !== '') {
                        $$('RestrictionTime').setValue(data.data.RestrictionTime);
                    } else {
                        $$('RestrictionTime').setValue('');
                    }

                    if (data.data.BoUserPasswordExpireDays !== null) {
                        $$('BoUserPasswordExpireDays').setValue(parseInt(data.data.BoUserPasswordExpireDays));
                    }
                    if (data.ReferredBonuses.length > 0) {
                        data.ReferredBonuses.forEach((bonus) => {
                            bonus.id = bonus.BonoId; // Set bonus ID
                            bonus.value = bonus.Name; // Set bonus value
                        });
                        webix.storage.local.put('bonusReferrals', data.ReferredBonuses); // Store bonuses in local storage
                    } else {
                        webix.storage.local.put('bonusReferrals', []); // Store empty array if no bonuses
                    }
                    if (data.data.ReferentConditions.length > 0) {
                        if ($$('ElementsReferralConditionsItems').getChildViews().length > 0) {
                            $$('ElementsReferralConditionsItems').removeView('ReferralConditionsItems');
                        }
                        let conditionsElements = [];
                        data.data.ReferentConditions.map((condition) => {
                            let conditionsReferrals = devConfig.getConditionsReferrals();
                            conditionsReferrals.push(condition);
                            if (condition.Type && condition.Type === 'switch') {
                                conditionsElements.push({
                                    rows: [
                                        {
                                            view: 'label',
                                            label: condition.Label,
                                            css: {
                                                'text-align': 'center',
                                            },
                                        },
                                        {
                                            id: condition.Condition,
                                            name: condition.Condition,
                                            view: 'switch',
                                            onLabel: 'Si',
                                            offLabel: 'No',
                                            value: condition.Value,
                                        },
                                    ],
                                });
                            } else {
                                conditionsElements.push({
                                    rows: [
                                        {
                                            view: 'label',
                                            label: "<div class='tittle'>" + _(condition.Label) + '</div>',
                                        },
                                        {
                                            view: 'text',
                                            name: condition.Condition,
                                            id: condition.Condition,
                                            type: 'number',
                                            placeholder: 'Valor',
                                            invalidMessage: 'Campo Requerido',
                                            value: condition.Value,
                                        },
                                    ],
                                });
                            }
                            devConfig.setConditionsReferrals(conditionsReferrals); // Update conditions referrals
                        });
                        $$('ElementsReferralConditionsItems').addView({
                            id: 'ReferralConditionsItems',
                            cols: conditionsElements,
                        });
                    } else {
                        if ($$('ElementsReferralConditionsItems').getChildViews().length > 0) {
                            $$('ElementsReferralConditionsItems').removeView('ReferralConditionsItems');
                        } else {
                            $$('ElementsReferralConditionsItems').addView({
                                id: 'ReferralConditionsItems',
                                margin: 10,
                                rows: [
                                    {
                                        view: 'label',
                                        label: 'No hay condiciones agregadas',
                                        css: { 'text-align': 'center' },
                                    },
                                ],
                            });
                        }
                    }
                    if (data.data.UrlLanding !== null && data.data.UrlLanding !== '') {
                        $$('UrlLanding').setValue(data.data.UrlLanding);
                    } else {
                        $$('UrlLanding').setValue('');
                    }
                    if (data.data.ReferredMinSelValue !== null && data.data.ReferredMinSelValue !== '') {
                        $$('ReferredMinSelValue').setValue(data.data.ReferredMinSelValue);
                    } else {
                        $$('ReferredMinSelValue').setValue(0);
                    }
                    if (data.GamesCategories.length > 0) {
                        data.GamesCategories.forEach((category) => {
                            category.value = category.description; // Set category value
                        });
                        if ($$('ElementsReferralCategoriesItems').getChildViews().length > 0) {
                            $$('ElementsReferralCategoriesItems').removeView('ExcludedCategoriesMinBetReferred');
                        }
                        $$('ElementsReferralCategoriesItems').addView({
                            margin: 20,
                            view: 'dbllist',
                            name: 'ExcludedCategoriesMinBetReferred',
                            id: 'ExcludedCategoriesMinBetReferred',
                            list: { height: 200, margin: 10 },
                            labelLeft: 'Todas',
                            labelRight: 'Excluidas',
                            data: data.GamesCategories,
                            value: data.data.ExcludedCategoriesMinBetReferred.toString(),
                            css: 'webix_dbllist2',
                        });
                    } else {
                        if ($$('ElementsReferralCategoriesItems').getChildViews().length > 0) {
                            $$('ElementsReferralCategoriesItems').removeView('ExcludedCategoriesMinBetReferred');
                        }
                        $$('ElementsReferralCategoriesItems').addView({
                            margin: 20,
                            view: 'dbllist',
                            name: 'ExcludedCategoriesMinBetReferred',
                            id: 'ExcludedCategoriesMinBetReferred',
                            list: { height: 150, margin: 10 },
                            labelLeft: 'Todas',
                            labelRight: 'Excluidas',
                            css: 'webix_dbllist2',
                        });
                    }
                    if (data.data.ReferredAwards.length > 0) {
                        if ($$('ElementsReferralsAward').getChildViews().length > 1) {
                            $$('ElementsReferralsAward').removeView('ReferralsAwardItems');
                        }
                        let awardsElements = [];
                        let awardsList = [];
                        data.data.ReferredAwards.map((award) => {
                            award.IsNew = false; // Mark award as not new
                            awardsList.push(award); // Add award to the list
                            let conditionsElements = [];
                            award.Conditions.map((condition) => {
                                conditionsElements.push({
                                    rows: [
                                        { view: 'label', label: condition.Label },
                                        {
                                            view: 'text',
                                            name: condition.Condition + award.AwardId,
                                            id: condition.Condition + award.AwardId,
                                            type: 'number',
                                            placeholder: 'Valor',
                                            invalidMessage: 'Campo Requerido',
                                            value: condition.Value,
                                        },
                                    ],
                                });
                            });
                            conditionsElements.push({
                                cols: [
                                    {},
                                    {},
                                    {},
                                    {
                                        rows: [
                                            {
                                                view: 'label',
                                                label: 'Cuenta verificada',
                                                css: { 'text-align': 'center' },
                                            },
                                            {
                                                id: 'IsVerified' + award.AwardId,
                                                name: 'IsVerified' + award.AwardId,
                                                view: 'switch',
                                                onLabel: 'Si',
                                                offLabel: 'No',
                                                value: award.IsVerified,
                                            },
                                        ],
                                    },
                                ],
                            });
                            awardsElements.push({
                                view: 'form',
                                id: 'Award' + award.AwardId,
                                margin: 10,
                                rows: [
                                    {
                                        cols: [
                                            {
                                                view: 'text',
                                                name: 'AwardName' + award.AwardId,
                                                id: 'AwardName' + award.AwardId,
                                                label: 'Nombre de recompensa',
                                                labelPosition: 'top',
                                                placeholder: 'Nombre',
                                                invalidMessage: 'Campo Requerido',
                                                value: award.AwardName,
                                            },
                                            {
                                                cols: [
                                                    {},
                                                    {},
                                                    {},
                                                    {
                                                        view: 'button',
                                                        label: 'Eliminar',
                                                        css: 'webix_danger2',
                                                        click: function () {
                                                            let awards = devConfig.getAwardsReferrals();
                                                            awards = awards.filter(function (item) {
                                                                return item.AwardId !== award.AwardId; // Remove award from the list
                                                            });
                                                            devConfig.setAwardsReferrals(awards); // Update awards referrals
                                                            if (awards.length > 2) {
                                                                $$('addAwardButtons').hide(); // Hide add button if more than 2 awards
                                                            } else {
                                                                $$('addAwardButtons').show(); // Show add button if 2 or fewer awards
                                                            }
                                                            $$('ReferralsAwardItems').removeView(
                                                                'Award' + award.AwardId,
                                                            ); // Remove award view
                                                            if (
                                                                $$('ReferralsAwardItems').getChildViews().length ===
                                                                0
                                                            ) {
                                                                $$('ElementsReferralsAward').removeView(
                                                                    'ReferralsAwardItems',
                                                                );
                                                                $$('ElementsReferralsAward').addView({
                                                                    id: 'ReferralsAwardItems',
                                                                    margin: 10,
                                                                    view: 'form',
                                                                    rows: [
                                                                        {
                                                                            view: 'label',
                                                                            label: 'No hay premios agregados',
                                                                            css: { 'text-align': 'center' },
                                                                        },
                                                                    ],
                                                                });
                                                            }
                                                        },
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                    {
                                        minWidth: 200,
                                        margin: 10,
                                        cols: conditionsElements,
                                    },
                                    {
                                        margin: 10,
                                        rows: [
                                            {
                                                view: 'label',
                                                label: _('Bonos'),
                                            },
                                            {
                                                view: 'label',
                                                template:
                                                    "<img src='https://images.virtualsoft.tech/m/msj0212T1708977286.png' alt=''>" +
                                                    '<span>' +
                                                    _('Mueve los elementos a la categoría requerida.') +
                                                    '</span>',
                                                css: {
                                                    color: '#313131',
                                                    'text-align': 'center',
                                                    display: 'flex',
                                                    'align-items': 'center',
                                                    'justify-content': 'center',
                                                    gap: '10px',
                                                },
                                            },
                                            {
                                                view: 'dbllist',
                                                name: 'OfertedBonuses' + award.AwardId,
                                                id: 'OfertedBonuses' + award.AwardId,
                                                list: { height: 200 },
                                                labelLeft: 'Disponibles',
                                                labelRight: 'Seleccionados',
                                                data: data.ReferredBonuses,
                                                value: award.OfertedBonuses.toString(),
                                                css: 'webix_dbllist2',
                                            },
                                        ],
                                    },
                                ],
                            });
                        });
                        devConfig.setAwardsReferrals(awardsList); // Update awards referrals
                        $$('ElementsReferralsAward').addView({
                            id: 'ReferralsAwardItems',
                            margin: 10,
                            view: 'layout',
                            rows: awardsElements,
                        });
                        if (awardsList.length > 2) {
                            $$('addAwardButtons').hide(); // Hide add button if more than 2 awards
                        } else {
                            $$('addAwardButtons').show(); // Show add button if 2 or fewer awards
                        }
                    } else {
                        devConfig.setAwardsReferrals([]); // Reset awards referrals
                        if ($$('ElementsReferralsAward').getChildViews().length > 0) {
                            $$('ElementsReferralsAward').removeView('ReferralsAwardItems');
                        }
                        $$('addAwardButtons').show(); // Show add button
                        $$('ElementsReferralsAward').addView({
                            id: 'ReferralsAwardItems',
                            margin: 10,
                            view: 'form',
                            rows: [
                                {
                                    view: 'label',
                                    label: 'No hay premios agregados',
                                    css: { 'text-align': 'center' },
                                },
                            ],
                        });
                    }
                    if (data.data.AwardLimitFulfillmentDayReferred !== null) {
                        $$('AwardLimitFulfillmentDayReferred').setValue(
                            parseInt(data.data.AwardLimitFulfillmentDayReferred),
                        );
                    } else {
                        $$('AwardLimitFulfillmentDayReferred').setValue(0);
                    }
                    if (data.data.AwardLimitRedemptionDayReferent !== null) {
                        $$('AwardLimitRedemptionDayReferent').setValue(
                            parseInt(data.data.AwardLimitRedemptionDayReferent),
                        );
                    } else {
                        $$('AwardLimitRedemptionDayReferent').setValue(0);
                    }
                    if (data.data.AcceptReferred === '1') {
                        $$('AcceptReferred').setValue(1);
                    } else {
                        $$('AcceptReferred').setValue(0);
                    }
                    if (data.data.IsReferralEmailEnabled === 'A') {
                        $$('IsReferralEmailEnabled').setValue(1);
                    } else {
                        $$('IsReferralEmailEnabled').setValue(0);
                    }
                    if (data.data.SportsBetsUserOnline === 'A') {
                        $$('SportsBetsUserOnline').setValue(1);
                    } else {
                        $$('SportsBetsUserOnline').setValue(0);
                    }
                    if (data.data.CasinoBetsUserOnline === 'A') {
                        $$('CasinoBetsUserOnline').setValue(1);
                    } else {
                        $$('CasinoBetsUserOnline').setValue(0);
                    }
                    if (data.data.LiveCasinoUserOnline === 'A') {
                        $$('LiveCasinoUserOnline').setValue(1);
                    } else {
                        $$('LiveCasinoUserOnline').setValue(0);
                    }
                    if (data.data.VirtualBetsUserOnline === 'A') {
                        $$('VirtualBetsUserOnline').setValue(1);
                    } else {
                        $$('VirtualBetsUserOnline').setValue(0);
                    }
                    if (data.data.PokerUserOnline === 'A') {
                        $$('PokerUserOnline').setValue(1);
                    } else {
                        $$('PokerUserOnline').setValue(0);
                    }
                    if (data.data.RetirementNotesUserOnline === 'A') {
                        $$('RetirementNotesUserOnline').setValue(1);
                    } else {
                        $$('RetirementNotesUserOnline').setValue(0);
                    }
                    if (data.data.DepositUserOnline === 'A') {
                        $$('DepositUserOnline').setValue(1);
                    } else {
                        $$('DepositUserOnline').setValue(0);
                    }
                    if (data.data.HipicaUserOnline === 'A') {
                        $$('HipicaUserOnline').setValue(1);
                    } else {
                        $$('HipicaUserOnline').setValue(0);
                    }
                    if (data.data.SportsBetsPv === 'A') {
                        $$('SportsBetsPv').setValue(1);
                    } else {
                        $$('SportsBetsPv').setValue(0);
                    }
                    if (data.data.PayRetirementNotesPv === 'A') {
                        $$('PayRetirementNotesPv').setValue(1);
                    } else {
                        $$('PayRetirementNotesPv').setValue(0);
                    }
                    if (data.data.PayDepositPv === 'A') {
                        $$('PayDepositPv').setValue(1);
                    } else {
                        $$('PayDepositPv').setValue(0);
                    }
                    if (data.data.PayAwardsPv === 'A') {
                        $$('PayAwardsPv').setValue(1);
                    } else {
                        $$('PayAwardsPv').setValue(0);
                    }
                    if (data.data.VirtualBetsPv === 'A') {
                        $$('VirtualBetsPv').setValue(1);
                    } else {
                        $$('VirtualBetsPv').setValue(0);
                    }
                    if (data.data.SportsBetsAtm === 'A') {
                        $$('SportsBetsAtm').setValue(1);
                    } else {
                        $$('SportsBetsAtm').setValue(0);
                    }
                    if (data.data.PayRetirementNotesAtm === 'A') {
                        $$('PayRetirementNotesAtm').setValue(1);
                    } else {
                        $$('PayRetirementNotesAtm').setValue(0);
                    }
                    if (data.data.PayDepositAtm === 'A') {
                        $$('PayDepositAtm').setValue(1);
                    } else {
                        $$('PayDepositAtm').setValue(0);
                    }
                    if (data.data.PayAwardsAtm === 'A') {
                        $$('PayAwardsAtm').setValue(1);
                    } else {
                        $$('PayAwardsAtm').setValue(0);
                    }
                    if (data.data.VirtualBetsAtm === 'A') {
                        $$('VirtualBetsAtm').setValue(1);
                    } else {
                        $$('VirtualBetsAtm').setValue(0);
                    }
                    if (data.data.DepositPhoneVerification === 'A') {
                        $$('DepositPhoneVerification').setValue(1);
                    } else {
                        $$('DepositPhoneVerification').setValue(0);
                    }
                    if (data.data.SportBetsPhoneVerification === 'A') {
                        $$('SportBetsPhoneVerification').setValue(1);
                    } else {
                        $$('SportBetsPhoneVerification').setValue(0);
                    }
                    if (data.data.CasinoBetsPhoneVerification === 'A') {
                        $$('CasinoBetsPhoneVerification').setValue(1);
                    } else {
                        $$('CasinoBetsPhoneVerification').setValue(0);
                    }
                    if (data.data.WithdrawalPhoneVerification === 'A') {
                        $$('WithdrawalPhoneVerification').setValue(1);
                    } else {
                        $$('WithdrawalPhoneVerification').setValue(0);
                    }
                    if (data.data.LiveCasinoPhoneVerification === 'A') {
                        $$('LiveCasinoPhoneVerification').setValue(1);
                    } else {
                        $$('LiveCasinoPhoneVerification').setValue(0);
                    }
                    if (data.data.VirtualPhoneVerification === 'A') {
                        $$('VirtualPhoneVerification').setValue(1);
                    } else {
                        $$('VirtualPhoneVerification').setValue(0);
                    }
                    if (data.LandingFreeBetBonuses && data.LandingFreeBetBonuses.length > 0) {
                        if ($$('ElementsLandingBonusesFreeBetItems').getChildViews().length > 0) {
                            $$('ElementsLandingBonusesFreeBetItems').removeView('LandingFreeBetBonuses');
                        }
                        $$('ElementsLandingBonusesFreeBetItems').addView({
                            margin: 10,
                            view: 'dbllist',
                            name: 'LandingFreeBetBonuses',
                            id: 'LandingFreeBetBonuses',
                            list: { height: 200, margin: 10 },
                            labelLeft: 'Todos los bonos',
                            labelRight: 'Bono seleccionado',
                            data: data.LandingFreeBetBonuses,
                            value: data.data.LandingFreeBetBonusesSelected,
                            css: 'webix_dbllist2',
                            buttons:
                                "<button class='dbllist_button' action='select_one' style='width:100%; margin-right:0;'>Select</button><button class='dbllist_button' action='deselect_one' style='width:100%;margin-left:0;'>Remove</button>",
                        });
                    } else {
                        if ($$('ElementsLandingBonusesFreeBetItems').getChildViews().length > 0) {
                            $$('ElementsLandingBonusesFreeBetItems').removeView('LandingFreeBetBonuses');
                        }
                        $$('ElementsLandingBonusesFreeBetItems').addView({
                            margin: 20,
                            view: 'dbllist',
                            name: 'LandingFreeBetBonuses',
                            id: 'LandingFreeBetBonuses',
                            list: { height: 150, margin: 10 },
                            labelLeft: 'Todos los bonos',
                            labelRight: 'Bono seleccionado',
                            css: 'webix_dbllist2',
                            buttons:
                                "<button class='dbllist_button' action='select_one' style='width:100%; margin-right:0;'>Select</button><button class='dbllist_button' action='deselect_one' style='width:100%;margin-left:0;'>Remove</button>",
                        });
                    }
                    if (data.LandingFreeCasinoBonuses && data.LandingFreeCasinoBonuses.length > 0) {
                        if ($$('ElementsLandingBonusesFreeCasinoItems').getChildViews().length > 0) {
                            $$('ElementsLandingBonusesFreeCasinoItems').removeView('LandingFreeCasinoBonuses');
                        }
                        $$('ElementsLandingBonusesFreeCasinoItems').addView({
                            margin: 10,
                            view: 'dbllist',
                            name: 'LandingFreeCasinoBonuses',
                            id: 'LandingFreeCasinoBonuses',
                            list: { height: 200, margin: 10 },
                            labelLeft: 'Todos los bonos',
                            labelRight: 'Bono seleccionado',
                            data: data.LandingFreeCasinoBonuses,
                            value: data.data.LandingFreeCasinoBonusesSelected,
                            css: 'webix_dbllist2',
                            buttons:
                                "<button class='dbllist_button' action='select_one' style='width:100%; margin-right:0;'>Select</button><button class='dbllist_button' action='deselect_one' style='width:100%;margin-left:0;'>Remove</button>",
                        });
                    } else {
                        if ($$('ElementsLandingBonusesFreeCasinoItems').getChildViews().length > 0) {
                            $$('ElementsLandingBonusesFreeCasinoItems').removeView('LandingFreeCasinoBonuses');
                        }
                        $$('ElementsLandingBonusesFreeCasinoItems').addView({
                            margin: 20,
                            view: 'dbllist',
                            name: 'LandingFreeCasinoBonuses',
                            id: 'LandingFreeCasinoBonuses',
                            list: { height: 150, margin: 10 },
                            labelLeft: 'Todos los bonos',
                            labelRight: 'Bono seleccionado',
                            css: 'webix_dbllist2',
                            buttons:
                                "<button class='dbllist_button' action='select_one' style='width:100%; margin-right:0;'>Select</button><button class='dbllist_button' action='deselect_one' style='width:100%;margin-left:0;'>Remove</button>",
                        });
                    }
                    if (data.TotalityBirthday && data.TotalityBirthday.length > 0) {
                        if ($$('ElementsBirthdayBonusesItems').getChildViews().length > 0) {
                            $$('ElementsBirthdayBonusesItems').removeView('TotalityBirthday');
                        }
                        $$('ElementsBirthdayBonusesItems').addView({
                            margin: 10,
                            view: 'dbllist',
                            name: 'TotalityBirthday',
                            id: 'TotalityBirthday',
                            list: { height: 200, margin: 10 },
                            labelLeft: 'Todos los bonos',
                            labelRight: 'Bono seleccionado',
                            data: data.TotalityBirthday,
                            value: data.data.TotalityBonusesBirthdaySelected,
                            css: 'webix_dbllist2',
                            buttons: `
                                    <button class="dbllist_button" action="select_one" style="width:100%; margin-right:0;">Select</button>
                                    <button class="dbllist_button" action="deselect_one" style="width:100%; margin-left:0;">Remove</button>
                                `,
                        });
                    }

                    /**
                     * Handles the filter data for specific fields.
                     * @param {string} field - The field to check.
                     * @param {string} valueField - The corresponding value field to set.
                     */
                    function handleFilterData(field, valueField) {
                        if (data.data[field] && data.data[field] === 'A') {
                            $$(field).setValue(1);
                            if (data.data[valueField]) {
                                $$(valueField).setValue(data.data[valueField]);
                            }
                        } else {
                            $$(field).setValue(0);
                        }
                    }

                    // Call handleFilterData for various fields
                    handleFilterData('IsSportbookGgrPvIpConcessionaire', 'SportbookGgrPvIpConcessionaire');
                    handleFilterData('IsDepositPvConcessionaire', 'DepositPvConcessionaire');
                    handleFilterData('IsWithdrawalsNotesPvConcessionaire', 'WithdrawalsNotesPvConcessionaire');
                    handleFilterData('IsSportbookGgrAfConcessionaire', 'SportbookGgrAfConcessionaire');
                    handleFilterData('IsSportbookNgrAfConcessionaire', 'SportbookNgrAfConcessionaire');
                    handleFilterData('IsSportbookGgrPvConcessionaire', 'SportbookGgrPvConcessionaire');
                    handleFilterData('IsBetSportPvConcessionaire', 'BetSportPvConcessionaire');
                    handleFilterData('IsCasinoNgrAfConcessionaire', 'CasinoNgrAfConcessionaire');
                    handleFilterData(
                        'IsDepositCommissionTransactionConcessionaire',
                        'DepositCommissionTransactionConcessionaire',
                    );
                    handleFilterData('IsDepositAfConcessionaire', 'DepositAfConcessionaire');
                    handleFilterData('IsSportbookGgrPvIpSubdealer', 'SportbookGgrPvIpSubdealer');
                    handleFilterData('IsDepositPvSubdealer', 'DepositPvSubdealer');
                    handleFilterData('IsWithdrawalsNotesPvSubdealer', 'WithdrawalsNotesPvSubdealer');
                    handleFilterData('IsSportbookGgrAfSubdealer', 'SportbookGgrAfSubdealer');
                    handleFilterData('IsSportbookNgrAfSubdealer', 'SportbookNgrAfSubdealer');
                    handleFilterData('IsSportbookGgrPvSubdealer', 'SportbookGgrPvSubdealer');
                    handleFilterData('IsBetSportPvSubdealer', 'BetSportPvSubdealer');
                    handleFilterData('IsCasinoNgrAfSubdealer', 'CasinoNgrAfSubdealer');
                    handleFilterData(
                        'IsDepositCommissionTransactionSubdealer',
                        'DepositCommissionTransactionSubdealer',
                    );
                    handleFilterData('IsDepositAfSubdealer', 'DepositAfSubdealer');
                    handleFilterData('IsSportbookGgrPvIpPointSale', 'SportbookGgrPvIpPointSale');
                    handleFilterData('IsDepositPvPointSale', 'DepositPvPointSale');
                    handleFilterData('IsWithdrawalsNotesPvPointSale', 'WithdrawalsNotesPvPointSale');
                    handleFilterData('IsSportbookGgrAfPointSale', 'SportbookGgrAfPointSale');
                    handleFilterData('IsSportbookNgrAfPointSale', 'SportbookNgrAfPointSale');
                    handleFilterData('IsSportbookGgrPvPointSale', 'SportbookGgrPvPointSale');
                    handleFilterData('IsBetSportPvPointSale', 'BetSportPvPointSale');
                    handleFilterData('IsCasinoNgrAfPointSale', 'CasinoNgrAfPointSale');
                    handleFilterData(
                        'IsDepositCommissionTransactionPointSale',
                        'DepositCommissionTransactionPointSale',
                    );
                    handleFilterData('IsDepositAfPointSale', 'DepositAfPointSale');
                    handleFilterData('IsSportbookGgrPvIpAffiliate', 'SportbookGgrPvIpAffiliate');
                    handleFilterData('IsDepositPvAffiliate', 'DepositPvAffiliate');
                    handleFilterData('IsWithdrawalsNotesPvAffiliate', 'WithdrawalsNotesPvAffiliate');
                    handleFilterData('IsSportbookGgrAfAffiliate', 'SportbookGgrAfAffiliate');
                    handleFilterData('IsSportbookNgrAfAffiliate', 'SportbookNgrAfAffiliate');
                    handleFilterData('IsSportbookGgrPvAffiliate', 'SportbookGgrPvAffiliate');
                    handleFilterData('IsBetSportPvAffiliate', 'BetSportPvAffiliate');
                    handleFilterData('IsCasinoNgrAfAffiliate', 'CasinoNgrAfAffiliate');
                    handleFilterData(
                        'IsDepositCommissionTransactionAffiliate',
                        'DepositCommissionTransactionAffiliate',
                    );
                    handleFilterData('IsDepositAfAffiliate', 'DepositAfAffiliate');

                    // Handle OTP notes settings for point of sale
                    if (
                        data.data.IsActivateOtpNotesPuntoDeVenta &&
                        data.data.IsActivateOtpNotesPuntoDeVenta === 'A'
                    ) {
                        $$('IsActivateOtpNotesPuntoDeVenta').setValue(1);
                        if (data.data.OtpNotesTime) {
                            $$('OtpNotesTime').setValue(data.data.OtpNotesTime);
                        }
                        if (data.data.IsActivateOtpNotesEmailPV && data.data.IsActivateOtpNotesEmailPV === 'A') {
                            $$('IsActivateOtpNotesEmailPV').setValue(1);
                        } else {
                            $$('IsActivateOtpNotesEmailPV').setValue(0);
                        }
                        if (data.data.IsActivateOtpNotesSmsPV && data.data.IsActivateOtpNotesSmsPV === 'A') {
                            $$('IsActivateOtpNotesSmsPV').setValue(1);
                        } else {
                            $$('IsActivateOtpNotesSmsPV').setValue(0);
                        }
                    } else {
                        $$('IsActivateOtpNotesPuntoDeVenta').setValue(0);
                    }

                    // Handle OTP notes settings for bank account
                    if (
                        data.data.IsActivateOtpNotesCuentaBancaria &&
                        data.data.IsActivateOtpNotesCuentaBancaria === 'A'
                    ) {
                        $$('IsActivateOtpNotesCuentaBancaria').setValue(1);
                        if (data.data.OtpNotesTime) {
                            $$('OtpNotesTime').setValue(data.data.OtpNotesTime);
                        }
                        if (data.data.IsActivateOtpNotesEmailCB && data.data.IsActivateOtpNotesEmailCB === 'A') {
                            $$('IsActivateOtpNotesEmailCB').setValue(1);
                        } else {
                            $$('IsActivateOtpNotesEmailCB').setValue(0);
                        }
                        if (data.data.IsActivateOtpNotesSmsCB && data.data.IsActivateOtpNotesSmsCB === 'A') {
                            $$('IsActivateOtpNotesSmsCB').setValue(1);
                        } else {
                            $$('IsActivateOtpNotesSmsCB').setValue(0);
                        }
                    } else {
                        $$('IsActivateOtpNotesCuentaBancaria').setValue(0);
                    }
                    const active =
                        (data.data.IsActivateDepositTimePDV && data.data.IsActivateDepositTimePDV) === 'A';
                    $$('IsActivateDepositTimePDV').setValue(active ? 1 : 0);
                    const time = $$('TimeForDepositPDV');
                    if (active) {
                        time.show();
                    } else {
                        time.hide();
                    }
                    // Prevent 'onChange' validations from inputs, while filling  the form
                    loadingPartnerSettings = true;

                    form.setValues(data.data); // Set form values based on the response data

                    $$('ValidationsCasino').setValue(data.data.ValidationsCasino === 'A' ? 1 : 0);
                    $$('ValidationsLiveCasino').setValue(data.data.ValidationsLiveCasino === 'A' ? 1 : 0);
                    $$('ValidationsVirtuals').setValue(data.data.ValidationsVirtuals === 'A' ? 1 : 0);
                    $$('ValidationsSportbook').setValue(data.data.ValidationsSportbook === 'A' ? 1 : 0);

                    loadingPartnerSettings = false;
                },
            });
        });

        // Event listener for saving partner settings
        this.on(this.app, 'partnerSettings:save', (data) => {
            let filterdata = data; // Create a copy of the incoming data
            filterdata.Partner = data.Partner; // Set partner information
            filterdata.Country = data.Country; // Set country information
            // Collect various settings from the form
            filterdata.Contingency = $$('StateSwith').getValue();
            filterdata.Liquidations = $$('StateSwith2').getValue();
            filterdata.AutomaticallyActive = $$('StateSwith3').getValue();
            filterdata.ActiveRegistrationDeposit = $$('StateSwith4').getValue();
            filterdata.AccountVerificationDeposit = $$('StateSwith5').getValue();
            filterdata.ActiveRegistrationWithdraw = $$('StateSwith6').getValue();
            filterdata.AccountVerificationWithdraw = $$('StateSwith7').getValue();
            filterdata.ActivateWithdrawalNotes = $$('ActivateWithdrawalNotes').getValue() === 1 ? 'A' : 'I';
            filterdata.TypeRegister = $$('StateSwith8').getValue();
            filterdata.RechargeBalance = $$('StateSwith9').getValue();
            filterdata.WithdrawalsBalance = $$('StateSwith10').getValue();
            filterdata.BonusesBalance = $$('StateSwith11').getValue();
            filterdata.FreebetBalance = $$('StateSwith12').getValue();
            filterdata.FreecasinoBalance = $$('StateSwith13').getValue();
            filterdata.IsActivateRiskStatus = $$('StateSwith14').getValue();
            filterdata.ActivateBankAccountValidation = $$('ActivateBankAccountValidation').getValue();  // Bank account validation
            filterdata.VerificationMincetur = $$('VerificationMincetur').getValue();  // Mincetur verification
            filterdata.IsActiveMultiCountryLogin = $$('IsActiveMultiCountryLogin').getValue();  // Mincetur verification
            filterdata.RequiresVerificationForLoyalty = $$("StateSwith17").getValue();
            filterdata.IsActiveJumioAutoUpdateTypeDoc = $$("StateSwith19").getValue(); // Jumio auto-update type document
            filterdata.CommissionFreeTransactions = $$("StateSwith15").getValue();
            filterdata.VerificaFiltro = $$('VerificaFiltro').getValue();
            filterdata.VerificaFiltroPV = $$('VerificaFiltroPV').getValue();
            filterdata.ActiveWithdrawExpiration = $$('ActiveWithdrawExpiration').getValue() === 1 ? 'A' : 'I';
            filterdata.ExchangeOfTheSameGiftEveryXTime = $$('StateSwith18').getValue() === 1 ? 'A' : 'I';
            filterdata.MinimumTimeBetweenAnyExchanges = $$('StateSwith16').getValue() === 1 ? 'A' : 'I';
            filterdata.WithdrawExpirationTime = $$('WithdrawExpirationTime').getValue();
            filterdata.DaysFor2FA = $$('DaysFor2FA').getValue();
            filterdata.SetMins = parseInt($$('SetMins').getValue());
            filterdata.BoUserPasswordExpireDays = parseInt($$('BoUserPasswordExpireDays').getValue());
            filterdata.IsActiveSms = $$('IsActiveSms').getValue();
            filterdata.IsActivePopUp = $$('IsActivePopUp').getValue();
            filterdata.IsActiveEmail = $$('IsActiveEmail').getValue();
            filterdata.IsActiveInbox = $$('IsActiveInbox').getValue();
            filterdata.ClearCharacters = $$('ClearCharacters').getValue();
            filterdata.IsActiveAnonymousBets = $$('IsActiveAnonymousBets').getValue();
            filterdata.IsActiveAnonymousDocument = $$('IsActiveAnonymousDocument').getValue();
            filterdata.IsActiveAnonymousPhone = $$('IsActiveAnonymousPhone').getValue();
            filterdata.IsActivateSelectBonus = $$('IsActivateSelectBonus').getValue() === 1 ? 'A' : 'I';

            // Loyalty validation switches must be sent as "A/I"
            filterdata.ValidationsCasino = $$('ValidationsCasino').getValue() === 1 ? 'A' : 'I';
            filterdata.ValidationsLiveCasino = $$('ValidationsLiveCasino').getValue() === 1 ? 'A' : 'I';
            filterdata.ValidationsVirtuals = $$('ValidationsVirtuals').getValue() === 1 ? 'A' : 'I';
            filterdata.ValidationsSportbook = $$('ValidationsSportbook').getValue() === 1 ? 'A' : 'I';

            filterdata.EmailWrongLoginAttempts = $$('EmailWrongLoginAttempts').getValue();
            filterdata.InactiveAutomaticRule = $$('InactiveAutomaticRule').getValue() === 1 ? 'A' : 'I';
            filterdata.ValidateCompliance = $$('ValidateCompliance').getValue() === 1 ? 'A' : 'I';
            filterdata.Autentication2FAUsersOnline = $$('Autentication2FAUsersOnline').getValue() === 1 ? 'A' : 'I';
            filterdata.FirstDeposit = $$('FirstDeposit').getValue() === 1 ? 'A' : 'I';
            filterdata.VerifiedMail = $$('VerifiedMail').getValue() === 1 ? 'A' : 'I';
            filterdata.VerifiedPhone = $$('VerifiedPhone').getValue() === 1 ? 'A' : 'I';
            filterdata.IsReferralEmailEnabled = $$('IsReferralEmailEnabled').getValue() === 1 ? 'A' : 'I';
            filterdata.IsActivateDepositTimePDV = $$('IsActivateDepositTimePDV').getValue() === 1 ? 'A' : 'I';
            if (filterdata.IsActivateDepositTimePDV === 'A') {
                const timeForDeposit = String($$('TimeForDepositPDV').getValue() || '').trim();
                filterdata.TimeForDepositPDV = timeForDeposit === '' ? '60' : timeForDeposit;
            }

            let isAnonymousBetsEnabled = filterdata.IsActiveAnonymousBets;
            let isDocEnabled = filterdata.IsActiveAnonymousDocument;
            let isPhoneEnabled = filterdata.IsActiveAnonymousPhone;

            if (isAnonymousBetsEnabled === 1 && isDocEnabled === 0 && isPhoneEnabled === 0) {
                webix.message({
                    type: 'error',
                    text: _('Debe activar al menos una opción: Documento o Celular para apuestas anónimas'),
                });
                return;
            }

            let awardsReferrals = devConfig.getAwardsReferrals(); // Get awards for referrals
            if (awardsReferrals.length > 0) {
                awardsReferrals.map(function (award) {
                    award.AwardName = $$('AwardName' + award.AwardId).getValue(); // Set award name
                    award.IsVerified = $$('IsVerified' + award.AwardId).getValue() === 1; // Set verification status
                    award.Conditions.map(function (condition) {
                        let valor = $$(condition.Condition + award.AwardId).getValue(); // Get condition value
                        condition.Value = valor > 0 ? parseInt(valor) : '0'; // Set condition value
                    });
                    let ofertedBonuses = $$('OfertedBonuses' + award.AwardId).getValue(); // Get offered bonuses
                    if (ofertedBonuses.length > 0) {
                        ofertedBonuses = ofertedBonuses.split(','); // Split bonuses into an array
                    } else {
                        ofertedBonuses = [];
                    }
                    award.OfertedBonuses = ofertedBonuses; // Set offered bonuses
                });
                filterdata.ReferredAwards = awardsReferrals; // Assign awards to filter data
            } else {
                filterdata.ReferredAwards = []; // No awards found
                devConfig.setAwardsReferrals([]); // Reset awards in config
            }

            let conditionsReferrals = devConfig.getConditionsReferrals(); // Get conditions for referrals
            if (conditionsReferrals.length > 0) {
                conditionsReferrals.map(function (condition) {
                    condition.Value = parseInt($$(condition.Condition).getValue()); // Set condition value
                });
                filterdata.ReferentConditions = conditionsReferrals; // Assign conditions to filter data
            }

            filterdata.ReferredMinSelValue = $$('ReferredMinSelValue').getValue(); // Set minimum selection value for referrals
            let validateConditionsReferrals = conditionsReferrals.filter((condition) => {
                return condition.Value > 0; // Validate conditions with value greater than zero
            });

            // Handle excluded categories for minimum bet referred
            if ($$('ExcludedCategoriesMinBetReferred') && $$('ExcludedCategoriesMinBetReferred').getValue() !== null) {
                filterdata.ExcludedCategoriesMinBetReferred = $$('ExcludedCategoriesMinBetReferred')
                    .getValue()
                    .split(','); // Split excluded categories
            }

            filterdata.AcceptReferred = $$('AcceptReferred').getValue();
            filterdata.UrlLanding = $$('UrlLanding').getValue(); // Set landing URL
            filterdata.AwardLimitFulfillmentDayReferred = $$('AwardLimitFulfillmentDayReferred').getValue()
                ? $$('AwardLimitFulfillmentDayReferred').getValue()
                : 0; // Set award limit fulfillment day
            filterdata.AwardLimitRedemptionDayReferent = $$('AwardLimitRedemptionDayReferent').getValue()
                ? $$('AwardLimitRedemptionDayReferent').getValue()
                : 0; // Set award limit redemption day

            let isValid = true; // Validation flag
            if (filterdata.AcceptReferred === 1) {
                // Validate conditions for referred acceptance
                if (filterdata.UrlLanding === '') {
                    webix.message({
                        text: _('Debe agregar una url de landing para activar referidos'),
                        title: _('¡Mensaje!'),
                        type: 'alert-warning',
                    });
                    isValid = false;
                } else if (
                    !filterdata.UrlLanding.startsWith('http://') &&
                    !filterdata.UrlLanding.startsWith('https://')
                ) {
                    webix.message({
                        text: _('La url de landing debe comenzar con http:// o https://'),
                        title: _('¡Mensaje!'),
                        type: 'alert-warning',
                    });
                    isValid = false;
                } else {
                    try {
                        new URL(filterdata.UrlLanding);
                    } catch (e) {
                        webix.message({
                            text: _('Debe agregar una url de landing válida'),
                            title: _('¡Mensaje!'),
                            type: 'alert-warning',
                        });
                        isValid = false;
                    }
                }
                if (filterdata.ReferredMinSelValue === '' || parseFloat(filterdata.ReferredMinSelValue) < 0) {
                    webix.message({
                        text: _(
                            'Debe tener un valor mínimo de cuotas deportivas, mayor o igual a cero para activar referidos',
                        ), // Message for invalid minimum value
                        title: _('¡Mensaje!'),
                        type: 'alert-warning',
                    });
                    isValid = false;
                } else if (awardsReferrals.length === 0) {
                    webix.message({
                        text: _('Debe agregar al menos un premio para activar referidos'), // Message for missing awards
                        title: _('¡Mensaje!'),
                        type: 'alert-warning',
                    });
                    isValid = false;
                } else {
                    awardsReferrals.map(function (award) {
                        if (award.AwardName === '') {
                            webix.message({
                                text: _('Los nombres de los premios no pueden estar vacios para activar referidos'), // Message for empty award names
                                title: _('¡Mensaje!'),
                                type: 'alert-warning',
                            });
                            isValid = false;
                        } else {
                            let awardConditions = award.Conditions.filter(
                                (condition) => condition.Value !== '' && condition.Value > 0,
                            ); // Filter award conditions
                            if (awardConditions.length === 0 && !award.IsVerified) {
                                webix.message({
                                    text: _(
                                        'Debe tener al menos una condición con valor mayor a cero o requerir verificacion en los premios para activar referidos',
                                    ), // Message for invalid award conditions
                                    title: _('¡Mensaje!'),
                                    type: 'alert-warning',
                                });
                                isValid = false;
                            } else if (award.OfertedBonuses.length === 0) {
                                webix.message({
                                    text: _('Debe agregar al menos un bono en los premios para activar referidos'), // Message for missing bonuses
                                    title: _('¡Mensaje!'),
                                    type: 'alert-warning',
                                });
                                isValid = false;
                            }
                        }
                    });
                }
            } else {
                // Remove awards with empty names if referred acceptance is not active
                filterdata.ReferredAwards.map(function (award) {
                    if (award.AwardName === '') {
                        filterdata.ReferredAwards = filterdata.ReferredAwards.filter(function (item) {
                            return item.AwardId !== award.AwardId; // Filter out invalid awards
                        });
                    }
                });
            }

            // Set user online statuses for various betting types
            filterdata.SportsBetsUserOnline = $$('SportsBetsUserOnline').getValue() === 1 ? 'A' : 'I';
            filterdata.CasinoBetsUserOnline = $$('CasinoBetsUserOnline').getValue() === 1 ? 'A' : 'I';
            filterdata.LiveCasinoUserOnline = $$('LiveCasinoUserOnline').getValue() === 1 ? 'A' : 'I';
            filterdata.VirtualBetsUserOnline = $$('VirtualBetsUserOnline').getValue() === 1 ? 'A' : 'I';
            filterdata.PokerUserOnline = $$('PokerUserOnline').getValue() === 1 ? 'A' : 'I';
            filterdata.RetirementNotesUserOnline = $$('RetirementNotesUserOnline').getValue() === 1 ? 'A' : 'I';
            filterdata.DepositUserOnline = $$('DepositUserOnline').getValue() === 1 ? 'A' : 'I';
            filterdata.HipicaUserOnline = $$('HipicaUserOnline').getValue() === 1 ? 'A' : 'I';
            filterdata.SportsBetsPv = $$('SportsBetsPv').getValue() === 1 ? 'A' : 'I';
            filterdata.PayRetirementNotesPv = $$('PayRetirementNotesPv').getValue() === 1 ? 'A' : 'I';
            filterdata.PayDepositPv = $$('PayDepositPv').getValue() === 1 ? 'A' : 'I';
            filterdata.PayAwardsPv = $$('PayAwardsPv').getValue() === 1 ? 'A' : 'I';
            filterdata.VirtualBetsPv = $$('VirtualBetsPv').getValue() === 1 ? 'A' : 'I';
            filterdata.SportsBetsAtm = $$('SportsBetsAtm').getValue() === 1 ? 'A' : 'I';
            filterdata.PayRetirementNotesAtm = $$('PayRetirementNotesAtm').getValue() === 1 ? 'A' : 'I';
            filterdata.PayDepositAtm = $$('PayDepositAtm').getValue() === 1 ? 'A' : 'I';
            filterdata.PayAwardsAtm = $$('PayAwardsAtm').getValue() === 1 ? 'A' : 'I';
            filterdata.VirtualBetsAtm = $$('VirtualBetsAtm').getValue() === 1 ? 'A' : 'I';
            filterdata.DepositPhoneVerification = $$('DepositPhoneVerification').getValue() === 1 ? 'A' : 'I';
            filterdata.SportBetsPhoneVerification = $$('SportBetsPhoneVerification').getValue() === 1 ? 'A' : 'I';
            filterdata.CasinoBetsPhoneVerification = $$('CasinoBetsPhoneVerification').getValue() === 1 ? 'A' : 'I';
            filterdata.WithdrawalPhoneVerification = $$('WithdrawalPhoneVerification').getValue() === 1 ? 'A' : 'I';
            filterdata.LiveCasinoPhoneVerification = $$('LiveCasinoPhoneVerification').getValue() === 1 ? 'A' : 'I';
            filterdata.VirtualPhoneVerification = $$('VirtualPhoneVerification').getValue() === 1 ? 'A' : 'I';
            filterdata.VerificationMincetur = $$('VerificationMincetur').getValue() === 1 ? 'A' : 'I';  // Mincetur verification
            filterdata.IsActiveMultiCountryLogin = $$('IsActiveMultiCountryLogin').getValue() === 1 ? 'A' : 'I';  // Mincetur verification

            // Validate selected bonuses for FreeBet and FreeCasino
            let selectedId = $$('LandingFreeBetBonuses').getValue().split(',');
            if (selectedId.length > 1) {
                isValid = false;
                webix.message({
                    text: _('Solo puede seleccionar maximo un bono para el FreeBet'), // Message for too many selected bonuses
                    title: _('¡Mensaje!'),
                    type: 'alert-warning',
                });
            } else if (selectedId.length === 1) {
                filterdata.LandingFreeBetBonusesSelected = selectedId.toString(); // Set selected FreeBet bonus
                let selectedId2 = $$('LandingFreeCasinoBonuses').getValue().split(',');
                if (selectedId2.length > 1) {
                    isValid = false;
                    webix.message({
                        text: _('Solo puede seleccionar maximo un bono para el FreeCasino'), // Message for too many selected bonuses
                        title: _('¡Mensaje!'),
                        type: 'alert-warning',
                    });
                } else if (selectedId2.length === 1) {
                    filterdata.LandingFreeCasinoBonusesSelected = selectedId2.toString(); // Set selected FreeCasino bonus
                }
            }

            let selectedBirthdayBonus = $$('TotalityBirthday').getValue().split(',');
            if (selectedBirthdayBonus.length > 1) {
                isValid = false;
                webix.message({
                    text: _('Solo puede seleccionar un bono de cumpleaños'),
                    title: _('¡Mensaje!'),
                    type: 'alert-warning',
                });
            } else if (selectedBirthdayBonus.length === 1 && selectedBirthdayBonus[0] !== '') {
                filterdata.TotalityBonusesBirthdaySelected = selectedBirthdayBonus.toString();
                filterdata.IsFor = 'BirthdayBonus';
            } else {
                filterdata.TotalityBonusesBirthdaySelected = '';
            }

            /**
             * Handles filter data based on field value.
             * @param {string} field - The field to check.
             * @param {string} valueField - The corresponding value field.
             */
            function handleFilterData(field, valueField) {
                if ($$(field).getValue() === 1) {
                    filterdata[field] = 'A'; // Set active
                    filterdata[valueField] = $$(valueField).getValue(); // Set value
                } else {
                    filterdata[field] = 'I'; // Set inactive
                    filterdata[valueField] ? delete filterdata[valueField] : null; // Remove value if inactive
                }
            }

            // Handle various filter data fields
            handleFilterData('IsSportbookGgrPvIpConcessionaire', 'SportbookGgrPvIpConcessionaire');
            handleFilterData('IsDepositPvConcessionaire', 'DepositPvConcessionaire');
            handleFilterData('IsWithdrawalsNotesPvConcessionaire', 'WithdrawalsNotesPvConcessionaire');
            handleFilterData('IsSportbookGgrAfConcessionaire', 'SportbookGgrAfConcessionaire');
            handleFilterData('IsSportbookNgrAfConcessionaire', 'SportbookNgrAfConcessionaire');
            handleFilterData('IsSportbookGgrPvConcessionaire', 'SportbookGgrPvConcessionaire');
            handleFilterData('IsBetSportPvConcessionaire', 'BetSportPvConcessionaire');
            handleFilterData('IsCasinoNgrAfConcessionaire', 'CasinoNgrAfConcessionaire');
            handleFilterData(
                'IsDepositCommissionTransactionConcessionaire',
                'DepositCommissionTransactionConcessionaire',
            );
            handleFilterData('IsDepositAfConcessionaire', 'DepositAfConcessionaire');
            handleFilterData('IsSportbookGgrPvIpSubdealer', 'SportbookGgrPvIpSubdealer');
            handleFilterData('IsDepositPvSubdealer', 'DepositPvSubdealer');
            handleFilterData('IsWithdrawalsNotesPvSubdealer', 'WithdrawalsNotesPvSubdealer');
            handleFilterData('IsSportbookGgrAfSubdealer', 'SportbookGgrAfSubdealer');
            handleFilterData('IsSportbookNgrAfSubdealer', 'SportbookNgrAfSubdealer');
            handleFilterData('IsSportbookGgrPvSubdealer', 'SportbookGgrPvSubdealer');
            handleFilterData('IsBetSportPvSubdealer', 'BetSportPvSubdealer');
            handleFilterData('IsCasinoNgrAfSubdealer', 'CasinoNgrAfSubdealer');
            handleFilterData('IsDepositCommissionTransactionSubdealer', 'DepositCommissionTransactionSubdealer');
            handleFilterData('IsDepositAfSubdealer', 'DepositAfSubdealer');
            handleFilterData('IsSportbookGgrPvIpPointSale', 'SportbookGgrPvIpPointSale');
            handleFilterData('IsDepositPvPointSale', 'DepositPvPointSale');
            handleFilterData('IsWithdrawalsNotesPvPointSale', 'WithdrawalsNotesPvPointSale');
            handleFilterData('IsSportbookGgrAfPointSale', 'SportbookGgrAfPointSale');
            handleFilterData('IsSportbookNgrAfPointSale', 'SportbookNgrAfPointSale');
            handleFilterData('IsSportbookGgrPvPointSale', 'SportbookGgrPvPointSale');
            handleFilterData('IsBetSportPvPointSale', 'BetSportPvPointSale');
            handleFilterData('IsCasinoNgrAfPointSale', 'CasinoNgrAfPointSale');
            handleFilterData('IsDepositCommissionTransactionPointSale', 'DepositCommissionTransactionPointSale');
            handleFilterData('IsDepositAfPointSale', 'DepositAfPointSale');
            handleFilterData('IsSportbookGgrPvIpAffiliate', 'SportbookGgrPvIpAffiliate');
            handleFilterData('IsDepositPvAffiliate', 'DepositPvAffiliate');
            handleFilterData('IsWithdrawalsNotesPvAffiliate', 'WithdrawalsNotesPvAffiliate');
            handleFilterData('IsSportbookGgrAfAffiliate', 'SportbookGgrAfAffiliate');
            handleFilterData('IsSportbookNgrAfAffiliate', 'SportbookNgrAfAffiliate');
            handleFilterData('IsSportbookGgrPvAffiliate', 'SportbookGgrPvAffiliate');
            handleFilterData('IsBetSportPvAffiliate', 'BetSportPvAffiliate');
            handleFilterData('IsCasinoNgrAfAffiliate', 'CasinoNgrAfAffiliate');
            handleFilterData('IsDepositCommissionTransactionAffiliate', 'DepositCommissionTransactionAffiliate');
            handleFilterData('IsDepositAfAffiliate', 'DepositAfAffiliate');

            // Handle OTP notes activation for point of sale and bank account
            if ($$('IsActivateOtpNotesPuntoDeVenta').getValue() === 1) {
                filterdata.IsActivateOtpNotesPuntoDeVenta = 'A'; // Activate OTP notes for point of sale
                if ($$('OtpNotesTime').getValue() === '' || $$('OtpNotesTime').getValue() <= 0) {
                    isValid = false;
                    webix.message({
                        text: _('Debe agregar un tiempo en milisegundos mayor a 0 para activar las notas OTP'), // Message for invalid OTP time
                        title: _('¡Mensaje!'),
                        type: 'alert-warning',
                    });
                } else {
                    filterdata.OtpNotesTime = $$('OtpNotesTime').getValue(); // Set OTP time
                }
                if ($$('IsActivateOtpNotesEmailPV').getValue() === 1) {
                    filterdata.IsActivateOtpNotesEmailPV = 'A'; // Activate email OTP notes
                } else {
                    filterdata.IsActivateOtpNotesEmailPV = 'I'; // Deactivate email OTP notes
                }
                if ($$('IsActivateOtpNotesSmsPV').getValue() === 1) {
                    filterdata.IsActivateOtpNotesSmsPV = 'A'; // Activate SMS OTP notes
                } else {
                    filterdata.IsActivateOtpNotesSmsPV = 'I'; // Deactivate SMS OTP notes
                }
            } else {
                filterdata.IsActivateOtpNotesPuntoDeVenta = 'I'; // Activate OTP notes for point of sale
            }

            if ($$('IsActivateOtpNotesCuentaBancaria').getValue() === 1) {
                filterdata.IsActivateOtpNotesCuentaBancaria = 'A'; // Activate OTP notes for bank account
                if ($$('OtpNotesTime').getValue() === '' || $$('OtpNotesTime').getValue() <= 0) {
                    isValid = false;
                    webix.message({
                        text: _('Debe agregar un tiempo en milisegundos mayor a 0 para activar las notas OTP'), // Message for invalid OTP time
                        title: _('¡Mensaje!'),
                        type: 'alert-warning',
                    });
                } else {
                    filterdata.OtpNotesTime = $$('OtpNotesTime').getValue(); // Set OTP time
                }
                if ($$('IsActivateOtpNotesEmailCB').getValue() === 1) {
                    filterdata.IsActivateOtpNotesEmailCB = 'A'; // Activate email OTP notes for bank account
                } else {
                    filterdata.IsActivateOtpNotesEmailCB = 'I'; // Deactivate email OTP notes for bank account
                }
                if ($$('IsActivateOtpNotesSmsCB').getValue() === 1) {
                    filterdata.IsActivateOtpNotesSmsCB = 'A'; // Activate SMS OTP notes for bank account
                } else {
                    filterdata.IsActivateOtpNotesSmsCB = 'I'; // Deactivate SMS OTP notes for bank account
                }
            } else {
                filterdata.IsActivateOtpNotesCuentaBancaria = 'I'; // Activate OTP notes for bank account
            }

            if (isValid) {
                savePartnerSettings(filterdata); // Save the partner settings if valid
                isValid = false; // Reset validation flag
            }
        });
    }
}

// FILE DOCUMENTED
